import { extendGettingStartedTranslations } from "../../content/gettingStarted";
const messages = {
  es: {
    translations: {
      common: {
        close: "Cerrar",
      },
      gettingStarted: {
        hello: "Te damos la bienvenida, {{name}}",
        title: "Primeros pasos",
        subtitle: "Completa lo básico para empezar a atender.",
        next: "Siguiente:",
        completed: "{{done}} / {{total}} completados",
        allDone: "Listo: ya completaste la configuración inicial.",
        steps: {
          connection: {
            title: "Crear tu primera conexión",
            desc: "Conecta un canal para empezar a recibir chats.",
            time: "2 min",
          },
          greeting: {
            title: "Personalizar el mensaje de saludo",
            desc: "Define el primer mensaje que reciben tus clientes.",
            time: "1 min",
          },
          queue: {
            title: "Crear un departamento",
            desc: "Crea departamentos para organizar tu atención.",
            time: "1 min",
          },
          invite: {
            title: "Invitar personas",
            desc: "Invita usuarios y administradores a tu empresa.",
            time: "1 min",
          },
          assignment: {
            title: "Definir asignación automática",
            desc: "Asocia departamentos a tu conexión WhatsApp.",
            time: "30s",
          },
        },
        extrasTitle: "Libera el potencial de tu operación",
        extrasSubtitle: "Otras herramientas para que tu equipo atienda mejor.",
        extras: {
          new: "Nuevo",
          quick: {
            title: "Respuestas rápidas",
            desc: "Mensajes listos, activados con \"/\" en el chat.",
          },
          tags: {
            title: "Etiquetas",
            desc: "Organiza contactos y motivos de atención.",
          },
          kanban: {
            title: "Kanban",
            desc: "Visualiza el embudo de atención por columnas.",
          },
          ai: {
            title: "Agentes IA",
            desc: "Tu base de conocimiento se convierte en atención automática.",
          },
          campaigns: {
            title: "Campañas",
            desc: "Envía mensajes masivos a listas de contactos.",
          },
          schedules: {
            title: "Mensajes programados",
            desc: "Agenda envíos individuales para más tarde.",
          },
          chat: {
            title: "Chat interno",
            desc: "Coordina al equipo sin salir de Watoolx.",
          },
          agenda: {
            title: "Agenda",
            desc: "Citas, recordatorios y seguimiento de clientes.",
          },
          roles: {
            title: "Equipo y tipos de usuario",
            desc: "Invita agentes y supervisores. El admin configura el negocio; cada agente atiende sus departamentos.",
          },
          csat: {
            title: "CSAT",
            desc: "Mide la satisfacción después de cada atención.",
          },
        },
      },
      signup: {
        title: "Registrarse",
        toasts: {
          success: "¡Usuario creado exitosamente! ¡Inicie sesión!",
          fail: "Error al crear usuario. Verifique los datos ingresados.",
        },
        form: {
          name: "Nombre",
          email: "Correo electrónico",
          password: "Contraseña",
        },
        buttons: {
          submit: "Registrarse",
          login: "¿Ya tienes una cuenta? ¡Inicia sesión!",
        },
      },
      login: {
        title: "Iniciar sesión",
        form: {
          email: "Correo electrónico",
          password: "Contraseña",
        },
        buttons: {
          submit: "Iniciar sesión",
          register: " ¡Crea tu cuenta en solo unos clics!",
        },
        forgotPassword: "¿Olvidó su contraseña?",
      },
      plans: {
        title: "Planes",
        registerButton: "Registrar Plan",
        form: {
          name: "Nombre",
          users: "Usuarios",
          connections: "Conexiones",
          queues: "Colas",
          value: "Valor",
          campaigns: "Mensajes masivos",
          groupCampaigns: "Campañas a grupos",
          statusCampaigns: "Estados WhatsApp",
          negocio: "Módulo Negocio",
          schedules: "Programaciones",
          internalChat: "Chat Interno",
          externalApi: "API Externa",
          kanban: "Kanban",
          openAi: "Agente IA",
          integrations: "Integraciones",
          internalUse: "Visible en registro público",
          internalPlan: "En registro",
          enabled: "Habilitadas",
          disabled: "Deshabilitadas",
          clear: "Cancelar",
          delete: "Eliminar",
          save: "Guardar",
          yes: "Sí",
          no: "No",
          money: "$",
        },
        messages: {
          loadError: "No se pudo cargar la lista de registros",
          saveSuccess: "¡Operación realizada con éxito!",
          saveError:
            "No se pudo realizar la operación. Verifique si ya existe un plan con el mismo nombre o si los campos fueron completados correctamente",
          deleteSuccess: "¡Operación realizada con éxito!",
          deleteError: "No se pudo realizar la operación",
          deleteTitle: "Eliminación de Registro",
          deleteMessage: "¿Desea realmente eliminar este registro?",
        },
      },
      companies: {
        title: "Registrar Empresa",
        form: {
          name: "Nombre de Empresa",
          email: "Correo electrónico",
          phone: "Número de WhatsApp",
          plan: "Planes",
          status: "Estado",
          campaigns: "Campañas",
          dueDate: "Fecha de Vencimiento",
          recurrence: "Recurrencia",
          token: "Token",
          submit: "Registrar",
          success: "¡Empresa creada exitosamente!",
        },
        table: {
          name: "Nombre",
          email: "Correo electrónico",
          phone: "Teléfono",
          plan: "Planes",
          campaigns: "Campañas",
          status: "Estado",
          createdAt: "Creada En",
          dueDate: "Vencimiento",
        },
        messages: {
          loadError: "No se pudo cargar la lista de registros",
          saveSuccess: "¡Operación realizada con éxito!",
          saveError:
            "No se pudo realizar la operación. Verifique si ya existe una empresa con el mismo nombre o si los campos fueron completados correctamente",
          deleteSuccess: "¡Operación realizada con éxito!",
          deleteError: "No se pudo realizar la operación",
          deleteTitle: "Eliminación de Registro",
          deleteMessage: "¿Desea realmente eliminar este registro?",
          registerRefreshPage: "Empresa registrada. Actualiza la página para ver los cambios.",
        },
        formTitle: {
          edit: "Editar Empresa",
          registerNew: "Registrar Nueva Empresa",
        },
        sections: {
          basicInfo: "Información Básica",
          configuration: "Configuración",
        },
        loadingPlans: "Cargando planes...",
        timezone: {
          label: "Zona Horaria",
          loading: "Cargando timezones...",
          loadingValue: "{{tz}} (cargando...)",
          fallbackCurrent: "{{tz}} (actual)",
          hint: "Zona horaria para visualización de fechas/horas en mensajes y tickets",
          ariaLabel: "Zona Horaria",
        },
        grid: {
          emptyTitle: "No hay empresas registradas",
          emptySubtitle: "Comienza registrando tu primera empresa",
        },
        tooltips: {
          editCompany: "Editar empresa",
        },
        buttons: {
          clear: "Limpiar",
          delete: "Eliminar",
          save: "Guardar",
          addDueDate: "+ Vencimiento",
          user: "Usuario",
          registerCompany: "Registrar Empresa",
          saving: "Guardando...",
        },
        register: {
          formTitle: "Registrar Nueva Empresa",
          companyInfoSection: "Información de la Empresa",
          successTitle: "¡Empresa Registrada Exitosamente!",
          loadPlansError: "Error al cargar los planes disponibles",
          closingForm_one: "Cerrando el formulario en {{count}} segundo...",
          closingForm_other: "Cerrando el formulario en {{count}} segundos...",
          redirecting_one: "Redirigiendo a la pestaña de Empresas en {{count}} segundo...",
          redirecting_other: "Redirigiendo a la pestaña de Empresas en {{count}} segundos...",
          validation: {
            nameMin: "Nombre muy corto",
            nameMax: "Nombre muy largo",
            nameRequired: "Nombre requerido",
            passwordMin: "Contraseña muy corta",
            passwordMax: "Contraseña muy larga",
            passwordRequired: "Contraseña requerida",
            emailInvalid: "Email inválido",
            emailRequired: "Email requerido",
            phoneMin: "Número de teléfono muy corto",
            phoneRequired: "Número de WhatsApp requerido",
            planRequired: "Plan requerido",
          },
          buttons: {
            cancel: "Cancelar",
            back: "Volver",
            registering: "Registrando...",
            registered: "¡Registrado!",
          },
        },
        values: {
          yes: "Sí",
          no: "No",
          enabled: "Habilitadas",
          disabled: "Deshabilitadas",
          monthly: "Mensual",
          bimonthly: "Bimestral",
          quarterly: "Trimestral",
          semiannual: "Semestral",
          annual: "Anual",
        },
      },
      auth: {
        toasts: {
          success: "¡Inicio de sesión exitoso!",
        },
        token: "Token",
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Atenciones de hoy: ",
          },
        },
        filters: {
          filterType: "Tipo de filtro",
          dateFilter: "Filtro de fecha",
          periodFilter: "Filtro por período",
          selectPeriod: "Seleccionar período",
          initialDate: "Fecha inicial",
          finalDate: "Fecha final",
          start: "Inicio",
          end: "Fin",
          filter: "FILTRAR",
          period: "Período",
          noSelection: "Sin selección",
          last3Days: "Últimos 3 días",
          last7Days: "Últimos 7 días",
          last15Days: "Últimos 15 días",
          last30Days: "Últimos 30 días",
          last60Days: "Últimos 60 días",
          last90Days: "Últimos 90 días",
        },
        cards: {
          activeConnections: "Conexiones Activas",
          companies: "Empresas",
          inConversati: "En Conversación",
          inConversation: "En Conversación",
          waiting: "En Espera",
          finished: "Finalizadas",
          newContacts: "Nuevos Contactos",
          avgConversationTime: "Tiempo Promedio de Conversación",
          avgWaitTime: "Tiempo Promedio de Espera",
          totalConversationsByUsers: "Total de Conversaciones por Usuarios",
          totalAttendances: "Total de Atendimientos",
        },
        errors: {
          errorGettingConversationInfo: "Error al obtener información de conversaciones",
          parameterizeFilter: "Por favor, configure los filtros antes de buscar",
          invalidDateRange: "La fecha inicial no puede ser posterior a la fecha final",
          loadData: "Error al cargar datos del dashboard",
        },
        table: {
          name: "Nombre",
          assessments: "Evaluaciones",
          avgServiceTime: "T.M. de Atención",
          status: "Estado (Actual)",
        },
      },
      connections: {
        title: "Conexiones",
        toasts: {
          deleted: "¡Conexión con WhatsApp eliminada exitosamente!",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "¿Estás seguro? Esta acción no se puede deshacer.",
          disconnectTitle: "Desconectar",
          disconnectMessage: "¿Estás seguro? Deberás volver a leer el código QR.",
        },
        buttons: {
          add: "Agregar WhatsApp",
          disconnect: "desconectar",
          tryAgain: "Intentar de nuevo",
          qrcode: "CÓDIGO QR",
          newQr: "Nuevo CÓDIGO QR",
          connecting: "Conectando",
          restart: "Reiniciar conexiones",
        },
        toolTips: {
          disconnected: {
            title: "Error al iniciar sesión en WhatsApp",
            content:
              "Asegúrate de que tu teléfono esté conectado a internet e inténtalo nuevamente, o solicita un nuevo código QR",
          },
          qrcode: {
            title: "Esperando lectura del código QR",
            content:
              "Haz clic en el botón 'CÓDIGO QR' y lee el código QR con tu teléfono para iniciar sesión",
          },
          connected: {
            title: "¡Conexión establecida!",
          },
          timeout: {
            title: "Se perdió la conexión con el teléfono",
            content:
              "Asegúrate de que tu teléfono esté conectado a internet y WhatsApp esté abierto, o haz clic en el botón 'Desconectar' para obtener un nuevo código QR",
          },
        },
        table: {
          name: "Nombre",
          number: "Número",
          token: "Token",
          tokenEmpty: "Sin token (edite la conexión para generar uno)",
          aliasWa: "Alias WA",
          waName: "Nombre WA",
          status: "Estado",
          lastUpdate: "Última actualización",
          default: "Predeterminado",
          actions: "Acciones",
          session: "Sesión",
        },
        whatsappModal: {
          title: {
            add: "Agregar WhatsApp",
            edit: "Editar WhatsApp",
          },
          tabs: {
            general: "General",
            messages: "Mensajes",
            assessments: "Evaluaciones",
            integrations: "Integraciones",
            schedules: "Horario de expediente",
          },
          form: {
            name: "Nombre",
            default: "Predeterminado",
            sendIdQueue: "Fila",
            timeSendQueue: "Redireccionar a cola en X minutos",
            queueRedirection: "Redirección de cola",
            outOfHoursMessage: "Mensaje de fuera de expediente",
            queueRedirectionDesc:
              "Seleccione una fila para redirigir los contactos que no tienen fila",
            prompt: "Prompt",
            expiresTicket: "Cerrar chats abiertos después de X minutos",
            expiresInactiveMessage: "Mensaje de cierre por inactividad",
            greetingMessage: "Mensaje de saludo",
            complationMessage: "Mensaje de conclusión",
            timeToTransfer: "Transferir después de X (minutos)",
            transferQueue: "Cola de transferencia",
          },
          buttons: {
            okAdd: "Agregar",
            okEdit: "Guardar",
            cancel: "Cancelar",
          },
          success: "WhatsApp guardado con éxito.",
        },
      },
      qrCode: {
        message: "Escanea el código QR",
        waiting: "Generando código QR...",
      },
      whatsappModal: {
        title: {
          add: "Agregar WhatsApp",
          edit: "Editar WhatsApp",
        },
        tabs: {
          general: "General",
          messages: "Mensajes",
          assessments: "Evaluaciones",
          integrations: "Integraciones",
          schedules: "Horario de expediente",
        },
        form: {
          name: "Nombre",
          default: "Predeterminado",
          sendIdQueue: "Fila",
          timeSendQueue: "Redireccionar a cola en X minutos",
          queueRedirection: "Redirección de cola",
          outOfHoursMessage: "Mensaje de fuera de expediente",
          queueRedirectionDesc:
            "Seleccione una fila para redirigir los contactos que no tienen fila",
          prompt: "Prompt",
          expiresTicket: "Cerrar chats abiertos después de X minutos",
          expiresInactiveMessage: "Mensaje de cierre por inactividad",
          greetingMessage: "Mensaje de saludo",
          complationMessage: "Mensaje de conclusión",
          timeToTransfer: "Transferir después de X (minutos)",
          transferQueue: "Cola de transferencia",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "WhatsApp guardado con éxito.",
      },
      contacts: {
        title: "Contactos",
        toasts: {
          deleted: "Contacto eliminado con éxito!",
          deletedAll: "Todos los contactos eliminados con éxito!",
          exported: "Contactos exportados con éxito!",
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Eliminar ",
          deleteAllTitle: "Eliminar Todos",
          importTitle: "Importar agenda de contactos telefónico",
          exportTitle: "Exportar contactos",
          deleteMessage:
            "¿Seguro que desea eliminar este contacto? Se perderán todos los tickets relacionados.",
          deleteAllMessage:
            "¿Seguro que desea eliminar todos los contactos? Se perderán todos los tickets relacionados.",
          exportMessage: "¿Está seguro que desea exportar los contactos seleccionados?",
          exportAllMessage: "¿Está seguro que desea exportar todos los contactos?",
          importMessage: "¿Desea importar todos los contactos del teléfono?",
          importAgendaMessage: "Existen {count} contactos en su agenda ¿Desea importarlos?",
          titleExportAll: "Exportar todos los contactos",
          titleExportOne: "Exportar 1 contacto",
          titleExportMany: "Exportar {{count}} contactos",
          titleDeleteOne: "Eliminar 1 contacto",
          titleDeleteMany: "Eliminar {{count}} contactos",
          exportConfirmAll: "¿Está seguro que desea exportar todos los contactos?",
          exportConfirmMany: "¿Está seguro que desea exportar {{count}} contacto(s)?",
          deleteSelectedMany:
            "¿Seguro que desea eliminar {{count}} contacto(s)? Se perderán todos los tickets relacionados.",
        },
        tooltips: {
          importAgendaDisabled:
            "Esta funcionalidad está temporalmente deshabilitada. Baileys 6.7.21 no soporta la obtención directa de contactos. Se habilitará nuevamente cuando haya una versión compatible de Baileys.",
        },
        buttons: {
          import: "IMPORTAR AGENDA",
          importSheet: "Importar",
          add: "Agregar",
          export: "Exportar",
          delete: "BORRAR",
          deleteAll: "Eliminar Todos Contactos",
          downloadTemplate: "Descargar Plantilla",
        },
        table: {
          profile: "Perfil",
          name: "Nombre",
          whatsapp: "WhatsApp",
          email: "Correo electrónico",
          lastInteraction: "Última Interacción",
          status: "Estado",
          actions: "Acciones",
        },
        pagination: {
          rowsPerPage: "Registros por página:",
          displayedRows: "{{from}}-{{to}} de {{count}}",
        },
        badge: {
          contact: "contacto",
          contacts: "contactos",
        },
        messages: {
          selectToExport: "Para exportar contactos necesitas seleccionar al menos 1 contacto",
          processingExport: "Procesando {count} contactos... Esto puede tomar unos segundos.",
          exportSuccess: "Contactos exportados exitosamente",
          exportError: "Error al exportar los contactos. Intente nuevamente.",
          checkingAgenda: "Verificando agenda de contactos...",
          importingContacts: "Importando {count} contactos... Esto puede tomar varios minutos.",
          importSuccess: "Contactos importados exitosamente",
          importError: "Error al importar los contactos. Intente nuevamente.",
          agendaEmpty: "No se encontraron contactos en la agenda del teléfono.",
          agendaUnavailable:
            "No se pudo leer la agenda. Verifica que la conexión WhatsApp esté online.",
          importInvalidResponse: "Respuesta inválida del servidor",
          importErrorGeneric: "Error al importar contactos",
          templateDownloadSuccess: "Plantilla descargada correctamente",
          templateDownloadError: "Error al descargar la plantilla",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Agregar proyecto",
          edit: "Editar proyecto",
        },
        form: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Lenguaje",
          jsonContent: "JsonContent",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tiempo en minutos para expirar una conversación",
          typebotKeywordFinish: "Palabra para finalizar el ticket",
          typebotKeywordRestart: "Palabra para reiniciar el flujo",
          typebotRestartMessage: "Mensaje al reiniciar la conversación",
          typebotUnknownMessage: "Mensaje de opción inválida",
          typebotDelayMessage: "Intervalo (ms) entre mensajes",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          test: "Probar Bot",
        },
        messages: {
          testSuccess: "Integración probada con éxito!",
          addSuccess: "Integración agregada con éxito.",
          editSuccess: "Integración editada con éxito.",
        },
      },
      sideMenu: {
        name: "Menú Lateral Inicial",
        note: "Si está habilitado, el menú lateral se iniciará cerrado",
        options: {
          enabled: "Abierto",
          disabled: "Cerrado",
        },
      },
      promptModal: {
        form: {
          name: "Nombre",
          prompt: "Prompt",
          voice: "Voz",
          max_tokens: "Máximo de Tokens en la respuesta",
          temperature: "Temperatura",
          apikey: "API Key",
          max_messages: "Máximo de mensajes en el Historial",
          voiceKey: "Clave de la API de Voz",
          voiceRegion: "Región de Voz",
        },
        success: "Prompt guardado con éxito!",
        title: {
          add: "Agregar Prompt",
          edit: "Editar Prompt",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          cancelUpper: "CANCELAR",
          expand: "AMPLIAR",
          saveChanges: "Guardar cambios",
        },
        sections: {
          provider: "Configuración de proveedor de IA",
          api: "Configuración de API",
          basic: "Información básica",
          advanced: "Configuración avanzada",
          media: "Archivos multimedia",
          workMode: "Modo de trabajo",
        },
        providerInfo: {
          title: "Configuración de proveedor de IA",
          body1:
            "Selecciona el proveedor de inteligencia artificial que utilizará este prompt. Cada proveedor ofrece distintos modelos y capacidades según tus necesidades.",
          body2:
            "Proveedores disponibles: OpenAI oficial, Google Gemini (AI Studio), Anthropic Claude, DeepSeek, Kimi y OpenRouter. Cada opción requiere la API key de ese proveedor (OpenRouter usa sk-or-v1-…).",
        },
        mustValidateBeforeSave:
          "Debes validar la API Key y el proveedor antes de guardar. Usa el botón «Probar conexión».",
        mustValidateBeforeSaveWithStored:
          "Si cambiaste de proveedor o pegaste nueva clave, valida con «Probar conexión». Para solo editar texto u opciones, deja vacía la clave y mantén el mismo proveedor.",
        validation: {
          nameRequired: "El nombre es obligatorio",
          apiKeyRequired: "La API Key es obligatoria",
          promptRequired: "El prompt es obligatorio",
          maxTokensRequired: "Los tokens máximos son obligatorios",
          temperatureRequired: "La temperatura es obligatoria",
          maxMessagesRequired: "Los mensajes máximos son obligatorios",
        },
        fields: {
          aiProvider: "Proveedor de IA",
          promptName: "Nombre del prompt",
          promptNameHelper: "Ej.: Bot de soporte, asistente de ventas…",
          promptNamePlaceholder: "Ej.: Bot de soporte",
          mainPrompt: "Prompt principal",
          mainPromptHelper: "Define cómo debe comportarse la IA. Sé específico y claro.",
          mainPromptPlaceholder:
            "Eres un asistente de soporte técnico. Responde de manera profesional y útil…",
          charCount: "Cantidad de caracteres: {{count}}",
          temperature: "Temperatura",
          temperatureHelper: "0.0 = determinístico, 2.0 = muy creativo",
          maxTokens: "Máximo tokens",
          maxTokensHelper: "Límite de tokens en la respuesta",
          maxMessages: "Máximo mensajes",
          maxMessagesHelper: "Mensajes en el historial",
          queueOptional: "Departamentos (opcional)",
          noQueue: "Sin departamento",
          workModeLabel: "Modo de trabajo",
          workModeLayers: "Capas contextuales",
          workModePdfs: "Documentos PDF",
          workModeHintLayers: "Usa capas contextuales activadas por palabras clave",
          workModeHintPdfs: "Sube documentos PDF para que la IA aprenda de ellos",
        },
        apiTest: {
          validating: "Validando…",
          validated: "✅ Validado",
          validatedHelper: "✅ API Key validada correctamente",
          storedKeyMaskPlaceholder:
            "Pegue aquí solo si quiere cambiar la clave (al abrir editar ya se muestra la guardada).",
          storedKeyHelper:
            "Al editar este prompt verás la API Key cargada desde el servidor. Déjela tal cual para conservarla o sustituya el texto por una nueva clave. Use «Probar conexión» para validar.",
          testConnection: "Probar conexión",
          enterApiKeyFirst: "Por favor ingresa una API Key primero",
          selectProviderFirst: "Por favor selecciona un proveedor primero",
          keyTooShortToast: "La API Key parece ser muy corta. Verifica que sea correcta.",
          keyTooShort: "API Key muy corta",
          connectionSuccess: "Conexión exitosa",
          validationFailed: "Error de validación",
          validateError: "Error validando API",
          unknownError: "Error desconocido",
        },
        media: {
          savePromptFirst: "Primero debes guardar el prompt",
          savePromptFirstToast: "Primero debes guardar el prompt",
          unknownFileType: "Error: tipo de archivo no reconocido",
          noFilesSelected: "No se seleccionaron archivos",
          unexpectedError: "Error inesperado: {{message}}",
          fileDeleted: "Archivo eliminado correctamente",
          deleteFileError: "Error al eliminar archivo: {{message}}",
          maxSixFiles: "Máximo 6 archivos por prompt",
          urlAdded: "URL externa agregada correctamente",
          urlAddError: "Error al agregar URL: {{message}}",
          addUrl: "Agregar URL",
          uploadFile: "Subir archivo",
          hintFiles:
            "📎 Puedes agregar hasta 6 archivos multimedia (imágenes, videos, audios, documentos)",
          hintLimits: "📏 Límites: imágenes/audios 10 MB, videos/documentos 15 MB",
          hintSyntax:
            "💡 Usa la sintaxis [MEDIA: nombrearchivo.ext] en tu prompt para referenciar archivos",
          filesCount: "{{current}}/6 archivos agregados",
          uploadSuccessCount: "{{count}} archivo(s) agregado(s) correctamente",
          maxSixWithCounts:
            "Máximo 6 archivos por prompt. Ya tienes {{current}} y estás intentando agregar {{adding}}. Solo puedes agregar {{remaining}} más.",
          maxSixNoMore:
            "Máximo 6 archivos por prompt. Ya tienes {{count}} archivos. No se pueden agregar más.",
          someRejected: "Algunos archivos no se pudieron agregar: {{list}}",
          fileTooBig: "{{name}}: excede {{maxMb}}MB",
          uploadPartial: "{{uploaded}} archivo(s) agregado(s), {{failed}} fallaron: {{names}}",
          uploadFailedDetail: "Error al subir archivos: {{details}}",
          uploadNone: "No se pudo subir ningún archivo. Verifica la consola para más detalles.",
        },
        urlDialog: {
          title: "Agregar URL externa",
          urlLabel: "URL del archivo",
          urlPlaceholder: "https://ejemplo.com/archivo.jpg",
          captionLabel: "Descripción (opcional)",
          captionPlaceholder: "Descripción del archivo",
          hintPublic: "💡 Asegúrate de que la URL sea accesible públicamente",
          add: "Agregar",
          close: "Cerrar",
        },
        expanded: {
          confirmClose: "¿Deseas guardar los cambios antes de cerrar?",
          title: "Editor ampliado — prompt principal",
          unsavedChip: "Cambios sin guardar",
          intro:
            "Edita tu prompt con más espacio. Las referencias a archivos multimedia [MEDIA: nombrearchivo.ext] aparecerán resaltadas en la vista previa.",
          editorPlaceholder: "Escribe tu prompt aquí…",
          charCount: "Cantidad de caracteres: {{count}}",
          previewTitle: "Vista previa (con resaltado):",
          toastSaved: "Prompt actualizado correctamente",
        },
      },
      prompts: {
        title: "Prompts",
        table: {
          name: "Nombre",
          queue: "Sector/Cola",
          max_tokens: "Máximo Tokens Respuesta",
          actions: "Acciones",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteTitleNamed: "¿Eliminar el prompt «{{name}}»?",
          deleteMessage: "¿Está seguro? ¡Esta acción no se puede deshacer!",
        },
        buttons: {
          add: "Agregar Prompt",
        },
        listPage: {
          title: "Prompts de IA",
          addButton: "Agregar prompt",
          providersTitle: "Proveedores de IA disponibles",
          providersIntro:
            "Selecciona el proveedor de inteligencia artificial que mejor se adapte a tus necesidades. Disponemos de proveedores oficiales: OpenAI, Gemini, Grok, Deepseek® y OpenRouter.",
          providersApiKey:
            "Cada proveedor ofrece distintos modelos y capacidades. Asegúrate de tener una API Key válida para el proveedor seleccionado.",
          tablePromptName: "Nombre del prompt",
          tableProvider: "Proveedor IA",
          tableMaxTokens: "Máximo tokens",
          tableTemperature: "Temperatura",
          tableMaxMessages: "Máximo mensajes",
          tableActions: "Acciones",
          tokensChip: "{{count}} tokens",
          tooltipEdit: "Editar prompt",
          tooltipDelete: "Eliminar prompt",
        },
      },
      contactModal: {
        notes: {
          title: "Observaciones del Contacto",
          success: "Observación agregada exitosamente",
          deleted: "Observación eliminada exitosamente",
          deleteTitle: "Eliminar Observación",
          deleteMessage: "¿Desea realmente eliminar esta observación?",
        },
        title: {
          add: "Agregar contacto",
          edit: "Editar contacto",
        },
        form: {
          mainInfo: "Datos del contacto",
          extraInfo: "Información adicional",
          name: "Nombre",
          number: "Número de Whatsapp",
          email: "Email",
          extraName: "Nombre del campo",
          extraValue: "Valor",
          whatsapp: "Conexión de origen",
          whatsappHelper: "WhatsApp por el que se registró este contacto. Se asigna al abrir un ticket, no al crearlo.",
        },
        buttons: {
          addExtraInfo: "Agregar información",
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Contacto guardado con éxito.",
      },
      queueModal: {
        title: {
          add: "Agregar departamento",
          edit: "Editar departamento",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
        },
        tabs: {
          queueData: "Datos del departamento",
          serviceHours: "Horario de servicio",
        },
        automation: {
          title: "Automatización de procesos",
          intro:
            "Puedes automatizar conversaciones con prompts personalizados, flujos de trabajo (FlowBuilder), integraciones externas o un chatbot con menús de opciones: el contacto elige con botones en el chat, no escribe en modo libre. Solo puede estar activa una de las cuatro opciones a la vez; ninguna es obligatoria.",
        },
        form: {
          name: "Nombre",
          departmentName: "Nombre del departamento",
          color: "Color",
          greetingMessage: "Mensaje de saludo",
          enableGreeting: "Activar saludo",
          greetingEnabledOn: "Habilitado — se enviará el mensaje de bienvenida.",
          greetingEnabledOff: "Desactivado — no se muestra ni envía saludo.",
          greetingRequired: "Si activa el saludo, debe escribir el mensaje.",
          complationMessage: "Mensaje de conclusión",
          outOfHoursMessage: "Mensaje de fuera de horario",
          ratingMessage: "Mensaje de evaluación",
          token: "Token",
          orderQueue: "Orden de la cola (Bot)",
          integrationId: "Integración",
          noIntegration: "Sin integración",
          prompt: "Prompt",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          attach: "Adjuntar archivo",
        },
        toasts: {
          deleted: "Archivo eliminado correctamente.",
        },
        schedules: {
          title: "Agendamientos",
          confirmationModal: {
            deleteTitle: "¿Estás seguro de que quieres eliminar este Agendamiento?",
            deleteMessage: "Esta acción no se puede deshacer.",
          },
          table: {
            contact: "Contacto",
            body: "Mensaje",
            sendAt: "Fecha de Agendamiento",
            sentAt: "Fecha de Envío",
            status: "Estado",
            actions: "Acciones",
          },
          buttons: {
            add: "Nuevo Agendamiento",
          },
          toasts: {
            deleted: "Agendamiento eliminado con éxito.",
          },
          saveSuccess: "Horarios guardados correctamente.",
          saveButton: "Guardar horarios",
        },
      },
      schedules: {
        form: {
          weekday: "Día de la semana",
          startTime: "Hora de inicio",
          endTime: "Hora de fin",
          save: "Guardar horarios",
        },
      },
      userModal: {
        title: {
          add: "Agregar usuario",
          edit: "Editar usuario",
        },
        form: {
          name: "Nombre",
          email: "Email",
          password: "Contraseña",
          profile: "Tipo de usuario",
          whatsapp: "Conexión Predeterminada",
          whatsappHint:
            "Usada en el inbox y en Negocio (entregas, recordatorios y avisos). WhatsApp o Telegram según la conexión.",
          language: "Idioma del panel",
          allTicket: "Ver Tickets Sin Asignar",
          allTicketEnabled: "Habilitado",
          allTicketDesabled: "Deshabilitado",
          profileHint:
            "Admin configura el negocio. Supervisor ve todos los tickets de sus departamentos. Agente atiende solo los suyos.",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Usuario guardado con éxito.",
      },
      scheduleModal: {
        title: {
          add: "Nuevo Agendamiento",
          edit: "Editar Agendamiento",
        },
        form: {
          body: "Mensaje",
          contact: "Contacto",
          sendAt: "Fecha de Agendamiento",
          sentAt: "Fecha de Envío",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          cancelMeeting: "Cancelar reunión",
          exit: "Salir",
        },
        selectConnectionPlaceholder: "Seleccione una conexión",
        bodyCharCounter: "{{current}}/500 caracteres",
        success: "Agendamiento guardado con éxito.",
        toasts: {
          deleted: "Archivo eliminado con éxito.",
          meetingCancelled: "Reunión cancelada exitosamente",
          updated: "✅ Agendamiento actualizado correctamente",
          created: "✅ Agendamiento creado correctamente",
          noDataSave: "❌ Error: No hay datos para guardar",
        },
        confirmationModal: {
          deleteTitle: "Eliminar archivo",
          deleteMessage: "¿Estás seguro de que quieres eliminar este archivo?",
        },
        cancelMeetingTitle: "Cancelar Reunión",
        cancelMeetingMessage:
          "¿Está seguro que desea cancelar esta reunión? Se enviará un mensaje de cancelación al contacto.",
        confirmScheduleTitle: "¿Está seguro de agendar la cita?",
        confirmScheduleDate: "Fecha y Hora:",
        confirmScheduleContact: "Contacto:",
        confirmScheduleWhatsapp: "Conexión:",
        confirmScheduleMessage: "Mensaje:",
        confirmScheduleQuestion: "¿Confirma que desea agendar esta cita con los datos mostrados?",
        validationErrorTitle: "❌ Error de validación",
        understood: "Entendido",
        validationGeneric: "Error al validar el agendamiento",
        contactNotFound: "Contacto no encontrado",
        whatsappNotFound: "Conexión no encontrada",
        dialogStatusErro: "Error de envío",
        dialogStatusPrefix: "Mensaje",
        autocompleteNoContacts: "No se encontraron contactos",
        searchContactLabel: "Escribe para buscar contactos",
        searchContactPlaceholder: "Clic aquí para ver contactos disponibles",
        attachFile: "Adjuntar archivo",
        validation: {
          required: "Obligatorio",
          invalidDateTime: "❌ Fecha/hora inválida",
          pastDateTime: "❌ No puedes agendar para una fecha/hora pasada. Hora actual: {{now}}",
          minTenMinutes:
            "❌ El tiempo mínimo para agendar es 10 minutos. Hora más temprana permitida: {{min}}",
          maxOneYear: "❌ No puedes agendar para más de 1 año en el futuro",
          febMaxDays: "❌ Febrero no puede tener más de 29 días",
          feb29Leap: "❌ 29 de febrero solo existe en años bisiestos",
          month30: "❌ El mes {{month}} no puede tener más de 30 días",
          bodyShort: "Mensaje muy corto",
          messageMax: "❌ El mensaje no puede exceder 500 caracteres",
          messageMinChars: "❌ El mensaje debe tener al menos 3 caracteres",
          messageMinValid: "❌ El mensaje debe contener al menos 2 caracteres válidos",
          allFieldsRequired:
            "❌ Todos los campos son obligatorios: contacto, conexión, mensaje y fecha/hora",
        },
        connectionFallback: "Conexión {{id}}",
      },
      tagModal: {
        title: {
          add: "Nueva Etiqueta",
          edit: "Editar Etiqueta",
        },
        form: {
          name: "Nombre",
          color: "Color",
          namePlaceholder: "Ej: Atención, Cliente, Interesado...",
          pickColorTitle: "Seleccionar color",
          kanbanLabel: "Usar en Kanban",
          kanbanHint:
            "Las etiquetas con Kanban activado aparecerán como columnas en el tablero Kanban",
        },
        validation: {
          nameMin: "Nombre demasiado corto",
          required: "Obligatorio",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Etiqueta guardada con éxito.",
      },
      schedulePage: {
        moduleTitle: "Módulo de Agenda",
        scheduledTotal: "{{count}} agendamientos",
        title: "Agendamientos ({{count}})",
        notAvailable: "N/D",
        viewTable: "Vista tabla",
        viewCalendar: "Vista calendario",
        newButton: "Nuevo Agendamiento",
        table: {
          date: "Fecha",
          time: "Hora",
          contact: "Contacto",
          connection: "Conexión",
          message: "Mensaje",
          status: "Estado",
          actions: "Acciones",
        },
        status: {
          error: "Error",
          cancelled: "Cancelado",
          sent: "Enviado",
          overdue: "Vencido",
          pending: "Pendiente",
        },
        cancelMeetingTitle: "¿Cancelar reunión?",
        cancelScheduleTitle: "¿Cancelar agendamiento?",
        cancelMeetingMessage:
          "¿Estás seguro de que deseas cancelar esta reunión? Se eliminarán todos los recordatorios asociados.",
        cancelScheduleMessage:
          "¿Estás seguro de que deseas cancelar este agendamiento? Se enviará un mensaje de cancelación al contacto.",
        toastMeetingCancelled: "Reunión cancelada exitosamente",
        toastScheduleCancelled: "Agendamiento cancelado exitosamente",
        deleteTitleAlreadyCancelled: "Ya cancelado",
        deleteTitleCancel: "Cancelar agendamiento",
        calendar: {
          date: "Fecha",
          time: "Hora",
          event: "Evento",
          allDay: "Día completo",
          week: "Semana",
          work_week: "Agendamientos",
          day: "Día",
          month: "Mes",
          previous: "Anterior",
          next: "Siguiente",
          yesterday: "Ayer",
          tomorrow: "Mañana",
          today: "Hoy",
          agenda: "Agenda",
          noEventsInRange: "No hay agendamientos en este período.",
          showMore: "+{{total}} más",
        },
      },
      appointmentsModule: {
        page: {
          moduleTitle: "Módulo de Agenda",
          pendingLine: "• {{count}} solicitudes pendientes",
          newAppointment: "Nueva cita",
          tabs: {
            dashboard: "Dashboard",
            calendar: "Calendario",
            pending: "Pendientes",
            history: "Historial",
            settings: "Configuración",
          },
          accessDeniedTitle: "No tienes acceso al módulo Agenda",
          accessDeniedP1:
            "Debes estar vinculado como profesional/instructor en Agenda > Configuración > Equipo, o ser administrador.",
          accessDeniedP2:
            "Flujo: Registrar primero en Usuarios → luego vincular como Professional en Equipo.",
          goHome: "Ir al inicio",
          checkingAccess: "Verificando acceso…",
          allProfessionals: "Todos los profesionales",
        },
        status: {
          all: "Todos",
          pending: "Pendiente",
          confirmed: "Confirmada",
          rescheduled: "Reprogramada",
          in_progress: "En curso",
          completed: "Completada",
          no_show: "No asistió",
          cancelled: "Cancelada",
        },
        calendar: {
          date: "Fecha",
          time: "Hora",
          event: "Evento",
          today: "Hoy",
          previous: "Anterior",
          next: "Siguiente",
          month: "Mes",
          week: "Semana",
          day: "Día",
          agenda: "Agenda",
          noEventsInRange: "No hay citas en este período.",
          noName: "Sin nombre",
          serviceFallback: "Servicio",
          code: "Código",
          detailsListTitle: "Detalle de citas",
          viewDetails: "Ver detalle",
          modality: {
            presencial: "Presencial",
            online: "Online",
            phone: "Teléfono",
          },
        },
        dashboard: {
          wd0: "Lun",
          wd1: "Mar",
          wd2: "Mié",
          wd3: "Jue",
          wd4: "Vie",
          wd5: "Sáb",
          wd6: "Dom",
          kpiWeek: "Sesiones esta semana",
          kpiPending: "Pendientes de confirmar",
          kpiToday: "Sesiones hoy",
          kpiRate: "Tasa de asistencia (30 días)",
          chartTitle: "Sesiones por día — {{month}}",
          todayTitle: "Sesiones de hoy",
          todayEmpty: "No hay sesiones programadas para hoy",
          todayLine: "{{time}}: {{contact}} — {{service}}",
          professionalPrefix: "Profesional:",
          upcomingTitle: "Próximas sesiones",
          upcomingEmpty: "No hay sesiones programadas en los próximos 30 días",
          chartConfirmed: "Confirmadas",
          chartPending: "Pendientes",
          chartCancelled: "Canceladas",
          code: "Código",
          viewDetails: "Ver detalle",
          modality: {
            presencial: "Presencial",
            online: "Online",
            phone: "Teléfono",
          },
        },
        pendientes: {
          loading: "Cargando...",
          emptyHint: "Estas solicitudes requieren tu confirmación antes de ser agendadas",
          emptySub: "No hay solicitudes pendientes",
          intro: "Estas solicitudes requieren tu confirmación antes de ser agendadas",
          noName: "Sin nombre",
          serviceFallback: "Servicio",
          instructor: "Instructor: {{name}}",
          chipPending: "Pendiente",
          confirm: "Confirmar",
          reschedule: "Reagendar",
          cancel: "Cancelar",
          tooltipConfirm: "La cita queda confirmada, aparece en Calendario y deja Pendientes",
          tooltipReschedule:
            "Abre el modal para cambiar estado (ej. Confirmar, Cancelar) de la cita",
          tooltipCancel: "Cancela la cita, ya no aparecerá en Pendientes",
          code: "Código",
          bookedByAi: "Agendada por IA",
          notes: "Notas",
          modality: {
            presencial: "Presencial",
            online: "Online",
            phone: "Teléfono",
          },
        },
        historial: {
          loading: "Cargando historial…",
          empty: "No hay citas con los filtros aplicados",
          emptyHint: "Ajusta las fechas o el estado en el encabezado para ver más resultados",
          countOrder: "{{count}} citas · Orden: {{order}}",
          orderAsc: "próximas primero",
          orderDesc: "más recientes primero",
          changeOrder: "Cambiar orden",
          edit: "Editar",
          editReschedule: "Editar / Reagendar",
          editAria: "Editar cita",
          tableAria: "Historial de citas",
          colDate: "Fecha",
          colTime: "Hora",
          colContact: "Contacto",
          colService: "Servicio",
          colProfessional: "Profesional",
          colDetails: "Detalles",
          colStatus: "Estado",
          colActions: "Acciones",
          code: "Código",
          modality: {
            presencial: "Presencial",
            online: "Online",
            phone: "Teléfono",
          },
          rowsPerPage: "Filas por página:",
          rowsPerPageShort: "Filas:",
          displayedRows: "{{from}}-{{to}} de {{count}}",
        },
        config: {
          firstTimeTitle: "¿Primera vez configurando Agenda?",
          firstTimeSubtitle: "Configura perfil, servicios, equipo y horarios en pocos pasos.",
          firstTimeCta: "Comienza aquí",
          activeProfileTitle: "Perfil activo: {{name}}",
          activeProfileSubtitle: "Modifica cualquier aspecto de la configuración inicial.",
          cardPerfilTitle: "Tipo de negocio / perfil",
          cardPerfilDesc:
            "Define si eres Belleza, Comercial, Salud, Educación o Técnico. Afecta vocabulario y columnas Kanban.",
          cardServiciosTitle: "Servicios / Programas",
          cardServiciosDesc: "Catálogo de servicios, materias o programas con duración y precio.",
          cardEquipoTitle: "Equipo de instructores",
          cardEquipoDesc:
            "Profesionales que atienden. Vincula cada uno con un usuario para que pueda acceder a Agenda y confirmar citas.",
          cardHorariosTitle: "Horarios de atención",
          cardHorariosDesc: "Días, horarios y duración de slots por día.",
          cardSecuenciasTitle: "Secuencias automáticas del Agente IA",
          cardSecuenciasDesc:
            "Cuándo y cómo el Agente IA captura datos y dispara flujos (solicitud de cita). El tono se configura en Prompts IA.",
          equipoIntro:
            "Vincula cada profesional con un usuario (registrado en Usuarios) para que pueda entrar a Agenda y confirmar citas.",
          equipoConfigureBtn: "Configurar equipo (nombres, roles y especialidades)",
          loadingProfessionals: "Cargando profesionales…",
          tableProfessional: "Profesional",
          tableRole: "Rol / especialidad",
          tableLinkUser: "Vincular con usuario",
          noneUser: "— Ninguno —",
          noProfessionals:
            "No hay profesionales. Usa el botón de arriba para agregar el equipo en la configuración inicial.",
          secuenciasIntro:
            "Elige qué Agente IA (Prompt) se usará para capturar solicitudes de cita por chat. El tono y la personalidad se configuran en ese Agente.",
          loading: "Cargando…",
          agentLabel: "Agente IA para flujo de citas",
          noAgent: "— Ninguno (no usar Agente para citas) —",
          noAgentsList: "No hay Agentes IA. Crea uno en Prompts IA.",
          promptsLink: "Configurar tono y personalidad en Prompts IA",
          kanbanHint:
            "Si cambiaste el tipo de negocio, recrea las columnas Kanban según el perfil actual.",
          kanbanRecreate: "Recrear columnas Kanban",
          kanbanProcessing: "Procesando…",
          edit: "Editar",
          editSectionAria: "Editar {{section}}",
          toastLinkOk:
            "Vinculación actualizada. El instructor puede acceder a Agenda con su usuario.",
          toastKanbanOk: "Columnas Kanban recreadas según perfil.",
          toastAgentOk: "Agente IA para flujo de citas actualizado.",
          errorProfileFirst: "Primero configura el perfil en la configuración inicial.",
        },
        appointmentModal: {
          titleNew: "Nueva cita",
          titleEdit: "Cita {{code}}",
          detailsTitle: "Datos de la cita",
          contactFallback: "Contacto #{{id}}",
          client: "Cliente:",
          service: "Servicio:",
          professional: "Profesional:",
          date: "Fecha:",
          confirmationCode: "Código de confirmación",
          statusLabel: "Estado",
          viewProfile360: "Ver Perfil 360",
          rescheduleHint:
            "Indica la nueva fecha, servicio y profesional para reprogramar. Se enviará notificación al contacto.",
          newDateTime: "Nueva fecha y hora *",
          duration: "Duración (minutos)",
          modality: "Modalidad",
          modalityPresential: "Presencial",
          modalityOnline: "Online",
          modalityPhone: "Teléfono",
          locationDetail: "Ubicación / enlace",
          locationPlaceholder: "Dirección, sala o enlace de reunión",
          notes: "Notas",
          bookedByAi: "Agendada por IA",
          createdAt: "Creación",
          updatedAt: "Actualización",
          yes: "Sí",
          no: "No",
          introNew:
            "Registra una nueva cita manualmente. Escribe para buscar y selecciona de la lista filtrada.",
          contactLabel: "Contacto *",
          contactPlaceholder: "Escribe nombre o número para buscar...",
          contactHelper: "Obligatorio. Busca por nombre o teléfono.",
          noOptionsShort: "Escribe al menos 2 caracteres para buscar",
          noOptionsEmpty: "Sin resultados",
          connectionLabel: "Conexión *",
          connectionPlaceholder: "Selecciona la línea WhatsApp (conexión) de esta cita",
          connectionHelper:
            "Obligatorio. Indica desde qué conexión queda registrada la cita (misma lógica que el recordatorio programado).",
          connectionNamed: "Conexión {{id}}",
          dash: "—",
          serviceField: "Servicio",
          serviceSearchPh: "Buscar servicio...",
          serviceHelper: "Opcional. Catálogo de servicios.",
          noServices: "Sin servicios configurados",
          professionalField: "Profesional",
          professionalSearchPh: "Buscar profesional...",
          professionalHelper: "Opcional. Equipo de instructores.",
          noProfessionalsConfigured: "Sin profesionales configurados",
          datetimeLabel: "Fecha y hora *",
          datetimeHelper: "Obligatorio. Momento de la cita.",
          durationHelper: "Por defecto 60 minutos.",
          notesPlaceholder: "Observaciones adicionales...",
          cancel: "Cancelar",
          saveReschedule: "GUARDAR Y REAGENDAR",
          saveStatus: "Guardar estado",
          create: "Crear cita",
          toastContactDateRequired: "Contacto y fecha son obligatorios",
          toastWhatsappRequired: "Selecciona la conexión (WhatsApp) de la cita",
          toastStatusUpdated: "Estado actualizado",
          toastCreated: "Cita creada",
          toastRescheduleDateRequired: "La nueva fecha es obligatoria para reprogramar",
          toastRescheduled: "Cita reprogramada. Se envió notificación al contacto.",
        },
      },
      negocioModule: {
        mobileNav: {
          label: "Accesos de Negocio",
          home: "Inicio",
          customers: "Clientes",
          services: "Servicios",
          collections: "Cobros",
        },
        title: "Negocio",
        previewOnly: "Visible solo para el dueño del sistema · en construcción",
        loading: "Cargando…",
        search: "Buscar…",
        empty: "No hay registros todavía. Crea el catálogo y las cuentas para empezar a vender.",
        save: "Guardar",
        close: "Cancelar",
        edit: "Editar",
        cancel: "Cancelar",
        renew: "Renovar",
        markPaid: "Marcar pagada",
        toastSaved: "Guardado",
        phoneFormat: "Solo el número local, sin el prefijo.",
        confirmTitle: "Confirmar acción",
        confirmBody: "¿Seguro que quieres continuar?",
        deleteAccountBody: "Se eliminará la cuenta y todos sus perfiles. Solo es posible si la cuenta ya venció (o no tiene fecha de vencimiento) y ningún cliente tiene un servicio vigente en ella.",
        confirmRemoveService: "¿Seguro que quieres eliminar este registro?",
        removeService: "Quitar",
        due: {
          leftN: "Faltan {n} días",
          tomorrow: "Vence mañana",
          today: "Vence hoy",
          expiredN: "Venció hace {n} días",
          expiredOne: "Venció hace 1 día",
        },
        openInfo: "Ver información",
        related: {
          accounts: "Ver cuentas",
          products: "Ver productos",
          sales: "Ver movimientos",
          collections: "Ver cobros",
          services: "Ver servicios",
          customers: "Ver cliente",
          suppliers: "Todos los proveedores",
          combos: "Ver combos",
        },
        filters: { all: "Todos" },
        pager: {
          rows: "Filas",
          shown: "{from}–{to} de {count}",
        },
        pages: {
          growth: {
            title: "Referidos y recuperación de ventas",
            referralEnabled: "Programa de referidos activo",
            referralHint: "Cada cliente recibe un enlace (/invitar en Telegram o INVITAR en WhatsApp). Cuando un amigo nuevo paga su primera compra, quien lo invitó recibe la recompensa una sola vez.",
            rewardType: "Tipo de recompensa",
            rewardWallet: "Saldo en el monedero",
            rewardPoints: "Saldo",
            rewardAmount: "Recompensa para quien invita",
            rewardAmountHintWallet: "Monto en la moneda del monedero ({cur}).",
            rewardMode: "Tipo de recompensa",
            rewardModeFixed: "Monto fijo ({cur})",
            rewardModePercent: "% de la primera compra",
            rewardPercentHint: "Porcentaje de la primera compra pagada del invitado.",
            rewardPercentExample: "Ejemplo: si el invitado compra {sale}, quien lo invitó recibe el {pct}% = {wallet} de saldo (clientes de otros países: ≈ {fx}).",
            rewardFixedExample: "Quien invita recibe {amount} de saldo por cada amigo que compre (clientes de otros países: ≈ {fx}).",
            rewardAmountHintLocal: "Monto en {cur}. A clientes de otros países se les acredita el equivalente en divisa.",
            rewardZeroWarning: "Con recompensa en 0 el programa queda apagado: no se reparten enlaces ni el agente IA invita a recomendar.",
            rewardAmountHintPoints: "Valor de saldo.",
            friendReward: "Bono de bienvenida para el invitado (opcional)",
            friendRewardHint: "0 = sin bono. Se acredita con su primera compra pagada.",
            cartEnabled: "Recordatorio de carrito abandonado",
            cartHint: "Un recordatorio amable a quien dejó un pedido sin pagar (45 min después) y, en Telegram, a quien vio un producto y no compró (2 h después). Máximo uno por día, fuera del horario nocturno.",
            autoRenewEnabled: "Renovación automática con saldo",
            autoRenewHint: "El cliente la activa escribiendo AUTORENOVAR (o desde su ficha). El día del vencimiento se cobra de su saldo solo si le alcanza y tiene el saldo habilitado; si no, se le avisa. Sin cashback.",
            autoRenewNeedsWallet: "Requiere el sistema de saldo/cashback activo.",
            reactivationEnabled: "Recuperar clientes inactivos (según su historial)",
            reactivationDays: "Máximo 1 mensaje cada (días)",
            reactivationHint: "Personaliza según los servicios que tuvo el cliente y siguen disponibles: contenido de streaming, características del producto o un recordatorio cordial. IA y TMDB son opcionales. Incluye BAJA para dejar de recibir estas comunicaciones. Se envían pocos por hora, de 10:00 a 19:00.",
            supportTitle: "Garantía, soporte y stock",
            guaranteeHours: "Garantía de reposición (horas)",
            supportResponseText: "Tiempo de atención de soporte",
            supportResponsePlaceholder: "Ej.: te atendemos en menos de 30 minutos (8 am – 10 pm)",
            stockAlertDays: "Alerta de stock (días de cobertura)",
            stockAlertHint: "0 = desactivada",
            supportHint: "La garantía y el tiempo de atención se muestran al cliente al reportar fallas o pedir asesor, y el agente IA los conoce. La alerta de stock avisa al admin (WhatsApp/Telegram) cuando, al ritmo de ventas de 14 días, el stock libre alcanza para esos días o menos.",
            save: "Guardar",
            statsTitle: "Resultados (últimos {days} días)",
            promoSent: "Promos enviadas",
            promoClicks: "Clics en Ver detalles",
            promoPaid: "Ventas atribuidas",
            promoRevenue: "Ingresos atribuidos",
            invited: "Invitados",
            converted: "Con compra",
            colPromo: "Promoción",
            colSent: "Enviadas",
            colClicks: "Clics",
            colPaid: "Ventas",
            colRevenue: "Ingresos",
            colReferrer: "Cliente",
            colCode: "Código",
            topReferrers: "Clientes que más recomiendan",
            promosTitle: "Últimas promociones de Telegram",
            empty: "Aún no hay datos.",
          },
          ai: {
            tab: "Agente IA",
            hint: "Agente con inteligencia artificial que atiende soporte y ventas en WhatsApp y Telegram usando los datos reales de Negocio, y aprende de tus asesores.",
            title: "Agente IA de atención y ventas",
            intro: "Cuando está activo, el agente responde en lenguaje natural: consulta los servicios y vencimientos del cliente, recomienda productos del catálogo con precio y stock reales, inicia compras con cobro (incluido Binance Pay automático), busca códigos, guía fallas y pasa a un asesor cuando hace falta. Los botones, comandos (MENU, SOPORTE, CODIGO) y pasos de pago siguen funcionando igual. Si un asesor toma el chat, el agente se detiene.",
            enabled: "Agente IA activo",
            needKey: "Falta la API Key: sin ella el agente no responde y sigue atendiendo el bot guiado.",
            provider: "Proveedor / modelo",
            apiKey: "API Key del proveedor",
            apiKeySet: "Clave guardada. Escribe una nueva solo si quieres cambiarla.",
            apiKeyHint: "Clave de OpenAI (sk-...), Google AI Studio, Anthropic u OpenRouter según el proveedor.",
            tmdbKey: "Clave TMDB (recomendaciones)",
            tmdbKeyHint: "Opcional. Con tu API Key de themoviedb.org el agente recomienda películas y series en tendencia y dice en qué plataforma verlas.",
            model: "Modelo personalizado (opcional)",
            modelHint: "Déjalo vacío para usar el del proveedor.",
            agentName: "Nombre del agente",
            temperature: "Creatividad (0 a 1)",
            temperatureHint: "0.3–0.5 recomendado: preciso y natural.",
            history: "Mensajes de memoria",
            historyHint: "Cuántos mensajes previos del chat recuerda.",
            instructions: "Instrucciones del negocio",
            instructionsPlaceholder: "Ej.: Horario de atención 9am–10pm. Garantía: reemplazo de cuenta si falla dentro de la vigencia. No hacemos reembolsos en efectivo. Para Netflix con error de hogar, se cambia de cuenta...",
            instructionsHint: "Políticas, tono, horarios y reglas propias. El agente ya conoce catálogo, precios, stock, métodos de pago, condiciones de uso y los servicios de cada cliente.",
            autoLearn: "Autoaprendizaje",
            autoApprove: "Publicar lo aprendido sin revisión",
            vision: "Analizar imágenes",
            visionHint: "El agente lee las imágenes que envía el cliente: detecta si es un comprobante de pago o una captura de falla, extrae el Order ID de Binance para validar el pago automáticamente y adjunta un resumen al aviso de pago. Requiere un modelo con visión (ej. GPT-4o / GPT-4o mini).",
            adminDigest: "Asistente y recordatorios para el admin",
            adminDigestHint: "Cuando el admin del bot (número de WhatsApp o usuario de Telegram de Ajustes › Bot) escribe, el agente le responde como su asistente: pendientes, cuentas vencidas, cobros, citas y dudas de uso de WaToolX según su plan. Además le envía los pendientes del día a las 8:00 y 15:00.",
            autoLearnHint: "Cuando el agente pasa un caso a un asesor, luego analiza cómo lo resolvió el asesor y crea conocimientos reutilizables (sin datos personales). Sin publicación automática quedan como Pendientes para que los apruebes.",
            testTitle: "Probar el agente",
            testHint: "Conversa como si fueras un cliente. Las acciones (compras, flujos, transferencias) se muestran sin ejecutarse. Guarda la configuración antes de probar.",
            testEmpty: "Escribe un mensaje para empezar, por ejemplo: «hola, cuánto vale Netflix?» o «no me abre el Disney».",
            testPlaceholder: "Escribe como cliente…",
            resetChat: "Reiniciar",
            knowledgeTitle: "Base de conocimiento",
            knowledgeHint: "Respuestas, soluciones y políticas que el agente usa. Las aprendidas llegan como Pendientes hasta que las apruebes.",
            knowledgeEmpty: "Sin entradas todavía.",
            newEntry: "Nueva entrada",
            editEntry: "Editar entrada",
            learnHistory: "Aprender del historial (30 días)",
            learnNow: "Procesar escalamientos",
            learnDone: "Revisadas {reviewed} conversaciones · {learned} conocimientos nuevos",
            question: "Pregunta o situación",
            questionHint: "Cómo lo preguntaría un cliente. Ej.: Disney dice contraseña incorrecta",
            answer: "Respuesta / solución",
            tags: "Etiquetas",
            tagsHint: "Palabras clave separadas por coma: disney, contraseña, acceso",
            status: "Estado",
            statusActive: "Activa",
            statusPending: "Pendiente",
            statusDisabled: "Desactivada",
            source: "Origen",
            sourceLearned: "Aprendida",
            sourceManual: "Manual",
            uses: "Usos",
            approve: "Aprobar",
            filterAll: "Todas",
            confirmDelete: "¿Eliminar esta entrada?",
            statActive: "Conocimientos activos",
            statPending: "Por aprobar",
            statLearned: "Aprendidos",
            statEscalations: "Escalados (30 días)",
          },
          dashboard: {
            title: "Resumen",
            subtitle: "Ganancia, vencimientos y ventas.",
            today: "Hoy",
            setup: "Cómo armar el negocio",
            step: "Paso",
            open: "Abrir",
            profit: "Ganancia",
            monthResume: "Resumen del mes",
            vsPrev: "vs. periodo anterior",
            expiredBanner: "{n} perfil(es) ya vencieron",
            expiringBanner: "{n} perfil(es) vencen en los próximos 3 días",
            pendingBanner: "{n} venta(s) con pago pendiente",
            toRenew: "por renovar · clic para ver",
            toCollect: "por cobrar · clic para ver",
            profitByMonth: "Ganancia por mes",
            rangeTotal: "Total del rango",
            bestMonth: "Mejor mes",
            worstMonth: "Menor mes",
            byService: "Resumen por servicio",
            thisMonth: "Este mes",
            salesCount: "venta(s)",
            noServices: "Aún no hay ventas de producto este mes.",
            raffleTitle: "Sorteo del mes",
            raffleWinner: "Ganador de {month}: {name}",
            rafflePhone: "Tel. {phone}",
            raffleTickets: "{n} de {total} tickets",
            rafflePending: "Premio pendiente de canje · vence {date}",
            raffleRedeemed: "Premio canjeado el {date}",
            raffleExpired: "Premio vencido sin canjear",
          },
          subscriptions: {
            title: "Cobros",
            subtitle: "Servicios que vencen en 3 días, vencen hoy o ya vencieron.",
            emptyTitle: "Nada por vencer ahora",
            empty: "Cuando un servicio esté a 3 días, venza hoy o ya esté vencido, aparece aquí.",
            search: "Buscar por nombre o código…",
            pendingShort: "por cobrar",
            expiredShort: "vencido(s)",
            expiredOverdue: "{count} vencido(s) hace más de {days} días",
            soonShort: "en 3 días",
            todayShort: "hoy",
            sendReminders: "Enviar recordatorios",
            remindersSent: "Envío de recordatorios iniciado ({n}).",
            remindersReport: "Recordatorios: {sent} mensaje(s). {detail}",
            remindersRunning: "Ya hay un envío de recordatorios en curso.",
            exportReport: "Exportar reporte",
            kpis: {
              amount: "En cola",
              soon: "En 3 días",
              today: "Vencen hoy",
              expired: "Vencidos",
              pending: "Pendientes",
              debtors: "Deudores",
            },
          },
          services: {
            title: "Servicios",
            subtitle: "Carrito vivo de cada cliente. Agrega, renueva o quita. Es la misma base de toda la cartera.",
            emptyTitle: "Aún no hay servicios activos",
            empty: "Agrega un producto a un cliente. Queda en su carrito y también se registra en Movimientos.",
            search: "Buscar cliente o servicio…",
            overdueBy: "hace {n} d",
            daysLeft: "{n} días",
            view: {
              cart: "Por cliente",
              list: "Lista",
            },
            kpis: {
              clients: "Clientes",
              live: "Servicios",
              expired: "Vencidos",
              pending: "Por cobrar",
            },
            cart: {
              new: "Nuevo carrito",
              config: "Configuración",
              pickCustomer: "Cliente",
              payment: "Forma de pago",
              payment2: "Segunda forma de pago",
              payment2Hint: "Opcional. Hasta dos métodos por cliente.",
              saleType: "Tipo de venta",
              saleTypes: {
                profile: "Perfil",
                full: "Cuenta completa",
                combo: "Combo",
              },
              saleTypeHints: {
                profile: "Solo cuentas que se venden por perfil.",
                full: "Solo cuentas que se venden completas.",
                combo: "Combos primero y luego todas las cuentas disponibles.",
              },
              codes: "Sistema de códigos",
              codeUrl: "URL",
              codeUser: "Usuario",
              codePassword: "Contraseña",
              addItem: "Agregar servicio",
              noItems: "Aún no hay servicios en este carrito.",
              pickAccount: "Selecciona producto y cuenta.",
              pickProfile: "Selecciona el perfil.",
              comboUnavailable: "No hay cuentas libres para todos los productos del combo.",
              comboHint: "Al guardar se asignan cuentas libres a cada producto del combo.",
              reviewSlots: "Cuentas y perfiles del combo",
              reviewSlotsHint: "Se eligieron al azar. Ábrelas para cambiarlas antes de guardar.",
              shuffleSlots: "Volver a asignar al azar",
              remove: "Eliminar carrito",
              removeBlocked: "Solo se puede eliminar si no tiene servicios vigentes.",
              sendOrder: "Pedido",
              sendReminder: "Recordatorio",
              sendUpdated: "Actualizado (5 min)",
              sendLast: "Último pedido (5 min)",
              sendRenewed: "Renovación (5 min)",
              renewExpired: "Renovar vencidos",
              renewExpiredOk: "Servicios renovados",
              pointsAccumulated: "Saldo acumulado",
              cartTotal: "Total compra",
              currency: "Moneda",
              currencyLocal: "Moneda local",
              currencyFx: "Divisa",
              profit: "Utilidad",
              profitHint: "Precio menos costo, siempre en moneda principal.",
              fxLocalHint: "Equivalente en moneda principal",
              contractDate: "Fecha de contratación",
              details: "Detalles del servicio",
              itemCodes: "Sistema de códigos",
              paid: "Pagado",
              unpaid: "Sin pagar",
              payWithWallet: "Pagar con saldo",
              payWithWalletHint: "Se descuenta del monedero del cliente en su moneda. Si no alcanza, no se registra. Pagar con saldo no genera cashback.",
              walletPaid: "Se pagará con el saldo del cliente",
              payWithPrize: "Canjear premio del sorteo",
              payWithPrizeHint: "30 días de un servicio con stock. Vence el {date}. Requiere un servicio activo y vigente.",
              prizeDaysHint: "El premio otorga 30 días. Vence",
              prizePaid: "Canje de premio (sale en negativo)",
              prizeReady: "Premio por canjear",
              ticketsLabel: "Tickets",
              raffleTickets: "{n} tickets este mes",
              sendPay: "Recordatorio de pago",
              send: "Enviar",
              suggestedAccount: "Sugerido: el perfil libre se eligió al azar; puedes cambiarlo.",
              codePoolHint: "Si lo dejas vacío se toma un código del stock ({n} disponibles).",
              panelStockHint: "Pega el código o link generado al asociar. Quedan {n} en esta cuenta.",
            },
          },
          sales: {
            title: "Movimientos",
            subtitle: "Cada cobro queda aquí. No se borra al quitar un servicio.",
            emptyTitle: "Aún no hay movimientos",
            empty: "Al agregar un servicio en el carrito se registra el cobro aquí.",
            search: "Buscar cliente o servicio…",
            export: "Exportar CSV",
            filterProduct: "Producto",
            filterCustomer: "Cliente",
            filterPayment: "Método de pago",
            dateFrom: "Desde",
            dateTo: "Hasta",
            pickMonth: "Mes",
            pickYear: "Año",
            chartTrend: "Por mes",
            chartByType: "Por tipo",
            chartByProduct: "Por producto",
            chartByCustomer: "Por cliente",
            chartByPayment: "Por forma de pago",
            chartClick: "Clic para filtrar · otro clic quita el filtro",
            chartClientsN: "{n} clientes",
            chartClientsTop: "Top {n}",
            chartClientsMore: "+{n} más en la tabla",
            chartOther: "Otros",
            kpis: {
              today: "Hoy",
              week: "Esta semana",
              month: "Este mes",
              year: "Este año",
              historical: "Total histórico",
              count: "Movimientos",
              filterIncome: "Ingresos (filtro)",
              filterPending: "Por cobrar (filtro)",
              filterCount: "Movimientos (filtro)",
              filterAvg: "Ticket promedio",
            },
            types: {
              sale: "Ingreso",
              pending_payment: "Por cobrar",
              redeem: "Pago con saldo",
            },
            periods: {
              all: "Todo",
              today: "Hoy",
              week: "Semana",
              month: "Mes",
              year: "Año",
            },
          },
          customers: {
            title: "Clientes",
            subtitle: "Agenda con foto de WhatsApp, código y servicios.",
            agendaSubtitle: "Agenda con foto de WhatsApp, código y servicios.",
            emptyTitle: "Aún no hay clientes de negocio",
            empty: "Agrégalos a mano o aparecerán solos cuando registres una venta.",
            active: "Servicios",
            noServices: "Este cliente todavía no tiene suscripciones.",
            noSales: "Este cliente todavía no tiene compras.",
            phoneHint: "Código de país y número, sin + ni espacios. Ejemplo: 573001234567",
            telegramHint: "Usuario de Telegram, sin @. Obligatorio si no hay teléfono.",
            phoneOrTelegram: "Indica teléfono o Telegram.",
            nameRequired: "El nombre es obligatorio",
            unknownCountry: "País no identificado",
            openDetail: "Ver ficha",
            newTicket: "Crear conversación",
            openChat: "Ir a la conversación (abre la existente o crea una)",
            detailTitle: "Ficha del cliente",
            points: "Saldo",
            pointsOn: "Recibe cashback",
            sendWallet: "Enviar saldo al cliente",
            autoRenewOn: "Renueva solo con saldo",
            autoRenewOff: "Sin renovación automática",
            discountPercent: "% de descuento (distribuidor)",
            discountHint: "Se aplica a compras nuevas en el bot, la IA y las ventas del panel. No aplica a renovaciones. Redondeo a la centena.",
            metrics: {
              avgTicket: "Ticket promedio",
              lastPurchase: "Última compra",
              daysAgo: "hace {n} días",
              frequency: "Frecuencia",
              everyDays: "cada {n} días",
              churn: "Riesgo de abandono",
              risk: { alto: "Alto", medio: "Medio", bajo: "Bajo" },
              autoRenew: "Renovación auto.",
              yes: "Sí",
              no: "No",
            },
            pointsOff: "Sin cashback",
            walletCurrency: "Moneda del saldo y cashback",
            walletCurrencyHint: "El cashback se calcula con el % general sobre lo que pague el cliente y se abona en esta moneda.",
            walletCurrencyConvert: "Su saldo actual de {{from}} se convertirá a {{to}} (tasa {{rate}}).",
            wallet: "Saldo",
            walletHistory: "Movimientos del monedero",
            walletEmpty: "Este cliente no tiene movimientos de saldo.",
            walletAmount: "Monto",
            walletReasons: {
              recarga: "Recarga",
              compra: "Compra",
              renovacion: "Renovación",
              ajuste: "Ajuste manual",
              reembolso: "Reembolso",
              referido: "Referido",
              cashback: "Cashback",
              puntos: "Saldo migrado",
            },
            sales: "Historial de compras",
            purchases: "Compras",
            totalPurchases: "Total compras",
            pointsHistory: "Historial de saldo",
            pointsEmpty: "Este cliente no tiene movimientos de saldo.",
            pointsService: "Servicio",
            pointsReason: "Motivo",
            pointsPurchase: "Compra",
            pointsRedeem: "Canje",
            services: "Servicios adquiridos",
            registeredAt: "Cliente desde",
            renewStartHint: "Día siguiente al vencimiento anterior, para dar continuidad.",
            sendUpdated: "Enviar datos actualizados",
            sendRenewed: "Enviar mensaje de renovación",
            sendRenewTitle: "¿Enviar el mensaje de renovación?",
            sendRenewBody: "El servicio ya fue renovado. Puedes avisar al cliente ahora por WhatsApp o Telegram, o saltar este paso.",
            sendPromptTitle: "¿Enviar el mensaje?",
            sendPromptBody: "Puedes enviarlo ahora por WhatsApp o Telegram, o saltar este paso.",
            sendNewServiceTitle: "¿Enviar los datos del nuevo servicio?",
            sendNewServiceBody: "Este mensaje incluye los datos de acceso o invitación de los productos que acabas de agregar. Si agregas más, todos irán en el mismo envío. El resumen del carrito se envía con Pedido.",
            sendSkip: "Ahora no",
            sendingVia: "Enviando por {channel}…",
            addAnotherProduct: "Agregar otro producto",
            createSaleTitle: "¿Crear una venta?",
            createSaleBody: "El cliente ya está listo. ¿Quieres abrir un carrito para venderle ahora?",
            createSaleYes: "Sí",
            createSaleNo: "No",
            addProductsTitle: "¿Agregar productos?",
            addProductsBody: "El carrito ya está configurado. ¿Quieres agregar productos ahora?",
            addProductsYes: "Sí",
            addProductsNo: "No",
            swapProfile: "Cambiar perfil",
            swapProfileTitle: "¿Mover a otra cuenta?",
            swapProfileBody: "Se buscará otra cuenta del mismo producto con un puesto libre (perfil, miembro o dispositivo) y se reasignará, sin crear una venta nueva. Útil si la plataforma expulsó al usuario.",
            swapProfileOk: "Cuenta y puesto cambiados",
            markedPaid: "Marcado como pagado",
            markPaidBody: "Se marcará el pago como recibido y el servicio quedará activo.",
            payWithWallet: "Pagar con saldo",
            payWithWalletBody: "Se descontará el valor de la venta del saldo del cliente y el servicio quedará activo. Pagar con saldo no genera cashback.",
            paidWithWallet: "Venta pagada con el saldo del cliente",
            removeServiceTitle: "Quitar servicio",
            removeServiceBody: "¿Seguro que quieres eliminar este registro?",
            sentOk: "Mensaje enviado",
            sendPointsTip: "Toca para enviarle al cliente su saldo",
            walletHistoryCurrencyHint: "Los movimientos sin moneda registrada muestran únicamente el importe original.",
            sendPointsTitle: "Enviar saldo:",
            templatesLink: "Editar plantilla",
            types: {
              final: "Cliente",
              reseller: "Revendedor",
            },
            import: {
              action: "Importar",
              title: "Importar clientes desde CSV",
              formatTitle: "Formato esperado",
              formatSample: "nombre,prefijo,telefono,tipo,email\nJuan Pérez,+57,3001234567,client,juan@example.com\nMaría López,+52,5512345678,client,\nPedro Gómez,+57,3119876543,reseller,",
              ruleName: "nombre: 2-150 caracteres",
              rulePrefix: "prefijo: + y 1-4 dígitos (ej: +57)",
              rulePhone: "telefono: 6-30 dígitos (guiones/espacios se eliminan)",
              ruleType: "tipo: client o reseller",
              ruleEmail: "email: opcional, déjalo vacío si no aplica",
              ruleDupes: "Filas con teléfonos o emails duplicados se omiten",
              ruleMax: "Máximo 1000 filas por importación",
              pickFile: "Selecciona un archivo",
              dropHint: "CSV de máximo 5 MB. Filas inválidas se omiten.",
              empty: "El archivo no tiene filas válidas.",
              maxSize: "El archivo no puede superar 5 MB.",
              done: "Se sincronizaron {created} clientes. Omitidos: {skipped}.",
            },
            kinds: {
              active: "Con servicio",
              expiring: "Por vencer",
              expired: "Vencido",
              none: "Sin servicios",
            },
          },
          accounts: {
            title: "Cuentas",
            subtitle: "Correo, perfiles libres u ocupados, y vencimiento.",
            emptyTitle: "Sin cuentas en inventario",
            empty: "Primero crea un producto. Luego agrega la cuenta y, si aplica, se crean los perfiles en estado libre.",
            profiles: "Perfiles de esta cuenta",
            noProfiles: "Esta cuenta todavía no tiene perfiles.",
            fullHint: "Venta de cuenta completa: no usa perfiles.",
            fullHintMailbox: "Cada correo es una unidad. No hay perfiles: se entrega el Gmail/Outlook completo.",
            slotsFromProduct: "Sale del máximo de puestos del producto (perfiles, miembros o dispositivos).",
            slotsEditableHint: "Al guardar se crean los puestos faltantes para poder venderlos o editarlos.",
            profileNameHint: "Se guardará como “nombre 1”, “nombre 2”, …",
            endDateHint: "Se calcula con la fecha de contratación y los días del plan.",
            profilePriceHint: "Precio de venta de la cuenta dividido entre el número de perfiles.",
            editProfile: "Ajustar perfil",
            editSlot: "Ajustar puesto",
            seeAllProfiles: "Ver todos",
            generatePin: "Generar PIN",
            overdue: "Vencida",
            expiredBlocksAvailable: "Una cuenta vencida no puede estar disponible. Renueva las fechas o déjala en falla/reposo.",
            botPublish: "Publicar en la tienda del bot",
            botPublishHint: "Si está activo, el bot de WhatsApp/Telegram puede vender esta cuenta cuando haya stock libre.",
            botPublishBlocked: "En falla o reposo la cuenta no se publica en ninguna tienda.",
            siteLoginHint: "Crea los puestos y luego edita cada uno para cargar URL, usuario y contraseña del sitio del cliente.",
            deleteSlot: "Eliminar puesto",
            deleteSlotConfirm: "¿Eliminar este puesto libre? No se puede deshacer.",
            deleteSlotBusy: "Solo se pueden eliminar puestos libres (sin cliente).",
            allProducts: "Todos los servicios",
            allSuppliers: "Todos los proveedores",
            allCountries: "Todos los países",
            filterService: "Servicio",
            filterSupplier: "Proveedor",
            filterCountry: "País",
            emailsBulkHint: "Un correo por línea. Opcional: correo,contraseña. El costo del lote se reparte entre las unidades.",
            lotHint: "Si compraste un lote (ej. 10 correos), anota cuántas unidades trae el costo.",
            unitCost: "Costo por unidad",
            remainingOne: "1 día",
            remainingN: "{n} días",
            daysOf: "{left} de {total} días",
            stock: "Stock",
            orders: "Órdenes",
            detail: "Detalle de cuenta",
            accountSales: "Ventas de esta cuenta",
            noSales: "Aún no hay ventas en esta cuenta.",
            updateNotifyTitle: "¿Enviar actualización a los clientes?",
            updateNotifyBody:
              "Hay {count} servicio(s) contratado(s) con esta cuenta. Se enviará el mensaje de actualización por WhatsApp (prioridad) y también por Telegram si el cliente lo tiene.",
            updateNotifySend: "Enviar ahora",
            updateNotifyDone: "Actualización enviada: {sent} mensaje(s) para {total} cliente(s).",
            filters: {
              available: "Disponibles",
              occupied: "Vendidas",
              expiring: "Por vencer",
              expired: "Vencidas",
              fault: "En falla",
              pending: "Pendientes",
              renew: "Por renovar",
            },
            import: {
              action: "Importar",
              title: "Importar cuentas",
              formatTitle: "CSV con encabezado. Ejemplo:",
              formatSample: "producto,correo,contraseña,costo,precio,inicio,dias,tipo,proveedor",
              ruleProduct: "producto debe coincidir con el nombre de un producto existente.",
              ruleEmail: "correo y contraseña son obligatorios.",
              rulePass: "tipo: profile o full (cuenta completa).",
              ruleOptional: "Opcional: costo, precio, inicio (YYYY-MM-DD), dias, slots, proveedor, url, ip, pais, pin.",
              ruleDupes: "Si el mismo correo ya existe en ese producto, se omite.",
              ruleMax: "Máximo 500 filas por archivo.",
              pickFile: "Elegir archivo CSV",
              dropHint: "CSV o texto separado por comas/punto y coma.",
              empty: "El archivo no tiene filas válidas.",
              maxSize: "El archivo supera 5 MB.",
              done: "Importadas {created}. Omitidas {skipped}.",
            },
            saleTypes: {
              profile: "Venta por perfil",
              profileHint: "Se crean perfiles libres para vender uno a uno.",
              member: "Venta por miembro",
              memberHint: "Se invitan miembros uno a uno, sin PIN.",
              device: "Venta por dispositivo",
              deviceHint: "Cada puesto es un dispositivo. No se asignan más del tope.",
              full: "Cuenta completa",
              fullHint: "Se vende la cuenta entera, sin perfiles.",
            },
            profileStatus: {
              available: "Libre",
              occupied: "Ocupado",
            },
            durations: {
              14: "14 días",
              20: "20 días",
              30: "1 mes",
              60: "2 meses",
              90: "3 meses",
              180: "6 meses",
              365: "1 año",
            },
            billingType: {
              title: "Tipo de facturación",
              hintAutopay: "Autopagable: no cuesta cada mes, se renueva sola. Aunque quede en días negativos sigue funcionando. Puedes anotar un costo de adquisición (pago único) o dejarlo vacío.",
              hintCost: "De costo: la compras a un proveedor y la renuevas cada mes pagando un monto. Cuando vence te avisamos para renovarla.",
              autopay: "Autopagable",
              autopaySub: "Se renueva sola",
              cost: "De costo",
              costSub: "Renuevas cada mes",
              unlimited: "Ilimitado — se renueva sola, no hay fecha que seguir.",
              unlimitedShort: "Ilimitado",
            },
            costAutopay: "Costo (opcional · pago único)",
            costMonthly: "Costo (renovación mensual)",
            pinDisabledHint: "Esta cuenta tendrá perfiles sin PIN.",
            currencyHint: "Puedes cargar compra o venta en moneda principal o en divisa. Siempre se guarda y se muestra en las dos.",
            salePrice: "Precio de venta",
            salePriceHint: "Lo que cobras al cliente por perfil o por cuenta completa a 30 días. Se calcula del costo de venta más el % de ganancia, y puedes ajustarlo.",
            purchaseCost: "Costo de compra",
            purchaseCostHint: "Lo que pagas al proveedor al comprar o renovar esta cuenta. Si cada mes pagas lo mismo, el costo de renovación es este mismo valor.",
            unitCost30: "Costo de venta (30 días)",
            unitCost30Hint: "Costo de compra llevado a 30 días y dividido entre los perfiles. Si la cuenta se paga por año, primero se saca el costo de 30 días y luego se divide.",
            suggestedSale: "Precio sugerido ({pct}% ganancia): {price}",
            deviceLimitHint: "Solo para productos por dispositivos (CapCut, IPTV). Indica cuántos dispositivos caben en esta cuenta. No aplica en venta de cuenta completa tipo Netflix.",
            licenseCount: "Códigos o links disponibles",
            licenseCountHint: "Cuántos códigos o links quedan en esta cuenta de panel. Se restan al vender.",
            autopayDurationHint: "Sirve para calcular el costo de 30 días. La cuenta no vence sola.",
          },
          products: {
            title: "Productos",
            subtitle: "Catálogo: entrega, plan y garantía. El precio al cliente se pone en cada cuenta.",
            emptyTitle: "Crea el primer producto",
            empty: "Ejemplo: Netflix. Luego le asignas cuentas y perfiles.",
            namePlaceholder: "Ej: Netflix, Disney+, HBO Max…",
            noDescription: "Sin descripción",
            announce: {
              action: "Aviso a clientes",
              title: "Mensaje a clientes del producto",
              hint: "Avisa fallas generales, cambios de precio, nuevas condiciones u otro mensaje con formato. Se envía por WhatsApp o Telegram según el contacto de cada cliente.",
              onlyActive: "Solo clientes con servicio activo",
              loadingAudience: "Contando destinatarios…",
              audience: "{total} destinatarios ({wa} WhatsApp · {tg} Telegram)",
              message: "Mensaje",
              empty: "Escribe el mensaje antes de enviar",
              send: "Enviar aviso",
              sending: "Enviando…",
              sent: "Aviso enviado a {sent} de {total} clientes",
              partialErrors: "{n} envíos fallaron (revisa logs)",
            },
            preset: "Configurar como…",
            presetHint: "Elige el modelo: define cómo se vende y qué datos lleva cada puesto.",
            giftCardCostHint: "Lo que pagas por cada código. Puedes cargarlo en moneda principal o en divisa; se guardan las dos.",
            giftCardPriceHint: "Lo que cobras por cada código. Puedes cargarlo en moneda principal o en divisa; se guardan las dos.",
            openSite: "Abrir sitio del producto",
            serviceUrlHint: "Al hacer clic en el logo se abre esta URL para iniciar sesión.",
            botSellable: "Vender por el bot (WA / Telegram)",
            activationMode: "Activación tras el pago",
            activationModeHint: "Manual: el bot notifica al admin aunque Binance confirme el pago.",
            activationAuto: "Automática (entrega de cuenta)",
            activationManual: "Manual (asesor activa)",
            slotKind: "Espacio que se vende",
            availableShort: "{n} disp.",
            managePlans: "Gestionar planes en Configuración",
            planHint: "Elige un plan o escribe uno nuevo abajo.",
            addPlanInline: "Nuevo plan",
            addPlanInlineBtn: "Agregar plan",
            addPlanInlineHint: "Se guarda en el catálogo y queda disponible al instante.",
            createAccounts: "Crear cuenta(s)",
            createAccountsHint: "Abre el formulario de inventario para este producto (una o varias).",
            addAnotherAccountTitle: "¿Crear otra cuenta?",
            addAnotherAccountBody: "La cuenta ya quedó guardada. ¿Quieres agregar otra para este producto?",
            addAnotherAccountYes: "Sí, otra cuenta",
            addAnotherAccountNo: "Listo",
            ownership: {
              title: "Tipo de venta",
              hint: "Alquiler: el cliente usa correo y clave de una cuenta del inventario. Dominio: el servicio se entrega al correo del cliente. Completa: se entrega la cuenta entera, sin perfiles.",
              rental: "Alquiler",
              rentalHint: "Cuenta compartida: correo, clave y perfil. También puedes vender la cuenta completa desde cada unidad de inventario.",
              domain: "Dominio",
              domainHint: "Se vende al correo del cliente (invitación o miembro). No comparte la clave maestra.",
              full: "Cuenta completa",
              fullHint: "Se entrega correo y contraseña de toda la cuenta. No hay perfiles ni PIN.",
            },
            presets: {
              streaming: "Streaming con perfiles (Netflix, Max, Disney)",
              fullAccount: "Cuenta completa (correo y clave, sin perfiles)",
              iptv: "IPTV / Flujo (usuario, contraseña y URL)",
              hostingSites: "Hosting / sitios web (cuenta madre + puestos URL, usuario y clave)",
              family: "Familiar por invitación (Spotify, YouTube)",
              canvaEdu: "Canva EDU / miembro por correo",
              capcut: "Por dispositivos (CapCut)",
              code: "Código o link (VPN, IA, Recargas de pin)",
              panel: "Códigos o links generados al asociar (panel)",
              recharge: "Recarga por ID (Free Fire)",
              mailbox: "Correos sueltos (Gmail, Outlook)",
            },
            fulfillment: {
              title: "Cómo se entrega",
              credentials: "Alquiler (correo y clave)",
              invite: "Dominio (al correo del cliente)",
              code: "Código o link",
              panel: "Panel",
              device: "Por dispositivos",
              recharge: "Recarga a un ID",
              mailbox: "Correo entregado",
              license: "Licencia / servicio",
              giftcard: "Gift card",
            },
            slotKinds: {
              none: "Sin puestos (cuenta, código o recarga)",
              noneHint: "Se vende la unidad completa, no hay grilla de perfiles.",
              pin_profile: "Perfil con PIN",
              pin_profileHint: "Puestos con nombre y PIN opcional, como Netflix o Max.",
              email_member: "Miembro por correo",
              email_memberHint: "El puesto se invita al correo del cliente. Sin PIN.",
              device: "Dispositivo",
              deviceHint: "Cada puesto es un dispositivo (CapCut, IPTV).",
              site_login: "Sitio web (URL + usuario + clave)",
              site_loginHint: "Hosting madre: cada puesto es la página del cliente con su URL, usuario y contraseña.",
            },
            logoType: "El logo debe ser JPG, PNG o WebP.",
            logoSize: "El logo no puede superar 2 MB.",
            remove: "Eliminar",
            createVariant: "Crear variante de plan",
            variantOf: "Variante de",
            variantHint: "Agrupa planes (Standard, Familiar, 1 dispositivo) bajo el mismo producto.",
            warrantyHint: "Días de garantía que salen en el mensaje al cliente. Déjalo vacío si no aplica.",
            priceHint: "Precio al público (lo que cobras). Se guarda en la moneda principal y se muestra también en divisa según la tasa.",
            lotHint: "Tamaño típico de compra al proveedor (ej. lote de 10 correos).",
            durationPlans: {
              generate: "Crear planes 1 mes / 3 meses / 1 año",
              hint: "Guarda el producto y luego genera las variantes de duración.",
              saveFirst: "Guarda el producto antes de generar los planes de duración.",
              month: "1 mes",
              quarter: "3 meses",
              year: "1 año",
              exists: "Este producto ya tiene las variantes de 1 mes, 3 meses y 1 año.",
              created: "Se crearon {n} plan(es) de duración.",
            },
            codes: {
              title: "Stock de códigos (uno por línea)",
              hint: "Pega PIN, VPN o licencias. En la venta se toma uno solo.",
              generatedHint: "Estos códigos se crean al asociar en la plataforma. Anota cuántos quedan en cada cuenta; no se precargan aquí.",
              stock: "{n} código(s) disponibles. Los que pegues ahora se suman al stock.",
              stockLabel: "Códigos disponibles",
              empty: "No hay códigos en stock. Pega uno aquí o cárgalos en el producto.",
              needStock: "No hay códigos en stock para este producto.",
            },
          },
          catalog: {
            slots: {
              profile: { one: "Perfil", plural: "Perfiles", max: "Máximo de perfiles" },
              member: { one: "Miembro", plural: "Miembros", max: "Máximo de miembros" },
              device: { one: "Dispositivo", plural: "Dispositivos", max: "Máximo de dispositivos" },
              site: { one: "Sitio", plural: "Sitios", max: "Máximo de sitios" },
              unit: { one: "Unidad", plural: "Unidades", max: "Unidades" },
            },
            offerTypes: {
              profile: "Perfil",
              full: "Completa",
              domain: "Dominio",
              device: "Dispositivo",
              mailbox: "Correo",
              code: "Código",
              recharge: "Recarga",
            },
          },
          combos: {
            title: "Combos",
            subtitle: "Paquetes a precio especial, con cuentas vigentes.",
            emptyTitle: "Aún no hay combos",
            empty: "Crea un paquete de 2 a 6 productos. Si le pones duración, se elimina solo al vencer.",
            noDescription: "Sin descripción",
            included: "Productos incluidos",
            rangeHint: "Selecciona entre 2 y 6 productos con cuentas vigentes.",
            maxProducts: "El combo admite máximo 6 productos.",
            noEligible: "No hay productos con cuentas vigentes (más de 3 días) para este tipo.",
            viableAccounts: "cuentas vigentes",
            permanent: "Permanente",
            permanentHint: "Este combo no caduca.",
            until: "Hasta",
            validity: "Vigencia",
            typeProfileHint: "Solo productos con cuentas de venta por perfil y más de 3 días.",
            typeFullHint: "Solo productos con cuentas completas y más de 3 días.",
            priceHint: "Precio del paquete al cliente. Escríbelo en moneda principal o en divisa.",
          },
          suppliers: {
            title: "Proveedores",
            subtitle: "Quién te vende las cuentas. Teléfono, Telegram y notas.",
            emptyTitle: "Sin proveedores",
            empty: "Agrega un proveedor si compras cuentas a terceros. Puedes saltarte este paso.",
            search: "Buscar proveedor…",
            phoneHint: "Código de país y número, sin + ni espacios. Ejemplo: 573001234567",
            openAccounts: "Ver cuentas",
            linkedAccounts: "Cuentas asociadas",
            noAccounts: "Sin cuentas asociadas",
            noAccountsHint: "Cuando vincules cuentas a este proveedor aparecerán aquí.",
          },
          codes: {
            lookup: "Consultar código",
            lookupTitle: "Resultado de la consulta",
            copied: "Código copiado",
            copiedLink: "Enlace copiado",
            found: "Código encontrado",
            linkFound: "Link encontrado",
            bothFound: "Código y link encontrados",
            newSearch: "Nueva búsqueda",
            share: "Compartir",
            preview: "Correo",
            empty: "No hay un código reciente para este correo.",
            noSubject: "Sin asunto",
            imapHint: "Conecta hasta 4 bandejas que reciben los códigos. Elige Gmail, Hotmail, Outlook o tu dominio. Solo se muestran las que están activas.",
            addServer: "Agregar servidor",
            inactiveServers: "Servidores desactivados",
            serverType: "Tipo de servidor",
            serverDomain: "Dominio propio",
            domainHostRequired: "Escribe el host IMAP de tu dominio.",
            gmailGuide: "1) Activa la verificación en 2 pasos de Google. 2) Abre el enlace y crea una clave de aplicación. 3) Pega aquí esa clave de 16 caracteres, no la contraseña de Gmail.",
            gmailAppLink: "Generar clave de aplicación",
            gmailTwoStepLink: "Activar verificación en 2 pasos",
            hotmailGuide: "Activa IMAP en Outlook en la web, crea una clave de aplicación y pégala aquí. El servidor queda en imap-mail.outlook.com, puerto 993.",
            appPasswordLink: "Crear clave de aplicación",
            outlookGuide: "El servidor queda en outlook.office365.com, puerto 993. Si la cuenta es de una empresa, el administrador debe permitir IMAP. Si pide clave de aplicación, créala en la cuenta de Microsoft.",
            domainGuide: "Escribe el host que te da el hosting (casi siempre mail.tudominio.com), el puerto 993 y la contraseña del buzón.",
            yopTitle: "Servidores Yopmail",
            yopHint: "Para cuentas cuyos correos llegan a Yopmail: solo escribe la dirección de la bandeja. Se consulta con navegador automático y se aplican los mismos asuntos y la misma ventana de tiempo que en IMAP. Si el correo de la cuenta ya es @yopmail.com, se consulta esa bandeja directamente aunque no la agregues aquí.",
            yopEmail: "Correo de Yopmail (bandeja)",
            yopRequired: "Escribe el correo de Yopmail",
            yopOk: "Bandeja de Yopmail abierta correctamente",
            imapOk: "Conexión IMAP correcta",
            mailbox: "Bandeja",
            server: "Servidor",
            lastOk: "Última conexión correcta",
            user: "Usuario IMAP",
            userPlaceholder: "correo@gmail.com",
            userRequired: "El usuario IMAP es obligatorio.",
            password: "Contraseña",
            passwordApp: "Contraseña / App Password",
            passwordKeep: "Nueva contraseña (dejar vacío para no cambiar)",
            passwordConfigured: "Configurada",
            passwordHint: "Contraseña guardada. Puedes probar la conexión o cambiarla por una nueva.",
            passwordHintNew: "Usa la contraseña de aplicación de Gmail, no la clave de la cuenta.",
            passwordRequired: "Escribe la contraseña de aplicación para probar esta bandeja.",
            host: "Host IMAP",
            port: "Puerto",
            portHint: "Puerto (993)",
            secure: "SSL/TLS",
            test: "Probar conexión",
            testing: "Probando…",
            testHint: "Prueba host, puerto, usuario y contraseña antes de guardar cambios.",
            messagesCount: "{n} mensajes en la bandeja",
            removeMailbox: "Eliminar bandeja",
            operatorTitle: "Probar búsqueda",
            operatorHint: "Solo correos no leídos de los últimos 20 minutos. Un código o enlace viejo ya no sirve.",
            email: "Correo de la cuenta",
            filters: "Filtros de consulta",
            filtersHint: "Asuntos que deben aparecer en el correo. Actívalo para usarlo en la búsqueda.",
            subject: "Asunto / condición",
            active: "Activo",
            useInSearch: "Usar",
            addFilter: "Agregar asunto",
            removeFilter: "Eliminar asunto",
            landingUrl: "Enlace de consulta",
            landingHint: "El cliente abre esta página y ve solo sus correos. El final del enlace es un nombre corto.",
            linkName: "Nombre al final del enlace",
            linkNameHint: "Queda como /codigos/ese-nombre. Si lo dejas vacío, se arma con el nombre del cliente.",
            saveLinkName: "Guardar nombre",
            randomLinkName: "Generar con el nombre del cliente",
            linkShapeHint: "El enlace de cada cliente se arma con su nombre. En la configuración del servicio puedes escribir el nombre final o generarlo al azar junto al nombre.",
            generating: "Creando enlace…",
            optionalPortal: "Usuario y clave de un portal externo (opcional)",
            externalPortal: "Portal externo",
            externalPortalHint: "Solo si usas otra página.",
            serviceSubjects: "Asuntos de consulta",
            serviceSubjectsHint: "Solo se buscan estos asuntos en el correo de la cuenta de este servicio.",
            noProductSubjects: "Este producto no tiene asuntos. Configúralos en Productos.",
          },
          binance: {
            hint: "Conecta tu Binance Pay con API Key de solo lectura. Al guardar una venta sin pagar con método Binance, el sistema reserva un importe exacto en USDT y lo confirma solo cuando llega el pago.",
            setup: "1) En Binance crea una API Key con Enable Reading, sin retiros ni trading. 2) Pega API Key, Secret y Pay ID. 3) Activa el cobro y pulsa Probar conexión.",
            apiLink: "Abrir API Management",
            assignHint: "Crea un método de pago llamado Binance y asígnalo solo a los clientes que pagan así. Ellos lo verán al recargar saldo y el pago se acredita solo.",
            enabled: "Activar cobro automático Binance Pay",
            apiKey: "API Key",
            apiSecret: "API Secret",
            apiKeyHint: "En Binance → API Management: solo Enable Reading. Sin retiros ni trading.",
            apiSecretHint: "Se guarda cifrado. Déjalo vacío para no cambiar el actual.",
            keySet: "Ya configurada — pega una nueva solo si la cambias",
            payId: "Pay ID / Binance ID",
            payIdHint: "El ID que el cliente usa en Binance Pay para enviarte USDT.",
            qrUrl: "URL del QR",
            uploadQr: "Subir QR",
            qrUploaded: "QR cargado",
            test: "Probar conexión",
            testOk: "API Key válida (solo lectura)",
            validatedAt: "Última validación: {date}",
            checkoutTitle: "Cobro Binance Pay",
            exactAmount: "Paga exactamente este importe en USDT",
            amount: "Importe USDT",
            copy: "Copiar",
            copied: "Copiado",
            copyFail: "No se pudo copiar",
            checkoutHint: "El sistema revisa el historial cada minuto. También puedes pegar el Order ID si el cliente ya pagó.",
            expires: "Vence {date}.",
            orderId: "Order ID / Transaction ID",
            orderIdHint: "Opcional: si el auto-detect no llega, pega el ID del pago en Binance.",
            confirmOrder: "Confirmar Order ID",
            refresh: "Actualizar",
            paid: "Pago confirmado",
            openCheckout: "Cobro Binance",
            validateTitle: "Validar pago Binance",
            validateHint: "Pega el Order ID que te envió el cliente para confirmar el cobro.",
            validateOrderHint: "Order ID o Transaction ID del pago en Binance Pay.",
          },
          payments: {
            title: "Métodos de pago",
            subtitle: "Nequi, transferencia u otro medio. Actívalo o desactívalo.",
            emptyTitle: "Sin métodos de pago",
            empty: "Nequi, transferencia, USDT u otro medio con el que te pagan.",
          },
          settings: {
            subtitle: "Usuarios, moneda, pagos, mensajes, recordatorios y condiciones.",
            tabs: {
              users: "Usuarios",
              plans: "Planes",
              currency: "Moneda",
              payments: "Pagos",
              messages: "Mensajes",
              reminders: "Recordatorios",
              terms: "Condiciones de uso",
              raffle: "Sorteo mensual",
              points: "Saldo",
              loyalty: "Fidelización",
              codes: "Códigos",
              bot: "Bot WA / Telegram",
              migrate: "Migrar AppSheet",
              binance: "Binance Pay",
            },
            paymentsUnifiedHint: "Moneda, tasa, ganancia y métodos de cobro del negocio.",
            messagesUnifiedHint: "Plantillas de entrega/renovación y recordatorios automáticos de vencimiento.",
            loyaltyHint: "Cashback en saldo por compra y sorteo mensual para fidelizar clientes.",
            paymentMethodsTitle: "Métodos de pago",
            codesHint: "Hasta 4 bandejas IMAP y una prueba de búsqueda. Los filtros de asunto se configuran en cada producto.",
            botHint: "Activa el bot estilo tienda (Shop) en WhatsApp y/o Telegram por separado. En Telegram usa token de @BotFather para botones nativos.",
            migrateHint: "Importa el Excel de AppSheet / StreamDigi (Base.xlsx) a este negocio: productos, cuentas, perfiles, clientes, ventas, suscripciones y puntos.",
            migrateSheets: "Hojas que se leen: Productos, Proveedores, M_Pago, Cuentas, Perfiles, Cliente, Ventas, Base, Control_Ingresos, Puntos.",
            migratePickFile: "Elegir Excel (.xlsx)",
            migrateChangeFile: "Cambiar archivo",
            migrateReplace: "Reemplazar datos actuales del negocio",
            migrateReplaceHint: "Si está activo, borra productos, cuentas, ventas y suscripciones de esta empresa antes de cargar. Ajustes (bot, IMAP, recordatorios) se conservan.",
            migratePreview: "Vista previa",
            migrateRun: "Migrar ahora",
            migratePreviewTitle: "Vista previa del archivo",
            migrateResultTitle: "Resultado de la migración",
            migrateMissingSheets: "Faltan hojas obligatorias en el Excel.",
            migratePreviewOk: "Archivo válido. Revisa los conteos y ejecuta la migración.",
            migrateReady: "Listo para migrar",
            migrateMissing: "Faltan",
            migrateDone: "Migración completada",
            migrateStarted: "Migración iniciada en el servidor. Puede tardar unos minutos; no la repitas.",
            migrateFailed: "La migración falló",
            migrateConfirmTitle: "¿Migrar base AppSheet?",
            migrateConfirmReplace: "Se reemplazarán los datos actuales del negocio con el Excel. Esta acción no se puede deshacer.",
            migrateConfirmKeep: "Se agregarán los datos del Excel sobre lo existente. Puede generar duplicados si ya migraste antes.",
            botEnabled: "Bot activo",
            botWhatsappEnabled: "Bot activo en WhatsApp",
            botTelegramEnabled: "Bot activo en Telegram",
            botPromoEnabled: "Mostrar atajo PROMO en el menú",
            botGuidedOnly: "Solo menú guiado (sin texto libre del cliente)",
            botWalletEnabled: "Monedero del cliente (pagar / renovar con saldo)",
            botRatingEnabled: "Pedir calificación tras la entrega (encuesta 1-3)",
            botShopName: "Nombre de la tienda",
            botShopNameHint: "Se muestra en bienvenida y en el recibo de entrega (ej. KOKORO SHOP).",
            botTelegramToken: "Token del bot de Telegram (@BotFather)",
            botTelegramTokenHint: "Crea el bot con @BotFather, pega el token aquí y guarda. El sistema inicia long-polling automáticamente.",
            botTelegramTokenHintSet: "Token guardado. Deja vacío para no cambiarlo. Bot activo:",
            botTest: "Probar bot Telegram",
            botTestRunning: "Probando…",
            botTestOk: "Bot Telegram activo",
            botTestFail: "No se pudo verificar el bot",
            botTestHintApi:
              "Con token configurado, el shop solo responde en @tu_bot (Bot API). La cuenta de usuario de Telegram ya no manda el menú (evita bucles con BotFather). WhatsApp sigue igual.",
            botAdminNumber: "WhatsApp del admin (alertas)",
            botAdminNumberHint: "Recibe pedidos nuevos, pagos a validar y escalados de soporte.",
            botAdminTelegram: "Usuario Telegram del admin",
            botAdminTelegramHint: "Sin @. Ejemplo: miusuario. Requiere conexión Telegram activa.",
            botSalesQueue: "Departamento Ventas",
            botSupportQueue: "Departamento Soporte",
            botQueueNone: "Sin departamento",
            botQueueHint: "Lista de Configuración → Departamentos. Al escalar, el ticket queda en ese departamento (pendiente).",
            botQueueEmpty: "No hay departamentos. Créalos en Configuración → Departamentos.",
            botWelcome: "Mensaje de bienvenida",
            botWelcomeHint: "Usa negrita/cursiva, variables y una imagen. Vista previa a la derecha. Vacío = saludo automático tipo tienda.",
            botWelcomePlaceholder: "Ej: ¡Hola {{nombre_cliente}}! 👋 Bienvenido a StreamDigi…",
            varCustomerName: "Nombre completo",
            varFirstName: "Primer nombre",
            binanceHint: "API Key de solo lectura, Pay ID y QR para cobrar USDT en automático.",
            usersHint: "WhatsApp con el que cada usuario envía los mensajes del negocio.",
            plansHint: "Nombres de plan que salen al crear un producto: Standard, Familiar, EDU, 1 pantalla…",
            planName: "Nombre del plan",
            addPlan: "Agregar plan",
            resetPlans: "Restaurar lista",
            noPlans: "Sin planes. Agrega uno o restaura la lista predeterminada.",
            noUsers: "No hay usuarios",
            noUsersHint: "Asigna una conexión a cada usuario de la empresa.",
            whatsapp: "Conexión WhatsApp",
            currencyHint: "Moneda principal, símbolo, tasa frente a la divisa y porcentaje de ganancia.",
            currencyLocal: "Moneda local",
            currencyFx: "Divisa",
            currencySymbol: "Símbolo",
            currencyLocalHint: "La moneda en que se guarda el precio al público. La divisa se calcula con la tasa.",
            currencyFxHint: "La moneda secundaria (divisa) contra la que se cruza la tasa (casi siempre USD).",
            currencySymbolHint: "Se muestra junto a los precios. Ejemplo: $ 10.000",
            profitPercent: "% de ganancia",
            profitPercentHint: "El precio de venta de cada perfil o cuenta completa = costo de venta × (1 + este %). Ejemplo: 50 = cobrar 50% sobre el costo.",
            timezoneTitle: "Zona horaria",
            timezoneHint: "Periodos, vencimientos, programaciones y cualquier fecha/hora del negocio usan esta zona, la misma de Configuración. No usa la del servidor ni la del navegador.",
            timezoneChange: "Cambiar en Configuración",
            exchangeRate: "Tasa de cambio (local por 1 divisa)",
            binanceTtlHours: "Plazo cobro Binance (horas)",
            binanceTtlHoursHint: "Tiempo que el cliente tiene para pagar el USDT exacto (6–168 h). Default 72.",
            fetchRate: "Actualizar tasa",
            fetchingRate: "Consultando…",
            rateUpdated: "Tasa del día",
            rateCached: "Tasa de hoy (ya consultada)",
            rateDaily: "Edita la tasa y guarda para aplicarla en todo el módulo. Para consultar la tasa actual, pulsa Actualizar tasa y luego Guardar.",
            rateInvalid: "Ingresa una tasa de cambio mayor que cero.",
            rateError: "No se pudo consultar la tasa ahora. Revisa la conexión o escríbela a mano y guarda.",
            example: "Ejemplo de cruce",
            messagesHint: "Textos al vender, renovar o avisar vencimiento. Si hay cobro Binance pendiente, se anexa el mensaje de pago.",
            generalMessages: "Mensajes generales",
            productOverride: "Puedes dejarlos vacíos para usar el mensaje general, o escribir uno propio de este producto.",
            saleMessage: "Datos de compra (al asignar)",
            renewMessage: "Mensaje de renovación",
            expireMessage: "Alerta de vencimiento",
            reminderWalletMessage: "Añadir mensaje de saldo disponible",
            reminderWalletMessageHint: "Envía un mensaje adicional si el saldo alcanza para renovar al menos un servicio.",
            pointsMessage: "Saldo del cliente",
            updateMessage: "Datos actualizados del servicio",
            payMessage: "Instrucciones de pago (Binance / pendiente)",
            pointsMessagePlaceholder: "Mensaje con el saldo actual del monedero del cliente.",
            pointsMessageHint: "Se envía al tocar el saldo del cliente (Clientes, carrito y ficha del cliente). También se usa en los recordatorios cuando el saldo alcanza para renovar.",
            pointsEarnedEnabled: "Enviar mensaje de saldo ganado (cashback) al entregar un pedido",
            pointsEarnedMessage: "Saldo ganado por compra",
            pointsEarnedMessagePlaceholder: "Cashback abonado en la compra y saldo disponible. Variables: {{saldo_ganado}} {{saldo}} {{servicios_compra}}.",
            pointsEarnedHint: "Se envía como mensaje aparte, justo después de enviar los datos de las cuentas, solo si la compra quedó pagada y generó cashback. Usa {{saldo_ganado}} y {{saldo}}.",
            updateMessagePlaceholder: "Se envía solo si editaste un servicio (no en renovaciones).",
            saleMessagePlaceholder: "Datos de la cuenta que recibe el cliente al comprar.",
            renewMessagePlaceholder: "Texto cuando se renueva el servicio.",
            expireMessagePlaceholder: "Aviso antes o al vencer.",
            payMessagePlaceholder:
              "Se anexa al enviar datos o renovar si la venta está sin pagar por Binance. Variables: {{usdt}} {{pay_id}} {{vence_pago}}.",
            messagePlaceholder: "Toca una variable e inserta el texto. Se reemplaza al enviar.",
            saveTemplates: "Guardar plantillas",
            preview: "Vista previa",
            previewEmpty: "Escribe un mensaje para ver la vista previa.",
            attached: "Archivo adjunto",
            removeMedia: "Quitar",
            newReminder: "Nuevo recordatorio",
            remindersHint: "Avisos días antes, el mismo día o después del vencimiento, a la hora configurada.",
            noReminders: "Sin recordatorios",
            noRemindersHint: "Crea uno con días antes, el mismo día (0) o días después del vencimiento (negativo).",
            when: "Cuándo",
            daysOffset: "Días según vencimiento",
            reminderType: "Tipo de recordatorio",
            reminderExpiration: "Vencimiento del servicio",
            reminderPayment: "Falta de pago",
            reminderExpirationHint: "Se envía según la fecha de vencimiento del servicio.",
            reminderPaymentHint: "Solo servicios con una venta pendiente de pago. Deja de enviarse al registrar el pago.",
            paymentDays: "Días desde la venta pendiente",
            paymentDaysHint: "0 = desde el día de la venta. 3 = desde el tercer día sin pago. No depende del vencimiento del servicio.",
            paymentDaysSummary: "Desde {{n}} día(s) sin pago",
            paymentFrequencyOnce: "Una vez por pago pendiente",
            paymentFrequencyHint: "Diario: recuerda mientras siga pendiente. Una vez: cada venta pendiente recibe un solo aviso.",
            daysOffsetHint: "3 = tres días antes. 0 = el mismo día. -3 = tres días vencido.",
            daysBefore: "{{n}} días antes",
            daysAfter: "{{n}} días vencido",
            daysSame: "El día del vencimiento",
            frequency: "Frecuencia",
            frequencyDaily: "Todos los días",
            frequencyOnce: "Una sola vez",
            frequencyHint: "Diario: se envía cada día que cumpla la regla. Una vez: solo el primer día que coincida.",
            sendHour: "Hora de envío",
            sendHourHint: "Si varios recordatorios tienen la misma hora, se envían en el orden de esta lista.",
            notifyNumber: "WhatsApp de notificación",
            reminderName: "Nombre interno",
            reminderActive: "Activo",
            termsHint: "Texto que puedes enviar o publicar para el cliente.",
            raffleHint: "Tickets por compra o renovación, sorteo el día 1, premio de 30 días y mensajes al ganador.",
            raffleEnabled: "Habilitar sorteo",
            raffleDay: "Día del sorteo",
            raffleDayHint: "El día 1 sortea las compras y renovaciones del mes anterior. Solo se guardan tickets si el sorteo está activo.",
            raffleLastDay: "Último día del mes",
            raffleWinnerMessage: "Mensaje al ganador",
            raffleWinnerPlaceholder: "Felicitaciones {{nombre_cliente}}. Ganaste el sorteo de {{mes}} con {{tickets_ganador}} tickets. Canjea 30 días antes del {{premio_vence}}.",
            raffleAnnounceMessage: "Anuncio a clientes con servicios activos",
            raffleAnnouncePlaceholder: "El ganador del sorteo de {{mes}} es {{nombre_ganador}}. Cada compra suma un ticket.",
            raffleReportNumber: "WhatsApp del informe",
            raffleReportNumberHint: "Número que recibe el informe del sorteo (ganador, tickets, enviados).",
            pointsHint: "Cashback en saldo: un % de cada compra o renovación pagada se abona al monedero del cliente. El saldo sirve para pagar compras y renovaciones.",
            pointsSystemEnabled: "Habilitar cashback en saldo",
            pointsEquivalence: "Equivalencia al otorgar (valor de venta ÷ este número)",
            pointsEquivalenceExample: "Ejemplo: {amount} ÷ {eq} = {points} puntos",
            cashbackPercent: "% de cashback",
            cashbackExample: "Ejemplo: una venta de {amount} abona {back} al monedero.",
            cashbackAbroad: "clientes de otros países:",
            pointsTermsTitle: "Condiciones del saldo / cashback",
            notifyHint: "Número que recibe aviso cuando este recordatorio envía mensajes.",
            reminderIncludePoints: "Incluir mensaje de saldo para renovar",
            reminderIncludePointsHint: "Solo se envía si el saldo del cliente alcanza para renovar al menos uno de los servicios del aviso. El mensaje indica para cuáles le alcanza (y si le alcanza para todos).",
            reminderExtraMessage: "Mensaje adicional",
            reminderExtraMessageHint: "Opcional. Se envía después del recordatorio principal (plantilla extra del script de referencia).",
            reminderMessage: "Mensaje",
            termsPlaceholder: "Escribe las condiciones de uso: vigencia, uso permitido, soporte y reembolsos.",
            rafflePlaceholder: "Escribe las reglas del sorteo: fecha, premio, clientes elegibles y cómo se anuncia el ganador.",
            pointsPlaceholder: "Explica cómo se gana saldo (cashback), cómo se usa para pagar y su vigencia. El Agente IA usa este texto.",
            cashbackTemplate: "Usar plantilla de cashback",
          },
        },
        setup: {
          products: {
            title: "Productos",
            desc: "Define qué vendes y a qué precio.",
            cta: "Crear producto",
          },
          payments: {
            title: "Métodos de pago",
            desc: "Indica cómo te pagan los clientes.",
            cta: "Agregar método",
          },
          accounts: {
            title: "Inventario",
            desc: "Carga correos, claves y perfiles listos para asignar.",
            cta: "Agregar cuenta",
          },
          sales: {
            title: "Primera venta",
            desc: "Elige un contacto, un producto y un perfil libre.",
            cta: "Agregar servicio",
          },
        },
        tabs: {
          dashboard: "Dashboard",
          subscriptions: "Suscripciones",
          sales: "Ventas",
          accounts: "Cuentas",
          products: "Productos",
          suppliers: "Proveedores",
          payments: "Métodos de pago",
        },
        new: {
          products: "Nuevo producto",
          product: "Nuevo producto",
          suppliers: "Nuevo proveedor",
          supplier: "Nuevo proveedor",
          payments: "Nuevo método",
          payment: "Nuevo método de pago",
          accounts: "Nueva cuenta",
          account: "Nueva cuenta",
          sales: "Nueva venta",
          sale: "Agregar servicio",
          customer: "Nuevo cliente",
          combo: "Nuevo combo",
        },
        kpi: {
          activeSubs: "Servicios activos",
          expiringSubs: "Vencen en 3 días",
          expiredSubs: "Vencidos",
          availableProfiles: "Perfiles libres",
          accounts: "Cuentas en inventario",
          products: "Productos",
          pendingSales: "Ventas por cobrar",
          monthTotal: "Ventas del mes",
          monthProfit: "Ganancia del mes",
          yearProfit: "Ganancia del año",
          weekProfit: "Esta semana",
          historicalProfit: "Total histórico",
          monthIncome: "Ingresos",
          monthCost: "Gastos",
        },
        cols: {
          contact: "Cliente",
          product: "Producto",
          account: "Cuenta",
          profile: "Perfil",
          endDate: "Vence",
          price: "Precio",
          status: "Estado",
          total: "Total",
          payment: "Pago",
          date: "Fecha",
          email: "Correo",
          supplier: "Proveedor",
          slots: "Perfiles libres",
          name: "Nombre",
          days: "Días",
          phone: "Teléfono",
          type: "Tipo",
          code: "Código",
          telegram: "Telegram",
          points: "Saldo",
          maxProfiles: "Máx. perfiles",
          accounts: "Cuentas",
          availableAccounts: "Disponibles",
          records: "Registros",
          activeAccounts: "Activas",
          password: "Contraseña",
          profiles: "Perfiles",
          billing: "Facturación",
          remaining: "Restantes",
          service: "Servicio / combo",
          accountNumber: "Número / cuenta",
          plan: "Plan",
          country: "País",
          warranty: "Garantía",
          lot: "Lote",
          slots: "Puestos",
        },
        fields: {
          name: "Nombre",
          description: "Descripción",
          days: "Duración (días)",
          price: "Precio",
          cost: "Costo",
          phone: "Teléfono",
          prefix: "Prefijo",
          notes: "Notas",
          type: "Tipo",
          accountNumber: "Número de cuenta",
          reference: "Referencia",
          product: "Producto",
          supplier: "Proveedor",
          email: "Correo de la cuenta",
          loginUser: "Usuario",
          loginUserHint: "Usuario del panel IPTV/Flujo (no tiene que ser un correo).",
          panelUrl: "URL del panel (opcional)",
          panelUrlHint: "Ej: http://servidor:puerto — se envía al cliente en el mensaje de entrega.",
          hostingAccount: "Cuenta madre (identificador)",
          hostingAccountHint: "Nombre o código del hosting madre. Los datos del cliente van en cada puesto.",
          siteUrl: "URL del sitio",
          siteUrlHint: "Página web del cliente (ej. https://cliente.tudominio.com).",
          siteUser: "Usuario",
          siteUserHint: "Usuario de acceso a la página del cliente.",
          sitePassword: "Contraseña",
          pin: "PIN",
          password: "Contraseña",
          passwordKeep: "Déjalo vacío para no cambiarla",
          slots: "Cantidad de perfiles",
          startDate: "Inicio",
          none: "— Ninguno —",
          contact: "Contacto *",
          contactHint: "Escribe al menos 2 letras para buscar en Contactos.",
          profile: "Perfil a asignar",
          assignLater: "Asignar después",
          payment: "Método de pago",
          accountType: "Tipo de cuenta",
          identityNumber: "Número de ID",
          comment: "Comentario",
          customerType: "Tipo de cliente",
          telegram: "Usuario de Telegram",
          pointsEnabled: "Otorgar cashback (saldo) por compras",
          maxProfiles: "Máximo de perfiles",
          logo: "Logo (JPG, PNG o WebP, máx. 2 MB)",
          logoHint: "Se adapta a 200×200 px. Clic para subir.",
          serviceUrl: "URL del servicio (opcional)",
          isActive: "Producto activo",
          accountStatus: "Estado de la cuenta",
          saleType: "Tipo de cuenta",
          pinLength: "Caracteres del PIN",
          pinCustom: "PIN personalizado",
          pinEnabled: "PIN de perfiles",
          planLabel: "Plan (Standard, Familiar, EDU…)",
          originCountry: "País de la cuenta",
          deviceLimit: "Máximo de dispositivos",
          memberEmail: "Correo del miembro",
          deliveryCode: "Código o link de entrega",
          externalId: "ID de recarga",
          warrantyDays: "Días de garantía",
          lotSize: "Unidades del lote",
          parentProduct: "Variante de (producto padre)",
          emailsBulk: "Lote de correos (uno por línea)",
          mailboxEmail: "Correo a entregar",
          customProfileName: "Nombre de perfil personalizado",
          profileNamePrefix: "Nombre base del perfil",
          endDate: "Fecha final",
          profilePrice: "Costo de venta por perfil",
          comboPrice: "Precio del combo",
          isPermanent: "Combo permanente (no caduca)",
          durationDays: "Días de duración",
          ip: "IP",
        },
        status: {
          active: "Activo",
          pending: "Pendiente",
          pending_payment: "Por cobrar",
          paid: "Pagada",
          expired: "Vencido",
          cancelled: "Cancelado",
          fault: "En falla",
          idle: "Reposo",
          available: "Disponible",
          assigned: "Asignado",
          disabled: "Inactivo",
          expiring: "Por vencer",
          soon: "En 3 días",
          today: "Hoy",
          none: "Sin servicios",
          sold: "Vendido",
        },
      },
      toDoList: {
        title: "Tareas del Operador",
        loading: "Cargando tareas...",
        searchPlaceholder: "Buscar tareas...",
        stats: {
          total: "Total",
          pending: "Pendientes",
          completed: "Completadas",
          urgent: "Urgentes",
        },
        form: {
          newTask: "Nueva Tarea",
          editTask: "Editar Tarea",
          descriptionLabel: "Descripción de la tarea",
          descriptionPlaceholder: "Ej: Revisar configuración del servidor...",
          priority: "Prioridad",
          category: "Categoría",
          add: "Agregar Tarea",
          save: "Guardar Cambios",
          cancel: "Cancelar",
        },
        priority: { low: "Baja", medium: "Media", high: "Alta" },
        categories: {
          general: "General",
          urgent: "Urgente",
          followup: "Seguimiento",
          meeting: "Reunión",
          system: "Sistema",
          customer: "Cliente",
        },
        filters: {
          title: "Filtros",
          all: "Todas",
          allCategories: "Todas las categorías",
          allStatus: "Todos",
          status: "Estado",
          clear: "Limpiar filtros",
        },
        statusLabel: { pending: "Pendiente", completed: "Completada" },
        empty: {
          none: "No hay tareas creadas",
          noneHint: "Crea tu primera tarea usando el formulario de arriba",
          filtered: "No se encontraron tareas con los filtros aplicados",
          filteredHint: "Ajusta los filtros para ver más tareas",
        },
        details: {
          title: "Detalle de tarea",
          content: "Contenido",
          priority: "Prioridad",
          category: "Categoría",
          status: "Estado",
          id: "ID",
          createdAt: "Creación",
          updatedAt: "Última actualización",
          notAvailable: "No disponible",
          close: "Cerrar",
        },
        tooltips: {
          markPending: "Marcar como pendiente",
          markDone: "Marcar como completada",
          edit: "Editar tarea",
          delete: "Eliminar tarea",
        },
      },
      chat: {
        noTicketMessage: "Seleccione un ticket para comenzar a conversar.",
        buttons: {
          new: "Nuevo",
        },
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop: "ARRASTRE Y SUELTE ARCHIVOS EN EL CAMPO ABAJO",
          titleFileList: "Lista de archivo(s)",
        },
      },

      ticketsQueueSelect: {
        placeholder: "Departamentos",
      },
      ticketsManager: {
        buttons: {
          newTicket: "Nuevo",
          closeallTicket: "Cerrar",
          closedAllTickets: "¿Estás seguro de cerrar por completo todos los tickets?", // ✅ MEJORADO: Mensaje más claro y específico
        },
        confirmation: {
          title: "⚠️ Confirmación de cierre de tickets", // ✅ MEJORADO: Título con icono de alerta y más específico
          subtitle: "Esta acción cerrará TODOS los tickets abiertos de forma permanente", // ✅ AGREGADO: Subtítulo explicativo
          warning: "Esta acción no se puede deshacer", // ✅ AGREGADO: Advertencia adicional
          whichTicketsQuestion: "¿Qué tickets deseas cerrar?",
          noTicketsForOption: "No hay tickets para cerrar según la opción seleccionada",
          warningEmojiAria: "Advertencia",
          optionAttendingOpen: "ATENDIENDO (Abiertos)",
          optionPending: "PENDIENTE",
          optionBoth: "AMBOS (ATENDIENDO + PENDIENTE)",
        },
      },
      tickets: {
        inbox: {
          closedAllTickets: "¿Cerrar todos los tickets?",
          closedAll: "Cerrar Todos",
          newTicket: "Nuevo Ticket",
          yes: "SÍ",
          no: "NO",
          open: "Abiertos",
          resolved: "Resueltos",
        },
        toasts: {
          deleted: "La atención en la que estaba ha sido eliminada.",
        },
        notification: {
          message: "Mensaje de",
        },
        tabs: {
          open: { title: "Abiertas" },
          closed: { title: "Resueltos" },
          search: { title: "Búsqueda" },
        },
        search: {
          placeholder: "Buscar tickets y mensajes",
          filterConnections: "Filtro por conexiones",
          filterContacts: "Filtro por contacto",
          filterConections: "Filtro por Conexión",
          filterConectionsOptions: {
            open: "Abierto",
            closed: "Cerrado",
            pending: "Pendiente",
          },
          filterUsers: "Filtro por Usuarios",
          ticketsPerPage: "Tickets por página",
          searchMessagesTooltip: "Buscar también en el contenido de los mensajes (más lento)",
        },
        buttons: {
          showAll: "Todos",
        },
        managerTabs: {
          tooltips: {
            newTicket: "Crear nuevo ticket",
            resolveTickets: "Resolver tickets",
            showOpen: "Mostrar tickets abiertos",
            showClosed: "Mostrar tickets cerrados",
            filterByQueues: "Filtrar por departamentos",
            filterByTags: "Filtrar por etiquetas",
            activeFilters: "Ver filtros activos",
          },
          emptyQueues: "No hay departamentos disponibles",
          emptyTags: "No hay etiquetas disponibles",
          tabs: {
            groups: "GRUPOS",
            aiAgents: "AGENTES IA",
          },
        },
        filterPanel: {
          title: "Filtros",
          show: "Mostrar",
          hide: "Ocultar",
          departments: "Departamentos",
          tags: "Etiquetas",
          departmentsWithCount: "Departamentos ({{count}})",
          tagsWithCount: "Etiquetas ({{count}})",
          clearFilters: "Limpiar Filtros",
          emptyState: "No hay filtros activos. Selecciona departamentos o etiquetas arriba.",
        },
        welcome: {
          title: "Bienvenido a tu módulo de chat",
          subtitle: "Puedes abrir un nuevo chat o esperar a que se te asigne uno",
        },
        aria: {
          resizeTicketsPanel: "Redimensionar panel de tickets",
        },
        mobile: {
          bottomNav: {
            chat: "Chat",
            tickets: "Atenciones",
          },
        },
        searchResults: {
          searchAria: "Búsqueda",
          searching: "Buscando...",
          resultsFor: 'Resultados para "{{term}}"',
          noResults: "No se encontraron resultados",
          emptySection: "No hay resultados en esta sección.",
          total: "{{count}} en total",
          sections: {
            open: "ATENDIENDO",
            pending: "PENDIENTE",
            closed: "CERRADOS",
          },
        },
        // ✅ NUEVAS TRADUCCIONES PARA MENSAJES AUTOMÁTICOS
        automaticMessages: {
          title: "Mensaje Automático",
          callsDisabled:
            "Las llamadas de voz y video están deshabilitadas para este WhatsApp, favor enviar un mensaje de texto. Gracias",
          transferToDepartment:
            "Has sido transferido al departamento *{department}*\nespera, ya vamos a atenderte!",
          transferToAgent:
            "Has sido transferido al atendente *{agent}*\nespera, ya vamos a atenderte!",
          transferToDepartmentAndAgent:
            "Has sido transferido al departamento *{department}* y contarás con la presencia de *{agent}*\nespera, ya vamos a atenderte!",
          // ✅ MENSAJES DE ERROR DEL BACKEND
          pdfSendError: "No se pudo enviar el PDF, inténtalo nuevamente!",
          messageNotProcessable: "Mensaje no procesable",
          unrecognizedMessage: "Mensaje no reconocido",
          temporaryMessage: "Mensaje temporal",
          // ✅ PROMPTS DEL SISTEMA IA
          aiSystemPrompt:
            "En las respuestas utiliza el nombre {name} para identificar al cliente.\nTu respuesta debe usar máximo {maxTokens} tokens y cuida de no truncar el final.\nSiempre que sea posible, menciona su nombre para que el atendimiento sea más personalizado y educado. Cuando la respuesta requiere una transferencia para el sector de atendimiento, comienza tu respuesta con 'Acción: Transferir para el sector de atendimiento'.\n{prompt}\n",
          aiTransferMessage:
            "Lo siento, este agente IA no está asociado a un departamento específico. Por favor, contacta directamente con un agente humano.",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Escribe para buscar usuarios",
        fieldQueueLabel: "Transferir a departamento",
        fieldQueuePlaceholder: "Seleccione un departamento",
        fieldConnectionLabel: "Seleccione una conexión",
        fieldConnectionPlaceholder: "Seleccione una conexión",
        noOptions: "No se encontraron usuarios con ese nombre",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      transferConfirmationModal: {
        title: "Confirmar Transferencia",
        aiWarning: "El departamento {queueName} tiene activado AGENTE IA",
        promptInfo: "Prompt: {promptName}",
        aiQuestion:
          "¿Estás seguro de transferir? El ticket será atendido automáticamente por el agente IA.",
        humanQuestion: "¿Estás seguro de transferir al departamento {queueName}?",
        confirm: "Sí, Transferir",
        cancel: "Cancelar",
        transferring: "Transfiriendo...",
        successMessage: "Transferencia exitosa al departamento {queueName}",
      },
      ticketsList: {
        pendingHeader: "Pendiente",
        assignedHeader: "Atendiendo",
        allHeader: "Todos", // ✅ AGREGADO: Para pestaña "TODOS"
        noTicketsTitle: "¡Nada aquí!",
        noTicketsMessage: "No se encontraron tickets con este estado o término de búsqueda",
        buttons: {
          accept: "Aceptar",
          closed: "Finalizar",
          transfer: "Transferir",
          reopen: "Reabrir",
          ticketClosed: "Ticket cerrado correctamente",
          confirmCloseWithTagsTitle: "Confirmar cierre de ticket",
          confirmCloseWithTagsMessage:
            "Al cerrar se quitarán todas las etiquetas de este ticket. ¿Deseas continuar?",
          confirmCloseWithSendMessage:
            "Al confirmar el cierre se enviará al cliente un mensaje de WhatsApp según «Mensaje al cerrar ticket» en Configuraciones de mensajería (no aplica a grupos). ¿Deseas continuar?",
          confirmCloseBodyTagsAndMessage:
            "Al cerrar se quitarán todas las etiquetas de este ticket y se enviará al cliente el mensaje de cierre configurado en Mensajería. ¿Deseas continuar?",
        },
      },
        newTicketModal: {
        title: "Crear Ticket",
        fieldLabel: "Escribe para buscar el contacto",
        add: "Agregar",
        selectQueue: "Seleccione un departamento",
        selectConnection: "Seleccione una conexión",
        selectChannel: "¿Por dónde iniciar la conversación?",
        channelWhatsApp: "WhatsApp",
        channelTelegram: "Telegram",
        departmentAttention: "Departamento de atención",
        buttons: {
          ok: "Guardar",
          cancel: "Cancelar",
        },
        errors: {
          contactRequired: "Debe seleccionar un contacto para crear el ticket",
          connectionRequired: "Debe seleccionar una conexión",
          queueRequired: "Debe seleccionar un departamento",
          channelRequired: "Elige WhatsApp o Telegram",
          noChannel: "Este contacto no tiene WhatsApp ni Telegram",
          noWhatsApp: "Este contacto no tiene WhatsApp",
          noTelegram: "Este contacto no tiene Telegram",
        },
      },
      mainDrawer: {
        mobileBar: {
          label: "Accesos principales",
          dashboard: "Inicio",
          chats: "Chats",
          negocio: "Negocio",
          groups: "Grupos",
          status: "Estados",
          campaigns: "Envíos",
          contacts: "Contactos",
          settings: "Ajustes",
        },
        groups: {
          whatsapp: "Chats",
          dashboard: "Dashboard",
          gruposWA: "Grupos y canales",
          estadosWA: "Estados / Historias",
          mensajes: "Mensajería",
          configuracion: "Configuración",
          flowbuilder: "FlowBuilder",
          utilidades: "Utilitarios",
          negocio: "Negocio",
        },
        listItems: {
          dashboard: "Tablero",
          connections: "Conexiones",
          metrics: "Métricas",
          tickets: "Tickets",
          gettingStarted: "Primeros pasos",
          quickMessages: "Respuestas Rápidas",
          kanban: "Kanban",
          todolist: "Tareas",
          contacts: "Contactos",
          groupsWA: "Lista de grupos/canales",
          newslettersWA: "Canales",
          queues: "Departamentos",
          tags: "Etiquetas",
          administration: "Administración",
          users: "Usuarios",
          userRoles: "Usuarios",
          settings: "Configuraciones",
          helps: "Ayuda",
          messagesAPI: "API",
          appointments: "Agenda",
          negocio: "Negocio",
          negocioResumen: "Resumen",
          negocioCustomers: "Clientes",
          negocioServices: "Servicios",
          negocioSubscriptions: "Cobros",
          negocioSales: "Movimientos",
          negocioAccounts: "Cuentas",
          negocioProducts: "Productos",
          negocioCombos: "Combos",
          negocioSuppliers: "Proveedores",
          negocioSettings: "Ajustes",
          negocioPayments: "Métodos de pago",
          negocioUsers: "Usuarios",
          negocioCurrency: "Moneda",
          negocioMessages: "Mensajes",
          negocioReminders: "Recordatorios",
          negocioTerms: "Condiciones de uso",
          negocioRaffle: "Sorteo mensual",
          negocioPoints: "Saldo",
          negocioSectionOperate: "Operación",
          negocioSectionInventory: "Inventario",
          negocioSectionSetup: "Configuración",
          schedules: "Mensajes programados",
          campaigns: "Campañas",
          campaignsDispatch: "Envío de mensajes",
          contactLists: "Lista de contactos",
          statusCampaigns: "Estados / Historias",
          campaignShippingReports: "Informe de Envío",
          annoucements: "Anuncios",
          chats: "Chat Interno",
          localChat: "Chat local",
          financeiro: "Suscripciones",
          subscription: "Subscripción",
          files: "Lista de archivos",
          prompts: "Agentes IA",
          queueIntegration: "Integraciones",
          flowbuilders: "Lista de Flujos",
          flowcampaigns: "Campañas de Flujo",
          dashboardWhatsApp: "Actividad",
          vpsPerformance: "Rendimiento VPS",
          satisfactionSurveys: "Encuestas de satisfacción",
          groupCampaigns: "Campañas de Grupos",
          groupCampaignShippingReports: "Informe de Envío",
          metaHub: "Meta",
        },
        appBar: {
          notRegister: "Sin notificaciones",
          user: {
            profile: "Perfil de usuario",
            logout: "Cerrar sesión",
            label: "Usuario:",
          },
          tooltips: {
            openDrawer: "Abrir menú",
            closeDrawer: "Cerrar menú",
            navigationMenu: "Menú de navegación",
            openNavigationMenu: "Abrir menú de navegación",
            internalChat: "Chat interno",
            help: "Ayuda",
            announcements: "Anuncios",
            whatsappNotifications: "Notificaciones de WhatsApp",
            settings: "Configuración",
            updateVersion: "Actualizar versión",
            logout: "Salir",
          },
          settingsMenu: {
            lightMode: "Modo claro",
            darkMode: "Modo oscuro",
            logs: "Registros (logs)",
          },
          pwa: {
            installApp: "Instalar app",
            enableNotifications: "Activar notificaciones",
            notificationsOn: "Notificaciones activadas",
            bannerInstallTitle: "Instala WATOOLX",
            bannerInstallBody: "Recibe avisos de mensajes nuevos aunque no tengas el panel abierto.",
            bannerNotifyTitle: "Activa las notificaciones",
            bannerNotifyBody: "Así te enteras de tickets y mensajes nuevos, también con la app instalada.",
            bannerInstall: "Instalar",
            bannerEnable: "Activar",
            bannerLater: "Ahora no",
            iosTitle: "Agregar a inicio",
            iosBody: "En Safari: toca Compartir y elige Agregar a pantalla de inicio. Luego abre la app desde el icono y activa las notificaciones.",
            gotIt: "Entendido",
            permissionDenied: "Las notificaciones están bloqueadas. Actívalas en Ajustes del navegador o del teléfono.",
          },
          versionLong: "VERSIÓN {{version}}",
          versionShort: "V{{version}}",
        },
      },
      queueIntegration: {
        title: "Integraciones",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Idioma",
          lastUpdate: "Última actualización",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar Proyecto",
        },
        searchPlaceholder: "Buscar...",
        toasts: {
          deleted: "Integración eliminada correctamente",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "¿Estás seguro? Esta acción no se puede deshacer y se eliminará de los departamentos y conexiones vinculadas.",
        },
      },
      files: {
        title: "Lista de archivos",
        adminTitle: "Administrador de archivos",
        searchPlaceholder: "Buscar listas de archivos...",
        newList: "Nueva lista de archivos",
        listCount: "{{count}} listas",
        table: {
          name: "Nombre de la lista",
          description: "Descripción",
          fileCount: "Cantidad de archivos",
          createdAt: "Fecha de creación",
          actions: "Acciones",
        },
        noDescription: "Sin descripción",
        filesInList: "{{count}} archivos",
        tooltips: {
          editList: "Editar lista de archivos",
          deleteList: "Eliminar lista de archivos",
        },
        contacts: "Contactos",
        actions: "Acción",
        toasts: {
          deleted: "¡Lista eliminada correctamente!",
          deletedAll: "¡Todas las listas se han eliminado correctamente!",
        },
        buttons: {
          add: "Agregar",
          deleteAll: "Eliminar Todos",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteAllTitle: "Eliminar Todos",
          deleteMessage: "¿Estás seguro de que deseas eliminar esta lista?",
          deleteAllMessage: "¿Estás seguro de que deseas eliminar todas las listas?",
        },
      },
      messagesAPI: {
        title: "API de Mensajería WhatsApp",
        documentation: {
          title: "Documentación para envío de mensajes",
          methods: "Métodos de Envío",
          instructions: "Instrucciones",
          importantNotes: "Observaciones importantes",
          textMessages: "Mensajes de Texto",
          mediaMessages: "Mensajes Multimedia",
          endpoint: "Endpoint",
          method: "Método",
          headers: "Headers",
          body: "Body",
          formData: "FormData",
          testSend: "Prueba de Envío",
          send: "Enviar",
        },
        instructions: {
          tokenRequired:
            "Antes de enviar mensajes, es necesario registrar el token vinculado a la conexión que enviará los mensajes. Para realizar el registro acceda al menú 'Conexiones', haga clic en el botón editar de la conexión e inserte el token en el campo correspondiente.",
          numberFormat:
            "El número para envío no debe tener máscara o caracteres especiales y debe estar compuesto por:",
          countryCode: "Código del país",
          areaCode: "DDD",
          number: "Número",
        },
        importantInfo: {
          title: "Información Importante",
          tokenLabel: "Token requerido",
          tokenBody: "Debes registrar un token vinculado a la conexión que enviará los mensajes",
          formatLabel: "Formato del número",
          formatBody: "Código de país + DDD + número (sin caracteres especiales)",
          exampleLabel: "Ejemplo",
          exampleBody: "51959858768 (Perú: 51, DDD: 959, Número: 858768)",
          channelsLabel: "Qué usa cada conexión",
          channelsBody: "Texto, multimedia y encuestas: token de WhatsApp. Grupos: token de WhatsApp o de Telegram. Canales @newsletter: solo WhatsApp. Estados e historias: token de WhatsApp o de Telegram. No abre chats.",
        },
        chips: {
          endpoint: "ENDPOINT",
          method: "MÉTODO",
          headers: "HEADERS",
          upTo100mb: "HASTA 100MB",
        },
        common: {
          apiInfoTitle: "Información de la API",
          testSendTitle: "Prueba de Envío",
          bodyJson: "Body (JSON):",
          formData: "FormData:",
        },
        section1: {
          title: "1. Mensajes de Texto",
          intro: "Envía mensajes de texto simples a través de WhatsApp Business API.",
          bodySnippet: `{ "number": "51959858768", "body": "Su mensaje" }`,
        },
        section2: {
          title: "2. Mensajes Multimedia",
          intro:
            "Envía archivos multimedia (imágenes, videos, documentos, audio) a través de WhatsApp Business API.",
          maxCapacity: "Capacidad máxima:",
          maxCapacityBody: "Archivos de hasta 100 MB",
          formDataNumber: "number:",
          formDataNumberEx: "51959858768",
          formDataMedias: "medias:",
          formDataMediasEx: "archivo",
          formDataBody: "body:",
          formDataBodyEx: "mensaje opcional (texto acompañante)",
          fileTypesTitle: "Tipos de archivo soportados:",
          images: "Imágenes:",
          imagesEx: "JPG, PNG, GIF (hasta 5MB)",
          videos: "Videos:",
          videosEx: "MP4, AVI, MOV (hasta 16MB)",
          documents: "Documentos:",
          documentsEx: "PDF, DOC, XLS, PPT (hasta 100MB)",
          audio: "Audio:",
          audioEx: "MP3, WAV, OGG (hasta 16MB)",
        },
        section3: {
          title: "3. Mensajes a grupos",
          intro: "Envía texto a un grupo. Con token de WhatsApp usa el ID del grupo. Con token de Telegram usa el ID del grupo o canal de esa cuenta.",
          bodySnippet: `{ "number": "12036312345678901234", "body": "Su mensaje" }`,
          groupNote: "Nota:",
          groupNoteBody: "En WhatsApp se agrega @g.us. En Telegram el ID se usa tal cual y no abre un chat privado.",
        },
        section4: {
          title: "4. Multimedia a grupos",
          intro:
            "Envía un archivo a un grupo de WhatsApp o, con el token de Telegram, a un grupo o canal de Telegram.",
          formDataNumberLi: "ID del grupo (ej: 12036312345678901234)",
          formDataMediasLi: "archivo multimedia",
        },
        sectionChannel: {
          title: "5. Canales WhatsApp: Texto, Multimedia y Encuestas",
          intro:
            "Publica contenido en un Canal de WhatsApp administrado por la conexión autenticada. El mismo endpoint acepta texto, un archivo multimedia o una encuesta.",
          destinationTitle: "Destino:",
          destinationBody:
            "newsletterJid, jid, link o channelLink. Se recomienda usar el JID terminado en @newsletter.",
          securityTitle: "Autorización:",
          securityBody:
            "Bearer token de la conexión administradora. La conexión debe estar CONNECTED y tener rol ADMIN u OWNER en el canal.",
          textTitle: "Publicar texto",
          textCurl: `curl -X POST "{{endpoint}}" \\
  -H "Authorization: Bearer TOKEN" \\
  -F "newsletterJid=123456789@newsletter" \\
  -F "body=Publicación del canal"`,
          mediaTitle: "Publicar multimedia con texto opcional",
          mediaCurl: `curl -X POST "{{endpoint}}" \\
  -H "Authorization: Bearer TOKEN" \\
  -F "newsletterJid=123456789@newsletter" \\
  -F "body=Texto opcional" \\
  -F "medias=@/ruta/archivo.jpg"`,
          pollTitle: "Publicar encuesta",
          pollCurl: `curl -X POST "{{endpoint}}" \\
  -H "Authorization: Bearer TOKEN" \\
  -F "newsletterJid=123456789@newsletter" \\
  -F "type=poll" \\
  -F "question=¿Qué contenido prefieres?" \\
  -F 'options=["Tutoriales","Noticias","Ofertas"]' \\
  -F "selectableCount=1"`,
          responseNote:
            "HTTP 200 significa publicación verificada. HTTP 202 significa que se transmitió al socket, pero no pudo confirmarse mediante ACK, evento o lectura posterior. Revisa success, publishedVerified, verification, serverId y messageId.",
          limitsNote:
            "Solo WhatsApp. Un canal de Telegram se publica con el envío a grupos, usando el token de Telegram. Solo se procesa un archivo por solicitud. Una encuesta no puede incluir multimedia.",
        },
        sectionStatus: {
          title: "Estados e historias",
          intro: "Publica de inmediato en Mi estado de WhatsApp o en una historia de Telegram. El token elige la conexión. No envía un mensaje de chat.",
          whatsappTitle: "WhatsApp",
          whatsappBody: "Texto, foto, video o audio. targetType all publica en lotes de 50 para los contactos con conversación en esa línea. WhatsApp lo muestra a quien tiene el número guardado. targetType contacts limita la lista con contactIds.",
          telegramTitle: "Telegram",
          telegramBody: "Foto o video obligatorio. El texto es la leyenda. Se publica una historia visible para los contactos de la cuenta. El texto solo responde 400.",
          fieldsTitle: "Campos",
          fieldsBody: "name (opcional), targetType (all o contacts), contactIds (1,2,3 o [1,2,3]), body o message, media o medias o file.",
          curl: `curl -X POST "{{endpoint}}" \\
  -H "Authorization: Bearer TOKEN_DE_LA_CONEXION" \\
  -F "targetType=all" \\
  -F "body=Contenido del estado" \\
  -F "media=@/ruta/imagen.jpg"`,
          testNote: "200: publicado. 400: falta contenido o, en Telegram, la foto o el video. 401: token inválido. 409: la conexión no está conectada.",
        },
        sectionPoll: {
          title: "6. Encuestas, Preguntas y Cuestionarios a Contactos",
          intro:
            "Envía una encuesta nativa de WhatsApp a un contacto. Una pregunta o cuestionario se representa mediante una encuesta de respuesta única o múltiple.",
          bodySnippet: `{
  "type": "poll",
  "number": "51959858768",
  "question": "¿Qué horario prefieres?",
  "options": ["Mañana", "Tarde", "Noche"],
  "selectableCount": 1
}`,
          fieldsTitle: "Campos aceptados:",
          typeField:
            "poll. También se aceptan survey, encuesta, question, pregunta, quiz y cuestionario.",
          numberField: "número del contacto con código de país, sin símbolos.",
          questionField:
            "texto de la pregunta. question tiene prioridad; body funciona como alias.",
          optionsField:
            "mínimo 2 opciones. Puede enviarse como arreglo JSON o texto separado por comas/saltos de línea.",
          selectableCountField:
            "1 para respuesta única; 0 para permitir selección múltiple; también admite un entero hasta el total de opciones.",
          quizNote:
            "Un cuestionario con varias preguntas se envía como varias solicitudes, una encuesta por cada pregunta. La API no calcula respuestas correctas ni puntuación.",
          validationNote:
            "Respuestas: 200 si se envió correctamente; 400 para pregunta/opciones inválidas; 401 para token inválido; error de conexión si WhatsApp no está conectado. No adjuntes multimedia en una solicitud de encuesta.",
        },
        forms: {
          tokenRegistered: "Token registrado",
          tokenRegisteredReq: "Token registrado *",
          tokenPlaceholder: "Ingresa tu token aquí",
          number: "Número",
          numberReq: "Número *",
          message: "Mensaje",
          messageReq: "Mensaje *",
          messageOptional: "Mensaje (Opcional)",
          messageOptionalPlaceholder: "Escribe un mensaje opcional para acompañar el archivo...",
          messagePlaceholder: "Escribe tu mensaje aquí",
          numberPlaceholder: "51980795094",
          fileName: "Nombre del archivo",
          sendMessage: "ENVIAR MENSAJE",
          sendMedia: "Enviar Multimedia",
          selectFile: "Seleccionar Archivo",
          clickUploadHint: "Haz clic para seleccionar un archivo multimedia",
          fileSize: "Tamaño:",
          groupId: "ID del Grupo *",
          groupIdHelper: "ID del grupo sin @g.us (ej: 12036312345678901234)",
          groupIdHelperShort: "ID del grupo sin @g.us",
          sendToGroup: "Enviar a Grupo",
          sendMediaToGroup: "Enviar Multimedia a Grupo",
          pollQuestion: "Pregunta *",
          pollOptions: "Opciones *",
          pollOptionsHelper: "Escribe una opción por línea o sepáralas por comas. Mínimo 2.",
          pollSelectionMode: "Modo de selección",
          pollSingleChoice: "Respuesta única",
          pollMultipleChoice: "Respuesta múltiple",
          sendPoll: "Enviar Encuesta",
          whatsappId: "ID de conexión WhatsApp *",
          channelJid: "JID o enlace del canal *",
          channelMode: "Tipo de publicación",
          channelText: "Texto",
          channelMedia: "Multimedia",
          channelPoll: "Encuesta",
          sendChannel: "Publicar en Canal",
        },
        fileSize: {
          bytes: "Bytes",
          kb: "KB",
          mb: "MB",
          gb: "GB",
        },
        apiInfo: {
          textMessageInfo:
            "A continuación se muestra la lista de información necesaria para el envío de mensajes de texto:",
          mediaMessageInfo:
            "A continuación se muestra la lista de información necesaria para el envío de mensajes multimedia:",
          authorization: "Authorization (Bearer token) y Content-Type (application/json)",
          multipartForm: "Authorization (Bearer token) y Content-Type (multipart/form-data)",
          exampleBody: '{ "number": "51959858768", "body": "Su mensaje" }',
          exampleNumber: "51959858768",
          exampleFile: "archivo",
        },
        textMessage: {
          number: "Número",
          body: "Mensaje",
          token: "Token registrado",
        },
        mediaMessage: {
          number: "Número",
          body: "Nombre del archivo",
          media: "Archivo",
          token: "Token registrado",
        },
        section5: {
          title: "7. API Externa - N8N / TypeBot",
          intro:
            "Endpoints para integraciones externas (N8N, TypeBot, etc.). Usa el mismo token de WhatsApp que la API de mensajería. Las respuestas incluyen el objeto variables compatible con TypeBot/N8N.",
          baseUrl: "Base URL:",
          headersLine: "Headers:",
          getTicketByNumber: "GET - Ticket por número",
          getTicketById: "GET - Ticket por ID",
          getUsers: "GET - Usuarios/Agentes",
          getTags: "GET - Etiquetas",
          putAssignTag: "PUT - Asignar etiqueta",
          putUpdateTicket: "PUT - Actualizar ticket",
          bodyLabel: "Body:",
          altPostTitle: "Alternativa POST (body o query params para Typebot):",
          postTicketBody1:
            'POST {{base}}/ticket - Body: { "atendimento": 1223 } o { "number": "51980795334" }',
          postTicketBody2: "POST {{base}}/ticket?number={{telefono}} - Variables en URL (Typebot)",
          postTicketBody3:
            "POST {{base}}/ticket/tag?atendimento={{atendimento}}&tagId=6 - Query params",
          postTicketBody4:
            'POST {{base}}/ticket - Body: { "atendimento": 1223, "status": "open", "userId": 1 } (actualizar)',
          postUsersTags: "POST {{base}}/users - POST {{base}}/tags",
          variablesObjectTitle: "Objeto variables (en respuestas ticket):",
          variablesList:
            "atendimento, nome, numero, status, canal, grupo, user, userEmail, queue, tags, whatsappNumber, whatsappName",
          typebotGuideTitle: "Guia Typebot (flujo validado):",
          typebotStep1: "Input: preguntar numero, guardar en variable telefono",
          typebotStep2:
            "HTTP Request: POST /ticket?number={{telefono}} (usar icono de llaves para insertar variable)",
          typebotStep3: "Headers: Authorization = Bearer token",
          typebotStep4: "Save in variables: data.variables.numero, nome, atendimento",
          typebotStep5: "Text: mostrar numero, nome, atendimento",
          seeGuide: "Ver guia 0275 para detalle completo.",
        },
        messages: {
          success: "Mensaje enviado exitosamente",
          successMedia: "Mensaje multimedia enviado exitosamente",
          successGroup: "Mensaje enviado al grupo exitosamente",
          successGroupMedia: "Mensaje multimedia enviado al grupo exitosamente",
          successPoll: "Encuesta enviada exitosamente",
          pollOptionsError: "La encuesta requiere al menos 2 opciones válidas",
          successChannel: "Contenido publicado y verificado en el canal",
          channelNotVerified: "La publicación fue enviada, pero no pudo verificarse",
          groupSendError: "Error al enviar mensaje al grupo",
          groupMediaError: "Error al enviar multimedia al grupo",
          noPermission:
            "Esta empresa no tiene permiso para acceder a esta página. Estamos redirigiéndolo.",
        },
        errors: {
          backendUrlNotConfigured: "REACT_APP_BACKEND_URL no está configurado",
        },
      },
      notifications: {
        noTickets: "No hay notificaciones.",
        noRecords: "Sin registros",
        whatsappDisconnected: {
          title: "Sin conexiones WhatsApp",
          body: "No hay conexiones activas. Configura o reconecta tus conexiones WhatsApp para continuar.",
          reconnect: "RECONECTAR AHORA",
          close: "Cerrar",
        },
      },
      whatsappConnectionsMenu: {
        loadingConnections: "Cargando conexiones…",
        tooltipNoConnections: "Sin conexiones WhatsApp — pulse para ver detalles",
        tooltipSomeConnected: "Hay al menos una conexión activa — pulse para ver el listado",
        tooltipNoneActive: "Ninguna conexión activa — pulse para ver el listado",
        ariaLabel: "Estado de conexiones WhatsApp",
        menuTitle: "Conexiones WhatsApp",
        loading: "Cargando…",
        noneConfigured: "No hay conexiones configuradas",
        connectionFallback: "Conexión #{{id}}",
        manage: "Gestionar conexiones…",
        status: {
          connected: "Conectado",
          opening: "Conectando…",
          disconnected: "Desconectado",
        },
      },
      quickMessages: {
        title: "Respuestas Rápidas",
        searchPlaceholder: "Buscar...",
        searchFieldPlaceholder: "Buscar respuestas rápidas...",
        noAttachment: "Sin adjunto",
        noFile: "Sin anexo",
        confirmationModal: {
          deleteTitle: "Eliminación",
          deleteMessage: "¡Esta acción es irreversible! ¿Quieres continuar?",
        },
        buttons: {
          add: "Agregar",
          addReply: "Agregar Respuesta",
          attach: "Adjuntar Archivo",
          cancel: "Cancelar",
          edit: "Editar",
        },
        toasts: {
          success: "¡Atajo agregado correctamente!",
          deleted: "¡Atajo eliminado correctamente!",
        },
        dialog: {
          title: "Mensaje Rápido",
          shortcode: "Atajo",
          message: "Respuesta",
          save: "Guardar",
          cancel: "Cancelar",
          geral: "Permitir editar",
          add: "Agregar",
          edit: "Editar",
          visao: "Permitir vista",
        },
        table: {
          shortcode: "Atajo",
          message: "Mensaje",
          actions: "Acciones",
          mediaName: "Nombre del Archivo",
          status: "Estado",
          shortcodeHeader: "ATAJO",
          messageHeader: "RESPUESTA",
          mediaNameHeader: "NOMBRE DEL ARCHIVO",
          statusHeader: "ESTADO",
          actionsHeader: "ACCIONES",
        },
        tooltips: {
          openAttachment: "Clic para abrir archivo",
          edit: "Editar respuesta rápida",
          delete: "Eliminar respuesta rápida",
        },
      },
      messageVariablesPicker: {
        label: "Variables disponibles",
        tooltipContactVars: "Variables de contacto",
        tooltipSystemVars: "Variables del sistema",
        vars: {
          contactFirstName: "Primer Nombre",
          contactName: "Nombre",
          greeting: "Saludo",
          protocolNumber: "Protocolo",
          date: "Fecha",
          hour: "Hora",
        },
      },
      contactLists: {
        title: "Listas de Contactos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acciones",
        },
        buttons: {
          add: "Nueva Lista",
        },
        dialog: {
          name: "Nombre",
          company: "Empresa",
          okEdit: "Editar",
          okAdd: "Agregar",
          add: "Agregar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no se puede deshacer.",
        },
        toasts: {
          deleted: "Registro eliminado",
        },
      },
      contactListItems: {
        title: "Contactos",
        searchPlaceholder: "Búsqueda",
        buttons: {
          add: "Nuevo",
          lists: "Listas",
          import: "Importar",
        },
        dialog: {
          name: "Nombre",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "Correo electrónico",
          okEdit: "Editar",
          okAdd: "Agregar",
          add: "Agregar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        table: {
          name: "Nombre",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "Correo electrónico",
          actions: "Acciones",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no se puede deshacer.",
          importMessage: "¿Desea importar los contactos de esta hoja de cálculo?",
          importTitle: "Importar",
        },
        toasts: {
          deleted: "Registro eliminado",
        },
      },
      flowbuilders: {
        title: "Flujos Automatizados",
        searchPlaceholder: "Buscar flujos...",
        noFlows: "No hay flujos creados",
        rowsPerPage: "Filas por página",
        buttons: {
          add: "Nuevo Flujo",
        },
        table: {
          name: "Nombre",
          status: "Estado",
          createdAt: "Creado",
          actions: "Acciones",
        },
        status: {
          active: "Activo",
          inactive: "Inactivo",
        },
        actions: {
          edit: "Editar",
          delete: "Eliminar",
        },
        confirmationModal: {
          deleteTitle: "Eliminar Flujo",
          deleteMessage:
            "¿Está seguro de que desea eliminar este flujo? Esta acción no se puede deshacer.",
        },
        toasts: {
          deleted: "Flujo eliminado exitosamente",
          created: "Flujo creado exitosamente",
          updated: "Flujo actualizado exitosamente",
          saved: "Flujo guardado exitosamente",
          saveSuccess: "Flujo guardado exitosamente",
          saveError: "Error al guardar el flujo",
          activated: "Flujo activado",
          deactivated: "Flujo desactivado",
        },
        loading: "Cargando flujo...",
        editor: {
          nodesPanel: "Nodos Disponibles",
          newFlow: "Nuevo Flujo",
          saving: "Guardando",
          save: "Guardar",
          cancel: "Cancelar",
          canvas: "Canvas del Flujo",
          noNodes:
            "No hay nodos en el flujo. Haz clic en un nodo del panel lateral para agregarlo.",
          connecting: "Conectando... (Haz clic en otro nodo)",
          connectionHint:
            "Shift + Click en un nodo para iniciar conexión, luego haz clic en otro nodo para conectar",
          nodesHint: "Haz clic en un nodo para agregarlo al canvas",
          shortcuts: "Atajos de teclado",
          shortcutDrag: "Arrastra: Click y arrastra para mover",
          shortcutConnect: "Conectar: Shift + Click en nodo origen, luego Click en nodo destino",
          shortcutConfig: "Configurar: Click en el nodo o doble click",
        },
        modals: {
          title: "Configurar {nodeType}",
          cancel: "Cancelar",
          save: "Guardar",
          noConfig: "Este nodo no requiere configuración",
          message: {
            text: "Texto del mensaje",
          },
          condition: {
            variable: "Variable",
            operator: "Operador",
            value: "Valor",
          },
          start: {
            description:
              "El nodo de inicio es el punto de entrada del flujo. No requiere configuración adicional.",
          },
        },
        validation: {
          noStartNode: "El flujo debe tener al menos un nodo de inicio",
          duplicateStartNode: "El flujo ya tiene un nodo de inicio",
          nameRequired: "El nombre del flujo es requerido",
        },
      },
      flowcampaigns: {
        title: "Campañas de Flujo",
        searchPlaceholder: "Buscar campañas...",
        noCampaigns: "No hay campañas creadas",
        rowsPerPage: "Filas por página",
        buttons: {
          add: "Nueva Campaña",
        },
        table: {
          name: "Nombre",
          flow: "Flujo",
          phrases: "Frases",
          whatsapps: "WhatsApp(s)",
          status: "Estado",
          actions: "Acciones",
        },
        status: {
          active: "Activa",
          inactive: "Inactiva",
        },
        actions: {
          edit: "Editar",
          delete: "Eliminar",
        },
        confirmationModal: {
          deleteTitle: "Eliminar Campaña",
          deleteMessage:
            "¿Está seguro de que desea eliminar esta campaña? Esta acción no se puede deshacer.",
        },
        toasts: {
          created: "Campaña creada exitosamente",
          updated: "Campaña actualizada exitosamente",
          deleted: "Campaña eliminada exitosamente",
          activated: "Campaña activada",
          deactivated: "Campaña desactivada",
        },
        form: {
          title: "Nueva Campaña",
          editTitle: "Editar Campaña",
          name: "Nombre de la Campaña",
          flow: "Flujo Asociado",
          phrases: "Frases de Activación",
          addPhrase: "Agregar Frase",
          phraseTypes: {
            exact: "Exacta",
            contains: "Contiene",
            startsWith: "Comienza con",
            endsWith: "Termina con",
          },
          whatsapps: "WhatsApp(s)",
          status: "Campaña Activa",
          save: "Crear",
          update: "Actualizar",
          cancel: "Cancelar",
        },
        validation: {
          nameRequired: "El nombre de la campaña es requerido",
          flowRequired: "Debe seleccionar un flujo",
          phraseRequired: "Debe proporcionar al menos una frase de activación",
          whatsappRequired: "Debe seleccionar al menos un WhatsApp",
        },
      },
      campaigns: {
        title: "Campañas",
        searchPlaceholder: "Búsqueda",
        buttons: {
          add: "Nueva Campaña",
          contactLists: "Listas de Contactos",
        },
        table: {
          name: "Nombre",
          whatsapp: "Conexión",
          aiAgent: "Agente IA",
          contactList: "Lista de Contactos",
          status: "Estado",
          scheduledAt: "Programada",
          completedAt: "Completada",
          confirmation: "Confirmación",
          actions: "Acciones",
        },
        placeholders: {
          notDefined: "No definido",
          notDefinedMale: "No definido",
          noScheduling: "Sin programación",
          notCompleted: "No completada",
        },
        dialog: {
          new: "Nueva Campaña",
          update: "Editar Campaña",
          readonly: "Solo Lectura",
          form: {
            name: "Nombre",
            message1: "Mensaje 1",
            message2: "Mensaje 2",
            message3: "Mensaje 3",
            message4: "Mensaje 4",
            message5: "Mensaje 5",
            confirmationMessage1: "Mensaje de Confirmación 1",
            confirmationMessage2: "Mensaje de Confirmación 2",
            confirmationMessage3: "Mensaje de Confirmación 3",
            confirmationMessage4: "Mensaje de Confirmación 4",
            confirmationMessage5: "Mensaje de Confirmación 5",
            messagePlaceholder: "Contenido del mensaje",
            messageVariables:
              "Variables disponibles: {{firstName}}, {{name}}, {{ms}}, {{protocol}}, {{hora}}",
            whatsapp: "Conexión",
            status: "Estado",
            scheduledAt: "Programada",
            confirmation: "Confirmación",
            contactList: "Lista de Contacto",
            tagList: "Lista de Etiquetas",
            fileList: "Lista de Archivos",
          },
          includeColdContacts: "Incluir contactos fríos",
          includeColdContactsHint:
            "Activado: envía a toda la lista. Desactivado: solo a números que ya te escribieron (tienen mensaje de entrada).",
          poll: {
            toggle: "Agregar encuesta de WhatsApp",
            hint: "Se envía justo después del mensaje de la campaña. Los votos se registran y los ves en el informe de la campaña.",
            question: "Pregunta",
            questionHint: "Máximo 255 caracteres. Puedes usar {{name}} para el nombre del contacto.",
            option: "Opción",
            addOption: "Agregar opción",
            multiple: "Permitir varias respuestas",
            results: "Resultados de la encuesta",
            sent: "Encuestas enviadas",
            voters: "Contactos que votaron",
            votes: "votos",
            noVotes: "Aún no hay votos.",
            voterList: "Detalle de votos",
          },
          ai: {
            wizardQuestion:
              "¿Desea usar Inteligencia Artificial dinámica en sus mensajes de esta campaña?",
            wizardHelp:
              "Con IA, cada contacto puede recibir un mensaje personalizado según el agente que elija y el texto base (semilla) que escriba. Sin IA, el envío sigue igual que siempre. Con IA debe configurar etiquetado ante respuesta.",
            choiceNo: "No — modo clásico (Msg. 1–5 y adjuntos como hasta ahora)",
            choiceYes: "Sí — IA dinámica (semilla única + agente Prompt)",
            continue: "Continuar",
            modeLabel: "Modo mensaje masivo",
            modeClassic: "Clásico (sin IA en el texto enviado)",
            modeAi: "IA dinámica (mensaje único adaptado por contacto)",
            promptAgent: "Agente IA (lista / legado)",
            promptAgentSend: "Agente IA (personaliza cada envío)",
            replyPromptAgent: "Agente IA (cuando el contacto responde)",
            ariaAiEnvironment: "Campaña con asistente de inteligencia artificial",
            promptPlaceholder: "Seleccione un agente…",
            promptPlaceholderSend: "Seleccione agente para el envío masivo…",
            promptPlaceholderReply: "Seleccione agente ante respuesta del contacto…",
            seedBanner:
              "IA generativa activa: se crearán versiones únicas del mensaje por destinatario; los intervalos en el servidor incluyen variación aleatoria.",
            seedLabel: "Mensaje semilla (base)",
            intervalHint:
              "Con IA dinámica, el sistema aplica jitter en los tiempos de envío sobre los intervalos que indique aquí.",
            tagMandatoryHint:
              "Con IA dinámica, el etiquetado ante respuesta es obligatorio: active la etiqueta y elija cuál aplicar.",
            autoTagForced: "Activado (obligatorio con IA dinámica)",
            responderTab: "RESPONDER",
            responderTitle: "Ante respuesta del contacto",
            responderBanner:
              "Elija el agente que debe usarse cuando un contacto responde después de esta campaña. Es independiente del que personaliza cada mensaje de envío.",
            attachFileAria: "Adjuntar archivo",
            errors: {
              promptSendRequired: "Seleccione el agente IA para el envío masivo.",
              replyPromptRequired:
                "Seleccione el agente IA para ante respuesta (pestaña RESPONDER).",
            },
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            restart: "Reiniciar Campañas",
            close: "Cerrar",
            attach: "Adjuntar Archivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no se puede deshacer.",
        },
        toasts: {
          success: "Operación realizada correctamente",
          cancel: "Campaña cancelada",
          restart: "Campañas reiniciadas",
          deleted: "Registro eliminado",
        },
        report: {
          title: "Informe de",
          status: "Estado",
          validContacts: "Contactos Válidos",
          delivered: "Entregados",
          confirmationRequested: "Confirmaciones Solicitadas",
          confirmations: "Confirmaciones",
          connection: "Conexión",
          contactList: "Lista de Contactos",
          scheduling: "Agendar",
          conclusion: "Conclusión",
          statusValues: {
            inactive: "Inactiva",
            scheduled: "Programada",
            inProgress: "En Progreso",
            cancelled: "Cancelada",
            finished: "Finalizada",
          },
        },
      },
      announcements: {
        active: "Activo",
        inactive: "Inactivo",
        title: "Informativos",
        searchPlaceholder: "Búsqueda",
        buttons: {
          add: "Nuevo Informativo",
          contactLists: "Listas de Informativos",
        },
        table: {
          priority: "Prioridad",
          title: "Título",
          text: "Texto",
          mediaName: "Archivo",
          status: "Estado",
          actions: "Acciones",
        },
        dialog: {
          edit: "Editar Informativo",
          add: "Nuevo Informativo",
          update: "Editar Informativo",
          readonly: "Solo Lectura",
          form: {
            priority: "Prioridad",
            title: "Título",
            text: "Texto",
            mediaPath: "Archivo",
            status: "Estado",
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Cerrar",
            attach: "Adjuntar Archivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no se puede deshacer.",
        },
        toasts: {
          success: "Operación realizada correctamente",
          deleted: "Registro eliminado",
        },
      },
      campaignsConfig: {
        title: "Configuraciones de Campañas",
        intervals: "Configuración de Intervalos",
        form: {
          randomTriggerInterval: "Tiempo entre mensajes (segundos)",
          longerIntervalAfter: "Aplicar intervalo mayor después de X mensajes",
          greaterTriggerInterval: "Intervalo mayor entre mensajes (segundos)",
          noInterval: "Sin intervalo",
          notDefined: "No definido",
          seconds: "segundos",
          second: "segundo",
        },
        buttons: {
          addVariable: "AGREGAR VARIABLE",
          saveConfigurations: "GUARDAR CONFIGURACIONES",
          close: "CERRAR",
          add: "AGREGAR",
        },
        variables: {
          shortcut: "Atajo",
          content: "Contenido",
        },
        messages: {
          saveSuccess: "Configuraciones guardadas correctamente",
        },
        help: {
          intervals: "Configura los tiempos de envío para evitar bloqueos de WhatsApp",
          variables: "Crea variables personalizadas para usar en tus mensajes de campaña",
          example:
            "Ejemplo: Atajo 'empresa' = Contenido 'Mi Empresa S.A.' → Usar {empresa} en mensajes",
        },
      },
      queues: {
        title: "Departamentos",
        toasts: {
          deleted: "Departamento eliminado correctamente",
        },
        table: {
          id: "ID",
          department: "Departamento",
          name: "Nombre",
          color: "Color",
          automation: "Automatización",
          greeting: "Mensaje de bienvenida",
          actions: "Acciones",
          orderQueue: "Orden de la cola (bot)",
        },
        automationLabels: {
          flowbuilder: "FLOWBUILDER",
          prompt: "PROMPT",
          integration: "INTEGRACIÓN",
          chatbot: "CHATBOT",
          none: "Sin automatización",
        },
        placeholders: {
          noGreeting: "Sin mensaje",
        },
        tooltips: {
          editQueue: "Editar departamento",
          deleteQueue: "Eliminar departamento",
        },
        buttons: {
          add: "Agregar departamento",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "¿Estás seguro? ¡Esta acción no se puede deshacer! Los tickets de este departamento seguirán existiendo pero ya no tendrán ningún departamento asignado.",
        },
      },
      queueOptions: {
        title: "Chatbot con menús de opciones",
        subtitle:
          "Aquí defines los botones que verá el contacto en el chat (menú por niveles). No es un asistente de texto libre: el cliente navega tocando opciones. Usa «Agregar» para cada ítem del menú.",
        add: "Agregar",
        placeholder: {
          title: "Título de la opción",
          message: "Escriba el texto de la opción",
        },
        undefinedTitle: "Título no definido",
      },
      transferQueueModal: {
        title: "Seleccionar Departamento de Transferencia",
        description:
          "Selecciona el departamento al que se transferirán los tickets cuando el usuario seleccione esta opción.",
        searchPlaceholder: "Buscar departamentos...",
        cancel: "Cancelar",
        confirm: "Confirmar Transferencia",
        noResults: "No se encontraron departamentos con ese nombre",
        noQueues: "No hay departamentos disponibles para transferencia",
      },
      queueSelect: {
        inputLabel: "Departamentos",
      },
      users: {
        title: "Usuarios",
        table: {
          id: "ID",
          status: "Estado",
          name: "Nombre",
          email: "Email",
          profile: "Perfil",
          department: "Departamento",
          lastConnection: "Última conexión",
          lastConnectionNow: "Ahora en línea",
          connected: "Conectada",
          disconnected: "Desconectada",
          actions: "Acciones",
        },
        profiles: {
          admin: "Admin",
          supervisor: "Supervisor",
          user: "Agente",
        },
        buttons: {
          add: "Agregar usuario",
        },
        toasts: {
          deleted: "Usuario eliminado correctamente.",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "Todos los datos del usuario se perderán. Los tickets abiertos de este usuario se moverán al departamento.",
        },
      },
      helps: {
        title: "Centro de Ayuda",
        form: {
          title: "Título",
          videoCode: "URL de Video (YouTube)",
          description: "Descripción",
        },
        table: {
          title: "Título",
          description: "Descripción",
          video: "Video",
          preview: "Vista",
          content: "Contenido",
          source: "Fuente",
          visibility: "Visibilidad",
          actions: "Acciones",
        },
        library: {
          title: "Biblioteca de videos",
          noDescription: "Sin descripción",
        },
        summary: {
          total: "Total",
          visible: "Visibles",
          hidden: "Ocultos",
          types: "YT/Ext",
        },
        videoTypes: {
          youtube: "YouTube",
          external: "Externo",
          unknown: "Video",
        },
        buttons: {
          clear: "Limpiar",
          delete: "Eliminar",
          save: "Guardar",
          saving: "Guardando...",
        },
        formTitle: {
          edit: "Editar Video de Ayuda",
          create: "Crear Nuevo Video de Ayuda",
        },
        sectionVideo: "Información del Video de Ayuda",
        placeholders: {
          video: "https://youtu.be/6FdRJTw46qI o https://tudominio.com/video.mp4",
          thumbnail: "https://tudominio.com/thumbnails/video.jpg",
        },
        helpers: {
          youtubeDetected: "✅ Video de YouTube detectado",
          externalDetected: "✅ Video externo detectado",
          pasteHint:
            "Pega la URL de YouTube o una URL externa de video (ej: https://tudominio.com/video.mp4)",
        },
        thumbnail: {
          label: "URL de Thumbnail (Opcional)",
          hint: "URL opcional de imagen thumbnail personalizada. Si no se proporciona, se usará thumbnail de YouTube o placeholder.",
        },
        grid: {
          emptyTitle: "No hay videos de ayuda registrados",
          emptySubtitle: "Crea tu primer video de ayuda para comenzar",
        },
        tooltips: {
          editRow: "Editar video de ayuda",
          hide: "Ocultar este video a las empresas",
          show: "Mostrar este video a las empresas",
          moveUp: "Mover video hacia arriba",
          moveDown: "Mover video hacia abajo",
        },
        visibility: {
          visible: "Visible",
          hidden: "Oculto",
        },
        validation: {
          invalidVideoInput:
            "URL de video no válida. Ingresa una URL de YouTube o una URL externa válida (ej: https://tudominio.com/video.mp4)",
          processFailed: "No se pudo procesar la URL del video",
          urlInvalid: "URL no válida. Debe comenzar con http:// o https://",
          urlExtensionHint:
            "La URL no tiene extensión de video. Asegúrate de que el servidor devuelva el Content-Type correcto.",
        },
        toast: {
          youtubeDetected: "Video de YouTube detectado: {{code}}",
          externalDetected: "Video externo detectado y guardado",
        },
        messages: {
          loadError: "No se pudo cargar la lista de registros",
          saveSuccess: "¡Operación realizada con éxito!",
          saveError:
            "No se pudo realizar la operación. Verifique si ya existe una ayuda con el mismo nombre o si los campos fueron completados correctamente",
          deleteSuccess: "¡Operación realizada con éxito!",
          deleteError: "No se pudo realizar la operación",
          hideSuccess: "Video oculto para las empresas",
          showSuccess: "Video visible para las empresas",
          visibilityError: "No se pudo actualizar la visibilidad del video",
          orderSuccess: "Orden de videos actualizado",
          orderError: "No se pudo actualizar el orden de los videos",
          deleteTitle: "Eliminación de Registro",
          deleteMessage: "¿Desea realmente eliminar este registro?",
          videoUnavailable: "El video no está disponible",
          videoLoadError: "No se pudo cargar el video",
          videoLoadHint:
            "El video puede no estar disponible o la URL no es accesible desde este dominio.",
          videoCorsHint:
            "Verifica que el servidor permita acceso público (CORS) y que la URL sea correcta.",
          youtubeError: "Error al cargar el video de YouTube",
          videoUrlError:
            "Error al cargar el video. Verifica que la URL sea accesible y el formato sea compatible.",
          videoNotSupported: "Tu navegador no soporta el elemento de video.",
        },
      },

      uploader: {
        title: "Cargar Logo",
        selectOption: "Seleccionar opción",
        fileInput: "Seleccionar archivo",
        sendFile: "Enviar archivo",
        options: {
          signup: "Página de registro",
          login: "Página de inicio de sesión",
          internal: "Interno",
          favicon: "Favicon",
          favicon256: "Favicon 256x256",
          appleTouch: "Apple Touch Icon",
        },
        messages: {
          noPermission: "No tienes permisos para acceder a esta página",
          invalidFormat: "Formato de archivo no válido. Solo se permiten PNG, ICO y SVG",
          chooseFile: "Por favor, selecciona un archivo",
          chooseDestination: "Por favor, selecciona un destino",
          fileSent: "Archivo enviado correctamente",
        },
      },
      tags: {
        title: "Etiquetas",
        confirmationModal: {
          deleteTitle: "¿Estás seguro que quieres eliminar esta Etiqueta?",
          deleteMessage: "Esta acción no se puede deshacer.",
          deleteAllMessage: "¿Estás seguro que quieres eliminar todas las Etiquetas?",
          deleteAllTitle: "Eliminar Todas",
        },
        table: {
          name: "Nombre",
          tagName: "Nombre de la etiqueta",
          color: "Color",
          tickets: "Tickets Etiquetados",
          taggedTickets: "Tickets etiquetados",
          kanban: "Kanban",
          origin: "Origen",
          actions: "Acciones",
        },
        kanbanActive: "ACTIVO",
        kanbanInactive: "INACTIVO",
        originProfile: "Por perfil",
        originManual: "Manual",
        readOnly: "Solo lectura",
        profileTagTitle: "Columna Kanban creada al activar Agenda. Solo lectura.",
        manualTagTitle: "Etiqueta creada manualmente",
        readOnlyHint:
          "Las columnas por perfil no se editan. Cambie el perfil en Agenda > Configuración.",
        tooltips: { editTag: "Editar etiqueta", deleteTag: "Eliminar etiqueta" },
        buttons: {
          add: "Nueva Etiqueta",
          deleteAll: "Eliminar Todas",
        },
        toasts: {
          deletedAll: "¡Todas las Etiquetas se han eliminado correctamente!",
          deleted: "Etiqueta eliminada correctamente.",
        },
      },
      settings: {
        success: "Configuraciones guardadas correctamente.",
        error: "Error al guardar la configuración.",
        title: "Configuraciones",
        schedules: {
          success: "Horarios guardados correctamente.",
        },
        settings: {
          userCreation: {
            name: "Creación de usuario",
            options: {
              enabled: "Habilitado",
              disabled: "Deshabilitado",
            },
          },
        },
        tabs: {
          options: "Opciones",
          schedules: "Horarios",
          version: "Versiones",
          smtp: "SMTP",
          alerts: "Alertas",
          subscriptions: "Suscripciones",
          logo: "Web",
          companies: "Empresas",
          registerCompany: "Registrar Empresa",
          plans: "Planes",
          help: "Ayuda",
          performance: "Rendimiento del Servidor",
        },
        options: {
          userRating: "Calificación de Usuario",
          userRatingDesc: "Permite a los usuarios calificar el servicio recibido",
          userRatingMessageText: "Mensaje de solicitud de calificación",
          userRatingMessageTextDesc:
            "Se envía al cerrar el ticket (junto al texto de la conexión WhatsApp si existe). Máx. 500 caracteres. Mismo criterio que el mensaje de llamadas: no puede quedar vacío al guardar.",
          userRatingMessageTextPlaceholder: "Escribe de 1 a 3 para valorar…",
          sendGreetingAcceptedMessageText: "Texto de saludo al aceptar (menú)",
          sendGreetingAcceptedMessageTextDesc:
            "Se usa como saludo del menú de opciones cuando el departamento no tiene mensaje propio. Variables Mustache: {{name}}, {{firstName}}, etc.",
          sendGreetingAcceptedMessageTextPlaceholder: "¡Hola {{name}}! Gracias por contactarnos…",
          transferTicketMessageText: "Mensaje al transferir de departamento",
          transferTicketMessageTextDesc:
            "Solo se envía si «Enviar Mensaje de Transferencia» está habilitado. Variables: {{name}}, {{firstName}} y {queueName} o {{queueName}} para el departamento destino.",
          transferTicketMessageTextPlaceholder: "¡Hola {{name}}! Has sido transferido…",
          greetingOneQueueMessageText: "Saludo con un solo departamento",
          greetingOneQueueMessageTextDesc:
            "Sustituye o complementa el saludo de la conexión cuando solo hay una fila y la opción está activa. Variables Mustache: {{name}}, {{firstName}}, etc. Si lo dejas en blanco al guardar, se restaura el texto por defecto.",
          greetingOneQueueMessageTextPlaceholder: "¡Hola {{name}}! Gracias por escribirnos…",
          scheduleType: "Tipo de Horario",
          ignoreGroupMessages: "Ignorar Mensajes de Grupo",
          acceptCall: "Aceptar Llamadas",
          sendCallAutoMessage: "Enviar Mensaje Automático para Llamadas Deshabilitadas",
          sendCallAutoMessageDesc:
            "Cuando está habilitado, se envía un mensaje automático cuando las llamadas están deshabilitadas",
          callAutoMessage: "Mensaje Automático para Llamadas",
          callAutoMessageDesc:
            "Personaliza el mensaje que se enviará automáticamente cuando las llamadas estén deshabilitadas",
          callAutoMessagePlaceholder: "Escribe el mensaje automático (máximo 500 caracteres)",
          restoreDefault: "Restaurar por Defecto",
          preview: "Vista Previa",
          chatbotType: "Tipo de Chatbot",
          sendGreetingAccepted: "Enviar Saludo al Aceptar",
          sendGreetingAcceptedDesc: "Envía saludo automático al aceptar un ticket",
          sendTransferMessage: "Enviar Mensaje de Transferencia",
          sendTransferMessageDesc: "Envía mensaje al transferir ticket entre departamentos",
          removeTagsOnCloseTicket: "Quitar etiquetas al cerrar",
          removeTagsOnCloseTicketDesc:
            "Si está habilitado, al cerrar un ticket se eliminan todas sus etiquetas y se pedirá confirmación antes de cerrar",
          sendTicketCloseMessage: "Mensaje al cerrar ticket",
          sendTicketCloseMessageDesc:
            "Envía un mensaje de WhatsApp al cliente al cerrar el ticket (no aplica a grupos). Use {nroticket} para el número de ticket",
          ticketCloseMessageText: "Texto del mensaje al cerrar",
          ticketCloseMessageTextDesc:
            "Mismo criterio que el mensaje automático de llamadas: texto obligatorio (máx. 500 caracteres), editable y con botón «Restaurar por defecto». Variable {nroticket} = ID del ticket. Se envía tras el cierre confirmado.",
          ticketCloseMessageTextPlaceholder:
            "💬⚙️ *Ticket de Atención:* {nroticket} 😀 ya fue cerrada correctamente... El bot 🤖 se volvera activar en *5 minutos*",
          sendGreetingOneQueue: "Enviar Saludo con Un Departamento",
          sendGreetingOneQueueDesc: "Envía saludo cuando hay solo una fila disponible",
          globalSettings: "Configuraciones Globales",
          registrationAllowed: "Registro Permitido",
          registrationVisible: "Registro Visible",
          trialTime: "Tiempo de Prueba",
          mainSettings: "Configuraciones Principales",
          messagingSettings: "Configuraciones de Mensajería",
          customerMessageLocale: "Idioma de mensajes automáticos al cliente (WhatsApp)",
          customerMessageLocaleDesc:
            "Idioma de saludos, transferencias, plantillas y textos automáticos que recibe el contacto por WhatsApp. Es independiente del idioma del panel de cada operador.",
          scheduleTypeDesc: "Define el tipo de horario de atención",
          ignoreGroupMessagesDesc: "Ignora mensajes de grupos de WhatsApp",
          chatbotTypeDesc: "Tipo de chatbot para respuestas automáticas",
          internalSignature: "Firmas Internas",
          internalSignatureDesc:
            "Muestra automáticamente el nombre del usuario que envía cada mensaje (solo visible internamente)",
          validateWhatsAppNumbers: "Validar Números de WhatsApp",
          validateWhatsAppNumbersDesc:
            "Al importar listas, comprueba si el número existe en WhatsApp. Los inválidos no se envían. Si WhatsApp no responde, el contacto se guarda y se intenta en la campaña.",
          timezoneForCampaigns: "Zona Horaria para Campañas",
          timezoneForCampaignsDesc: "Selecciona tu zona horaria para campañas masivas",
          timezone: "Zona Horaria",
          callAutoMessageMaxLength: "El mensaje no puede exceder 500 caracteres",
          callAutoMessageSaveError: "Error al guardar el mensaje",
          characters: "caracteres",
          registrationAllowedDesc: "Permite el registro de nuevos usuarios",
          registrationVisibleDesc: "Muestra el formulario de registro públicamente",
          trialTimeDesc: "Días de prueba para nuevos usuarios",
          day: "día",
          days: "días",
          additionalSettings: "Configuraciones Adicionales",
          hubNotificaMeToken: "Hub NotificaMe - Token Account",
          hubNotificaMeTokenDesc: "Token de 36 caracteres para integración con Hub NotificaMe",
          hubNotificaMeTokenLabel: "Token Account",
          hubNotificaMeTokenHelper: "Debe tener exactamente 36 caracteres",
          webInfo: "Info. Web",
          websiteTitle: "Título del sitio web",
          websiteTitleDesc:
            "Título que aparecerá en la pestaña del navegador y en los resultados de búsqueda",
          websiteDescription: "Descripción del sitio web",
          websiteDescriptionDesc:
            "Descripción que aparecerá en los resultados de búsqueda y redes sociales",
          websiteKeyword: "Palabra clave del sitio web",
          websiteKeywordDesc: "Palabras clave principales para SEO y posicionamiento web",
          companyName: "Nombre de la empresa",
          companyNameDesc: "Nombre de la empresa que aparecerá en el copyright del login",
          companyNameCopyright: "Nombre de la empresa (Copyright)",
          logos: "Logos",
          exampleCliqueaCRM: "Ejemplo: Cliquea CRM",
          exampleAutomatiza: "Ejemplo: Automatiza, conecta y ¡Vende más!",
          exampleWhatsAppAPI: "Ejemplo: WHATSAPP API",
          exampleWatoolx: "Ejemplo: watoolx.com",
          localeEs: "Español",
          localeEn: "English",
          localePt: "Português",
          loadingTimezones: "Cargando zonas horarias…",
          timezoneQuickPeru: "Perú (America/Lima)",
          timezoneQuickColombia: "Colombia (America/Bogota)",
          ariaSectionMain: "Configuraciones principales",
          ariaSectionMessaging: "Configuraciones de mensajería",
        },
        states: {
          disabled: "Deshabilitado",
          enabled: "Habilitado",
          activated: "Activado",
          deactivated: "Desactivado",
          accept: "Aceptar",
          notAccept: "No Aceptar",
          text: "Texto",
          updating: "Actualizando...",
          yes: "Sí",
          no: "No",
          queue: "Departamento",
          company: "Empresa",
        },
        versionPage: {
          loading: "Cargando información de versión…",
          title: "Información de versión del sistema",
          ariaVersion: "Versión",
          currentVersion: "Versión actual",
          changelogChip: "changelog {{version}}",
          releaseDateChangelog: "Fecha release (CHANGELOG):",
          changeType: "Tipo de cambio",
          gitDateChip: "Fecha vía Git",
          releaseSummary: "Resumen del último release",
          changesCount: "{{count}} cambios",
          frontendVersion: "Versión frontend",
          apiVersion: "Versión API (paquete backend)",
          baseWhaticket: "Base Whaticket:",
          lastUpdate: "Última actualización",
          semanticFooter: "Sistema de versionado semántico implementado",
          fullHistory: "Ver historial completo →",
          na: "N/D",
        },
        subscriptionsPayment: {
          title: "Métodos de pago",
          intro: "Configura las credenciales de PayPal, Stripe y Binance Pay para cobrar las suscripciones del proyecto. ",
          introNote: "Nota: Tras guardar, reinicia el servidor backend para aplicar los cambios de PayPal/Stripe.",
          saving: "Guardando…",
          sectionPaypal: "PayPal",
          sectionStripe: "Stripe",
          sectionBinance: "Binance Pay",
          sectionCurrency: "Moneda",
          sectionManual: "Pago manual",
          binanceIntro:
            "Cobro automático en USDT a tu Binance Pay. Las empresas pagan el plan con un importe exacto; el sistema confirma solo y extiende la vigencia.",
          binanceEnabled: "Estado Binance Pay",
          binanceOn: "Activado",
          binanceOff: "Desactivado",
          binanceApiKey: "API Key",
          binanceApiKeyDesc: "Binance → API Management: solo Enable Reading. Sin retiros ni trading.",
          binanceApiSecret: "API Secret",
          binanceApiSecretDesc: "Se guarda cifrado. Déjalo vacío para no cambiar el actual.",
          binanceKeySet: "Ya configurada — pega una nueva solo si la cambias",
          binancePayId: "Pay ID / Binance ID",
          binanceQrUrl: "URL del QR",
          binanceUploadQr: "Subir QR",
          binanceQrUploaded: "QR cargado",
          binanceSave: "Guardar Binance Pay",
          binanceTest: "Probar conexión",
          binanceValidated: "Última validación: {date}",
          toastBinance: "Binance Pay guardado correctamente",
          toastBinanceTest: "API Key válida (solo lectura)",
          paypalClientIdLabel: "ID de cliente PayPal",
          paypalClientIdDesc: "ID de cliente de tu aplicación PayPal",
          paypalClientIdField: "PayPal Client ID",
          paypalClientIdHelper: "Ejemplo: AQkquBDf1zctJOWLbrloE4zQnlX4rQvBfhXUZHX96zShVqSB2ikbkGg",
          paypalSecretLabel: "Secreto de cliente PayPal",
          paypalSecretDesc: "Secreto de tu aplicación PayPal",
          paypalSecretField: "PayPal Client Secret",
          paypalSecretHelper: "Secreto de tu aplicación PayPal",
          paypalModeLabel: "Modo de PayPal",
          paypalModeDesc: "Sandbox (pruebas) o live (producción)",
          modeField: "Modo",
          modeSandbox: "Sandbox (pruebas)",
          modeLive: "Live (producción)",
          stripeKeyLabel: "Clave secreta Stripe",
          stripeKeyDesc: "Clave secreta de tu cuenta Stripe (sk_test_… o sk_live_…)",
          stripeKeyField: "Stripe Secret Key",
          stripeKeyHelper: "Ejemplo: sk_test_51AbCdEf…",
          stripeWebhookLabel: "Webhook secret Stripe",
          stripeWebhookDesc: "Secreto del webhook para verificar eventos (whsec_…)",
          stripeWebhookField: "Stripe Webhook Secret",
          stripeWebhookHelper: "Ejemplo: whsec_1234567890abcdef",
          currencyLabel: "Moneda preferida",
          currencyDesc: "Moneda mostrada en planes y facturas",
          currencyField: "Moneda",
          currencyUSD: "USD — Dólar estadounidense ($)",
          currencyEUR: "EUR — Euro (€)",
          currencyGBP: "GBP — Libra esterlina (£)",
          currencyBRL: "BRL — Real brasileño (R$)",
          currencyMXN: "MXN — Peso mexicano ($)",
          currencyARS: "ARS — Peso argentino ($)",
          currencyCLP: "CLP — Peso chileno ($)",
          currencyCOP: "COP — Peso colombiano ($)",
          currencyPEN: "PEN — Sol peruano (S/)",
          toastPaypalId: "PayPal Client ID guardado correctamente",
          toastPaypalSecret: "PayPal Client Secret guardado correctamente",
          toastPaypalMode: "Modo PayPal actualizado correctamente",
          toastStripeKey: "Stripe Secret Key guardado correctamente",
          toastStripeWebhook: "Stripe Webhook Secret guardado correctamente",
          toastCurrency: "Moneda actualizada correctamente",
          manualIntro:
            "Si no hay pasarela en línea configurada, las empresas verán estos datos para coordinar el pago manual.",
          manualEmailLabel: "Correo de facturación",
          manualWhatsappLabel: "WhatsApp de facturación",
          manualInstructionsLabel: "Instrucciones para pago manual",
          manualInstructionsPlaceholder:
            "Escríbenos con el plan que deseas contratar y te enviaremos los datos de pago.",
          toastManualEmail: "Correo de pago manual guardado correctamente",
          toastManualWhatsapp: "WhatsApp de pago manual guardado correctamente",
          toastManualInstructions: "Instrucciones de pago manual guardadas correctamente",
        },
        smtpManager: {
          pageTitle: "Configuración SMTP y plantillas",
          tabSmtp: "Configuraciones SMTP",
          tabTemplates: "Plantillas de email",
          sectionTitle: "Configuraciones SMTP",
          newConfig: "Nueva configuración",
          emptyList: "No hay configuraciones SMTP. Crea una para comenzar.",
          colName: "Nombre",
          colProvider: "Proveedor",
          colHost: "Host",
          colPort: "Puerto",
          colUser: "Usuario",
          colStatus: "Estado",
          colActions: "Acciones",
          defaultChip: "Por defecto",
          statusActive: "Activo",
          statusInactive: "Inactivo",
          tooltipTest: "Probar conexión",
          tooltipEdit: "Editar",
          tooltipDelete: "Eliminar",
          dialogNew: "Nueva configuración SMTP",
          dialogEdit: "Editar configuración SMTP",
          fieldName: "Nombre",
          fieldProvider: "Proveedor",
          providerCustom: "Personalizado",
          fieldDescription: "Descripción",
          fieldHost: "Host SMTP",
          fieldPort: "Puerto",
          fieldUser: "Usuario / email",
          fieldPassword: "Contraseña",
          passwordKeepHint: "Dejar vacío para mantener la actual",
          gmailTooltipTitle: "Información para Gmail",
          gmailTooltipBody: "Para Gmail usa una contraseña de aplicación, no tu contraseña normal.",
          gmailTooltipSteps: "Pasos:",
          gmailTooltipStep1: "1. Google → Seguridad",
          gmailTooltipStep2: "2. Activa verificación en dos pasos",
          gmailTooltipStep3: "3. Busca «Contraseñas de aplicaciones»",
          gmailTooltipStep4: "4. Genera contraseña para «Correo»",
          gmailTooltipStep5: "5. Usa la contraseña de 16 caracteres aquí",
          gmailGuideLink: "Ver guía completa",
          fieldFrom: "Remitente (From)",
          sslLabel: "SSL (puerto 465)",
          tlsLabel: "Requerir TLS (puerto 587)",
          activeLabel: "Activa",
          defaultLabel: "Predeterminada",
          cancel: "Cancelar",
          save: "Guardar",
          testDialogTitle: "Probar conexión SMTP",
          testSuccess: "Conexión correcta",
          testError: "Error de conexión",
          deleteConfirm: "¿Eliminar esta configuración?",
          providerGmail: "Gmail",
          providerOutlook: "Outlook",
          fieldFromPlaceholder: "Nombre <email@dominio.com>",
          testTitleSuccess: "Prueba de conexión exitosa",
          testTitleFail: "Error en prueba de conexión",
          testTitlePending: "Probando conexión SMTP…",
          testVerifying: "Verificando conexión con el servidor SMTP…",
          alertOkTitle: "Conexión exitosa",
          alertOkBody: "La configuración SMTP se conectó correctamente con el servidor.",
          alertErrTitle: "Error de conexión",
          alertErrBody: "No se pudo establecer conexión con el servidor SMTP.",
          errorDetailsLabel: "Detalles del error:",
          close: "Cerrar",
          suggestedFixTitle: "Solución sugerida:",
          suggestedFixBody:
            "Si usas Gmail, utiliza una contraseña de aplicación en lugar de tu contraseña normal.",
        },
        vpsAlerts: {
          validation: {
            smtpSelect:
              "Configuración SMTP: elige una cuenta en el desplegable «Configuración SMTP *» (no dejes «Seleccionar SMTP…»).",
            adminEmailRequired: "Email del administrador: campo obligatorio cuando usas correo.",
            adminEmailInvalid: "Email del administrador: el formato no es válido.",
            whatsappSelect:
              "Conexión WhatsApp: elige una línea en el desplegable «Conexión WhatsApp *» (vacío impide guardar y no se envía nada al servidor).",
            adminWhatsappRequired:
              "Número de WhatsApp del administrador: campo obligatorio cuando usas WhatsApp.",
            adminWhatsappInvalid: "Número de WhatsApp: usa 10 a 15 dígitos; puedes anteponer +.",
            whatsappTemplateRequired: "Plantilla de mensaje WhatsApp: no puede estar vacía.",
          },
          validationModal: {
            bodyIntro: "No se ha enviado la petición al servidor. Completa lo siguiente:",
            titleTest: "Faltan datos para la prueba",
            titleSave: "No se puede guardar: formulario incompleto",
          },
          notes: {
            noActiveSmtpTest:
              "Nota: no hay cuentas SMTP activas. Configura una en la pestaña «SMTP».",
            noActiveSmtpSave:
              "Nota: no hay cuentas SMTP activas. Crea o activa una en la pestaña «SMTP».",
            noConnectedWhatsapp: "Nota: no hay WhatsApp en estado CONECTADO; revisa «Conexiones».",
          },
          test: {
            lineEmailOk: "✅ Email enviado exitosamente",
            lineWhatsappOk: "✅ WhatsApp enviado exitosamente",
            successIntro: "Notificación de prueba enviada exitosamente:",
            footerEmail: "Revisa tu email para confirmar la recepción.",
            footerWhatsapp: "Revisa tu WhatsApp para confirmar la recepción.",
            footerBoth: "Revisa tu email y WhatsApp para confirmar la recepción.",
            errorIntro: "Error al enviar notificación de prueba:",
            unknownError: "Error desconocido",
          },
          save: {
            notSavedTitle: "No se guardó la configuración",
            notSavedBody:
              "Revisa el mensaje de error en pantalla (si aparece) y tu conexión. Si el problema continúa, inténtalo de nuevo en unos segundos.",
            successTitle: "✅ Configuración Guardada",
            successBody: "La configuración de notificaciones VPS se ha guardado exitosamente.",
            errorTitle: "❌ Error al Guardar",
            errorBody: "Error al guardar la configuración: {{message}}",
          },
          loadError:
            "No se pudo cargar la configuración de alertas VPS: {{error}}. Comprueba que tu usuario sea administrador, que la API esté disponible y que existan los objetos de BD (VPSNotificationConfig, SP).",
          retry: "Reintentar",
          generalSection: "Habilitación General",
          toggleLabel: "Habilitar sistema de alertas y limpieza automática",
          infoWhyTitle: "¿Por qué habilitar este sistema?",
          infoIntro: "Este sistema de alertas y limpieza automática es especialmente útil si:",
          infoLi1: "Tu negocio maneja miles de mensajes WhatsApp diarios",
          infoLi2: "Generas muchos registros en la base de datos",
          infoLi3: "Necesitas monitoreo proactivo del servidor",
          infoLi4: "Quieres prevenir problemas de disco lleno",
          infoClosing:
            "Si tu negocio es pequeño y no genera muchos registros, puedes mantener este sistema deshabilitado sin problemas.",
          warningEnabled:
            "IMPORTANTE: Una vez habilitado, recibirás alertas automáticas cuando el sistema detecte problemas. Asegúrate de configurar correctamente tus credenciales de email o WhatsApp.",
          notificationsSection: "Configuración de Notificaciones",
          channelEmail: "Email",
          channelWhatsapp: "WhatsApp",
          channelBoth: "Ambos",
          emailSection: "Configuración Email",
          smtpRequiredLabel: "Configuración SMTP *",
          selectSmtp: "Seleccionar SMTP...",
          emailTemplateOptional: "Plantilla de Email (Opcional)",
          useDefaultTemplates: "Usar plantillas por defecto",
          adminEmailLabel: "Email del Administrador *",
          invalidEmail: "Formato de email inválido",
          adminEmailHint: "Email donde recibirás las alertas",
          whatsappSection: "Configuración WhatsApp",
          whatsappConnectionLabel: "Conexión WhatsApp *",
          selectWhatsapp: "Seleccionar WhatsApp...",
          whatsappTemplateLabel: "Plantilla de Mensaje WhatsApp",
          whatsappTemplateVars:
            "Variables disponibles: {alertType}, {diskUsage}, {binaryLogsSize}, {cpuUsage}, {memoryUsage}, {message}, {subject}",
          adminWhatsappLabel: "Número de WhatsApp del Administrador *",
          invalidWhatsapp: "Formato inválido (10-15 dígitos, opcionalmente precedido por +)",
          adminWhatsappHint: "Número donde recibirás las alertas (con código de país)",
          thresholdsSection: "Umbrales de Alertas",
          diskPct: "Disco (%)",
          diskHelp: "Alerta cuando el uso de disco supere este porcentaje",
          binaryGb: "Binary Logs (GB)",
          binaryHelp: "Alerta cuando el tamaño de binary logs supere este valor",
          cpuPct: "CPU (%)",
          cpuHelp: "Alerta cuando el uso de CPU supere este porcentaje",
          memPct: "Memoria (%)",
          memHelp: "Alerta cuando el uso de memoria supere este porcentaje",
          enableDisk: "Habilitar alertas de disco",
          enableBinary: "Habilitar alertas de binary logs",
          enableCpu: "Habilitar alertas de CPU",
          enableMem: "Habilitar alertas de memoria",
          enableCritical: "Habilitar alertas críticas",
          frequencySection: "Frecuencia de Notificaciones y Limpieza Automática",
          alertFreqLabel: "Frecuencia de Alertas (horas)",
          alertFreqHelp: "Cada cuántas horas se enviarán alertas automáticas (1-48 horas)",
          cleanupSubtitle: "Limpieza automática del servidor",
          cleanupInfoTitle: "Qué hace esta sección (importancia)",
          cleanupInfoIntro:
            "Con la limpieza activada, el sistema puede ejecutar acciones de mantenimiento sin intervención manual:",
          cleanupInfoLi1:
            "Si el disco supera el umbral (%): se aplica la rutina completa (purga de binary logs según política del servidor, pasos iterativos y optimización de tablas críticas cuando haga falta).",
          cleanupInfoLi2:
            "Si el disco está por debajo del umbral pero los binary logs de MySQL superan el umbral (GB): se ejecuta una purga progresiva de logs (conservadora y luego más agresiva), típica cuando el disco total es grande y el porcentaje no sube, pero los binlogs crecen mucho.",
          cleanupRisk:
            "Riesgo operativo: la purga de binary logs afecta la ventana de recuperación punto-en-tiempo (PITR). Use umbrales acordes a su política de backups y réplicas MySQL.",
          enableAutoCleanup: "Habilitar limpieza automática",
          cleanupCooldownNote:
            "Frecuencia de alertas ({{hours}} h) también limita cuánto puede repetirse la limpieza disparada solo por binary logs (GB) (cooldown desde la última ejecución de ese tipo).",
          cleanupDiskThreshold: "Umbral de disco para limpieza (%)",
          cleanupDiskHelp:
            "Si el uso de disco llega a este %, se ejecuta la rutina completa de limpieza (binlogs + pasos adicionales según BD).",
          cleanupBinlogGb: "Umbral de binary logs para limpieza (GB)",
          cleanupBinlogHelp:
            "Si el tamaño estimado de binary logs ≥ este valor y el disco NO disparó la rutina anterior, se purgan logs de forma progresiva. Suele ser menor que el umbral de solo alerta (GB).",
          lastCleanup: "Última limpieza automática por umbral de binary logs: {{date}}",
          saveConfig: "Guardar Configuración",
          saving: "Guardando...",
          sendTest: "Enviar Notificación de Prueba",
          sending: "Enviando...",
          testModal: {
            sending: "Enviando Notificación de Prueba...",
            success: "✅ Notificación Enviada",
            error: "❌ Error al Enviar",
            pleaseWait: "Por favor espera mientras se envía la notificación...",
            tipPrefix: "Tip:",
            tipEmail: "Revisa tu email para confirmar la recepción.",
            tipWhatsapp: "Revisa tu WhatsApp para confirmar la recepción.",
            tipBoth: "Revisa tu email y WhatsApp para confirmar la recepción.",
            close: "Cerrar",
            cancel: "Cancelar",
          },
          accept: "Aceptar",
          defaultWhatsAppTemplate:
            "⚠️ ALERTA VPS: {alertType}\n📊 Estado del Sistema:\n💾 Disco: {diskUsage}%\n📝 Binary Logs: {binaryLogsSize} GB\n⚡ CPU: {cpuUsage}%\n🧠 Memoria: {memoryUsage}%\n\n{message}",
        },
      },
      messagesList: {
        header: {
          assignedTo: "Asignado a:",
          buttons: {
            return: "Volver",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceptar",
          },
        },
        reactions: {
          you: "Tú",
          contact: "Contacto",
          reacted: "reaccionó",
        },
      },
      messagesInput: {
        placeholderOpen: "Escribe un mensaje",
        placeholderClosed: "Reabra o acepte este ticket para enviar un mensaje.",
        signMessage: "Firmar",
        mediaCaptionPlaceholder: "Añade un mensaje… (opcional — se envía junto al archivo)",
      },
      contactDrawer: {
        header: "Datos del contacto",
        buttons: {
          edit: "Editar contacto",
        },
        extraInfo: "Información adicional",
      },
      fileModal: {
        title: {
          add: "Agregar lista de archivos",
          edit: "Editar lista de archivos",
        },
        buttons: {
          okAdd: "Guardar",
          okEdit: "Editar",
          cancel: "Cancelar",
          fileOptions: "Agregar archivo",
        },
        form: {
          name: "Nombre de la lista de archivos",
          message: "Detalles de la lista",
          fileOptions: "Lista de archivos",
          extraName: "Mensaje para enviar con archivo",
          extraValue: "Valor de la opción",
        },
        dragDrop: {
          sectionTitle: "Lista de archivos",
          main: "Arrastra y suelta tus archivos aquí",
          sub: "o haz clic para seleccionar archivos",
          formats: "Formatos admitidos: PDF, DOC, DOCX, XLS, XLSX, CSV, JPG, PNG, MP4, MP3",
        },
        table: {
          thumbnail: "Miniatura",
          name: "Nombre",
          format: "Formato",
          size: "Peso",
          type: "Tipo",
          actions: "Acciones",
        },
        validation: {
          nameMin: "Nombre demasiado corto",
          required: "Obligatorio",
        },
        fileSize: { bytes: "Bytes", kb: "KB", mb: "MB", gb: "GB" },
        tooltips: { removeFile: "Eliminar archivo" },
        success: "Lista de archivos guardada correctamente!",
      },
      ticketOptionsMenu: {
        schedule: "Agendar",
        openInNewWindow: "Abrir conversación en popup",
        openInNewUnavailable: "Este ticket no tiene UUID; no se puede abrir en popup.",
        delete: "Eliminar",
        transfer: "Transferir",
        registerAppointment: "Observaciones del Contacto",
        appointmentsModal: {
          title: "Observaciones del Contacto",
          textarea: "Observación",
          placeholder: "Inserta aquí la información que deseas registrar",
        },
        confirmationModal: {
          title: "Eliminar el ticket",
          titleFrom: "del contacto ",
          message: "¡Atención! Todos los mensajes relacionados con el ticket se perderán.",
        },
        buttons: {
          delete: "Eliminar",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        forward: "Reenviar",
        edit: "Editar",
        react: "Reaccionar",
        reply: "Responder",
        delete: "Eliminar",
        reactionSuccess: "Reacción agregada exitosamente",
        confirmationModal: {
          title: "¿Eliminar mensaje?",
          message: "Esta acción no se puede deshacer.",
        },
        editMessageModal: {
          title: "Editar mensaje",
        },
      },
      backendErrors: {
        ERR_COMPANY_INVALID_DUE_DATE: "La fecha de vencimiento de la empresa no es válida.",
        ERR_NO_OTHER_WHATSAPP: "Debe haber al menos un WhatsApp predeterminado.",
        ERR_NO_DEF_WAPP_FOUND:
          "No se encontró ningún WhatsApp predeterminado. Comprueba la página de conexiones.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sesión de WhatsApp no se ha inicializado. Comprueba la página de conexiones.",
        ERR_WAPP_CHECK_CONTACT:
          "No se pudo verificar el contacto de WhatsApp. Comprueba la página de conexiones",
        ERR_WAPP_INVALID_CONTACT: "Este no es un número de WhatsApp válido.",
        ERR_CHECK_NUMBER_EMPTY_RESPONSE:
          "El número no está registrado en WhatsApp, pero el contacto se creó exitosamente.",
        ERR_CHECK_NUMBER:
          "El número no está registrado en WhatsApp, pero el contacto se creó exitosamente.",
        NUMBER_NOT_IN_WHATSAPP:
          "El contacto se guardó exitosamente, pero el número no está registrado en WhatsApp.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "No se pudo descargar medios de WhatsApp. Comprueba la página de conexiones.",
        ERR_INVALID_CREDENTIALS: "Error de autenticación. Por favor, inténtalo de nuevo.",
        ERR_SENDING_WAPP_MSG:
          "Error al enviar mensaje de WhatsApp. Comprueba la página de conexiones.",
        ERR_DELETE_WAPP_MSG: "No se pudo eliminar el mensaje de WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Ya hay un ticket abierto para este contacto.",
        ERR_TICKET_NEEDS_CONFIRMATION:
          "Ticket existe sin departamento. ¿Desea asignar este departamento?",
        ERR_TICKET_EXISTS_WITH_DIFFERENT_QUEUE:
          "Ya existe un ticket abierto con el departamento {{queueName}}.",
        ERR_TICKET_EXISTS_WITH_QUEUE: "Ya existe un ticket abierto con departamento asignado.",
        ERR_QUEUE_REQUIRES_WHATSAPP: "Debe seleccionar una conexión cuando asigna un departamento.",
        ERR_CONTACT_ID_REQUIRED: "Debe seleccionar un contacto para crear el ticket",
        ERR_SESSION_EXPIRED: "Sesión expirada. Por favor, inicia sesión.",
        ERR_USER_CREATION_DISABLED:
          "La creación de usuarios ha sido deshabilitada por el administrador.",
        ERR_NO_PERMISSION: "No tienes permiso para acceder a este recurso.",
        ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este número.",
        ERR_NO_SETTING_FOUND: "No se encontró ninguna configuración con esta ID.",
        ERR_NO_CONTACT_FOUND: "No se encontró ningún contacto con esta ID.",
        ERR_NO_TICKET_FOUND: "No se encontró ningún ticket con esta ID.",
        ERR_NO_USER_FOUND: "No se encontró ningún usuario con esta ID.",
        ERR_NO_WAPP_FOUND: "No se encontró ningún WhatsApp con esta ID.",
        ERR_CREATING_MESSAGE: "Error al crear mensaje en la base de datos.",
        ERR_CREATING_TICKET: "Error al crear ticket en la base de datos.",
        ERR_FETCH_WAPP_MSG: "Error al obtener mensaje de WhatsApp, puede que sea muy antiguo.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS: "Este color ya está en uso, elige otro.",
        ERR_QUEUE_NAME_ALREADY_EXISTS: "Este nombre de departamento ya existe, elige otro.",
        ERR_COMPANY_NAME_ALREADY_EXISTS:
          "Ya existe una empresa con este nombre. Por favor, elige otro nombre.",
        ERR_COMPANY_INVALID_NAME:
          "El nombre de la empresa es inválido. Debe tener entre 2 y 50 caracteres.",
        ERR_NO_PLAN_CONFIGURED:
          "No hay planes configurados en el sistema. Contacte al administrador.",
        ERR_COMPANY_CREATION_FAILED:
          "No se pudo crear la empresa. Verifique los datos o contacte al soporte.",
        ERR_PUBLIC_REGISTRATION_DISABLED:
          "El registro público de empresas está deshabilitado.",
        ERR_USER_EMAIL_ALREADY_EXISTS:
          "Ya existe un usuario con este email. Usa otro o recupera tu contraseña.",
        ERR_COMPANY_EXPIRED:
          "El periodo de prueba o el plan terminó. Elige un plan y completa el pago para volver a usar el sistema.",
        COMPANY_EXPIRED_BANNER:
          "Tu periodo de prueba o tu plan terminó. Elige un plan y completa el pago para reactivar el acceso. Las conexiones de WhatsApp y su historial se eliminan al vencer, para no seguir consumiendo recursos.",
        COMPANY_EXPIRED_MENU:
          "El resto del sistema queda restringido hasta que el plan esté al día.",
        ERR_COMPANY_INACTIVE:
          "La empresa está inactiva. Contacta a soporte.",
        ERR_COMPANY_INVALID_EMAIL: "El email de la empresa no es válido.",
        ERR_WAPP_GREETING_REQUIRED: "El saludo es obligatorio cuando hay más de un departamento.",
        // ✅ NUEVOS ERRORES DEL BACKEND
        ERR_PDF_SEND_FAILED: "No se pudo enviar el PDF, inténtalo nuevamente!",
        ERR_MESSAGE_NOT_PROCESSABLE: "Mensaje no procesable",
        ERR_UNRECOGNIZED_MESSAGE: "Mensaje no reconocido",
        ERR_TEMPORARY_MESSAGE: "Mensaje temporal",
        ERR_EPHEMERAL_MESSAGE_PROCESSING: "Error al procesar mensaje temporal",
        ERR_INTERNAL_SERVER: "Error interno del servidor. Inténtalo de nuevo o contacta a soporte.",
        ERR_DB_VALIDATION: "Los datos no cumplen las reglas de validación en base de datos.",
        ERR_TICKET_UPDATE_FAILED: "No se pudo actualizar el ticket. Inténtalo de nuevo.",
        ERR_SETTING_FOREIGN_COMPANY: "No puedes modificar la configuración de otra empresa.",
        ERR_NO_WBOT_FOR_WHATSAPP:
          "No hay sesión de WhatsApp activa para la conexión {{whatsappId}}. Revisa la página de conexiones.",
        ERR_UNKNOWN: "Ha ocurrido un error inesperado.",
      },
      welcome: {
        message: "¡Hola {name}, Bienvenido a {company}!",
        activeUntil: "Activo hasta {date}",
      },
      version: "Versión: {version}",
      logout: "Salir",
      time: {
        hoursAgo: "{hours} h atrás",
        minutesAgo: "{minutes} min atrás",
        daysAgo: "{days} días atrás",
      },
      confirmationModal: {
        buttons: {
          cancel: "Cancelar",
          confirm: "Confirmar",
        },
      },
      hardcodedElements: {
        atendimento: "Atenciones",
        tarefas: "Tareas",
        gerencia: "Gestión",
        campanhas: "Campañas",
        listagem: "Envío de mensajes",
        configuracoes: "Tiempos de Envío",
        administracao: "Administración",
        semFila: "Sin departamento",
        sair: "Salir",
        sayHelloToNewContact: "¡Hola! ¿En qué puedo ayudarte?",
        admin: "Administrador",
        filas: "Filas",
        todos: "Todos",
        hey: "hey",
      },
      financial: {
        title: "Facturación",
        pageTitle: "Facturación y suscripciones",
        tabs: {
          subscriptions: "Suscripciones",
          invoices: "Facturas",
          management: "Gestión",
        },
        table: {
          id: "ID",
          details: "Detalles",
          value: "Valor",
          dueDate: "Fecha Venc.",
          status: "Estado",
          action: "Acción",
        },
        status: {
          paid: "Pagado",
          overdue: "Vencido",
          open: "En Abierto",
        },
        buttons: {
          pay: "PAGAR",
          paid: "PAGADO",
        },
        messages: {
          noInvoices: "No hay facturas para mostrar",
          paymentSuccess: "Pago procesado exitosamente",
          paymentError: "Error al procesar el pago",
        },
        subscription: {
          currentPlanLabel: "Plan actual",
          noPlanAssigned: "Sin plan asignado",
          availablePlans: "Planes disponibles",
          availablePlansHint:
            "Selecciona un plan para suscribirte. Verás los métodos de pago disponibles (Binance Pay, PayPal, Stripe o pago manual).",
          perMonth: "/mes",
          users_one: "{{count}} usuario",
          users_other: "{{count}} usuarios",
          connections_one: "{{count}} conexión WhatsApp",
          connections_other: "{{count}} conexiones WhatsApp",
          queues_one: "{{count}} fila",
          queues_other: "{{count}} filas",
          featureCampaigns: "Campañas",
          featureSchedules: "Programación",
          featureOpenAi: "Inteligencia artificial",
          subscribe: "Suscribirse",
          processing: "Procesando...",
          noPlansTitle: "No hay planes disponibles",
          noPlansHint: "Contacta al administrador para más información",
          manualPaymentTitle: "Pago manual disponible",
          manualPaymentHint:
            "Puedes elegir un plan y contactar al administrador para coordinar el pago.",
          manualPaymentEmail: "Correo",
          binanceTitle: "Cobro Binance Pay",
          binanceExact: "Paga exactamente este importe en USDT",
          binanceHint: "El sistema revisa el pago cada minuto. También puedes pegar el Order ID.",
          binanceOrderId: "Order ID / Transaction ID",
          binanceOrderHint: "Opcional si el auto-detect no llega.",
          binanceConfirm: "Confirmar Order ID",
          binanceRefresh: "Actualizar",
          binancePaid: "Pago confirmado",
          binanceCopy: "Copiar",
          binanceCopied: "Copiado",
          binanceCopyFail: "No se pudo copiar",
          binanceStepsTitle: "Cómo pagar",
          binanceStep1: "Abre la app de Binance y entra en Pay → Enviar.",
          binanceStep2: "Envía exactamente {{amount}} USDT al Pay ID {{payId}}.",
          binanceStep3: "No redondees: los centavos identifican tu pago.",
          binanceStep4: "Listo: lo detectamos automáticamente. Si tarda, pega aquí el Order ID de Binance.",
          binanceWhatsappAlt: "¿Prefieres WhatsApp? Escribe PAGAR PLAN al",
          manualDefault: "Contacta al administrador para coordinar el pago manual de tu plan.",
          manualConfigHint: "Configura correo, WhatsApp o instrucciones desde Configuración > Suscripciones.",
          manualTitle: "Pago manual",
          pageTitle: "Suscripción",
          trialLabel: "Período de prueba",
          trialEnds: "¡Tu período de prueba termina en {{days}} días!",
          billingEmail: "Correo de facturación",
          subscribeNow: "¡Suscríbete ahora!",
          selectedPlan: "Plan seleccionado",
          value: "Valor",
          close: "Cerrar",
        },
        checkout: {
          title: "¡Ya casi!",
          steps: { data: "Datos", customize: "Personalizar", review: "Revisar" },
          back: "VOLVER",
          next: "SIGUIENTE",
          pay: "PAGAR",
          success: "¡Suscripción creada! Esperando la confirmación del pago.",
          notFound: "No encontrado",
          users: "{{count}} usuarios",
          connections: "{{count}} conexiones",
          queues: "{{count}} filas",
          select: "SELECCIONAR",
          perMonth: "/mes",
          summary: "Resumen de la suscripción",
          planDetails: "Detalles del plan",
          usersLabel: "Usuarios",
          billing: "Facturación: Mensual",
          paymentInfo: "Información de pago",
          name: "Nombre",
          address: "Dirección",
          copied: "Copiado",
          copyQr: "Copiar código QR",
          pixHint: "Para finalizar, realiza el pago escaneando o pegando el código de arriba.",
          renewed: "¡Tu licencia fue renovada hasta {{date}}!",
          addressIntro: "Necesitamos algunos datos",
          fullName: "Nombre completo*",
          fullNameRequired: "El nombre completo es obligatorio",
          street: "Dirección*",
          streetRequired: "La dirección es obligatoria",
          city: "Ciudad*",
          cityRequired: "La ciudad es obligatoria",
          state: "Departamento / Estado*",
          stateRequired: "El departamento / estado es obligatorio",
          zip: "Código postal*",
          zipRequired: "El código postal es obligatorio",
          zipInvalid: "Código postal inválido",
          country: "País*",
          countryRequired: "El país es obligatorio",
          countries: { BR: "Brasil", CO: "Colombia", US: "Estados Unidos" },
        },
      },
      kanban: {
        open: "En Abierto",
        tagNotFound: "Etiqueta no encontrada.",
        cannotMapStatus: "No se puede mapear la columna al estado de la cita.",
        appointmentUpdated: "Cita actualizada.",
        ticketMoved: "Ticket movido correctamente.",
        moveError: "Error al mover la tarjeta.",
        configureAgendaHint: "El tablero usa etiquetas Kanban. Activa Agenda en Configuración para columnas por perfil.",
      },
      // ✅ NUEVAS TRADUCCIONES PARA REPORTE DE ETIQUETAS
      tagsReport: {
        title: "ETIQUETAS POR PERIODO",
        filters: {
          start: "Inicio",
          end: "Fin",
          filter: "FILTRAR",
        },
        messages: {
          loading: "Cargando datos...",
          noData: "No hay datos de etiquetas para el período seleccionado",
          error: "Error al cargar el reporte de etiquetas",
        },
        chart: {
          yAxisTitle: "Número de Tickets",
          xAxisTitle: "Etiquetas",
          tooltip: "tickets",
        },
      },
      updateVersion: {
        title: "Actualizar Versión",
        buttons: {
          check: "Verificar",
          close: "Cerrar",
          update: "Actualizar Sistema",
        },
        status: {
          checking: "Verificando actualizaciones...",
          upToDate: "Sistema actualizado",
          updatesAvailable: "Nuevas actualizaciones disponibles",
          error: "Error al verificar actualizaciones",
          updating: "Actualización completa en progreso...",
          completed: "Actualización completada",
        },
        messages: {
          currentVersion: "Versión actual:",
          latestVersion: "Última versión disponible:",
          commitsAhead: "Hay {count} nuevos commits disponibles.",
          checkUpdates:
            "Haz clic en 'Verificar' para comprobar si hay actualizaciones disponibles.",
          updateInProgress: "Actualización en progreso...",
          updateCompleted: "Actualización completada exitosamente",
          pageWillReload: "La página se recargará automáticamente en unos segundos...",
          newVersion: "Nueva versión:",
          updateMessage: "Mensaje:",
          updateAuthor: "Autor:",
          stepsCompleted: "Pasos completados:",
          processMayTakeMinutes: "Este proceso puede tomar varios minutos...",
        },
        errors: {
          noUpdates: "No hay actualizaciones disponibles",
          updateFailed: "Error durante la actualización",
          localChanges: "Hay cambios locales sin commitear",
        },
        forceUpdate: {
          title: "Actualización Forzada",
          description: "• Ignora cambios locales no críticos (logs, builds, archivos multimedia)",
          description2: "• Útil cuando hay archivos generados automáticamente",
          description3: "• Solo usar cuando sea necesario",
          button: "Forzar Actualización Completa",
        },
      },
      // ✅ NUEVAS TRADUCCIONES PARA RECUPERACIÓN DE CONTRASEÑA
      forgetPassword: {
        title: "Recuperar Contraseña",
        form: {
          email: "Correo Electrónico",
          token: "Código de Verificación",
          newPassword: "Nueva Contraseña",
          confirmPassword: "Confirmar Contraseña",
        },
        buttons: {
          sendEmail: "ENVIAR EMAIL",
          resetPassword: "RECUPERAR CONTRASEÑA",
        },
        messages: {
          emailSent: "Email enviado con éxito!",
          passwordReset: "Contraseña recuperada exitosamente.",
          emailNotFound: "Email no encontrado",
          passwordsNotMatch: "Las contraseñas no coinciden",
          passwordRequirements:
            "Tu contraseña debe tener al menos 8 caracteres, una letra mayúscula, una minúscula y un número.",
        },
        links: {
          noAccount: "¿No tienes una cuenta? ¡Regístrate!",
        },
        validation: {
          emailRequired: "El correo electrónico es obligatorio",
          invalidEmail: "Correo electrónico inválido",
          tokenRequired: "El código de verificación es obligatorio",
          passwordRequired: "La contraseña es obligatoria",
          confirmPasswordRequired: "La confirmación de contraseña es obligatoria",
        },
      },
    },
  },
};

extendGettingStartedTranslations(messages.es.translations, "es");

export { messages };
